import React, {useState, useEffect} from 'react';
import classNames from 'classnames';
import ToolImg5700 from './assets/images/5700_sim_bg.png';
import Home from './components/home';
import Menu from './components/menu';
import MenuContext from './context/menuContext';
import {ConfigContextProvider} from './context/configContext';
import useKeyPress from './hooks/useKeyPress';
import ArrowButton from './components/arrow-button';
import Alert from './components/setAlert/alert';
import styles from './components/button/button.module.css';
import Acknowledge from './components/setAlert/acknowledge';
import Info from './components/setAlert/info';
import ShowHelp from './components/show-help';
import BatchTarget from './components/Batcher/run-batch/batch-target';
import LastBatchTime from './components/Batcher/batch-info/last-time';
import BatchTotal from './components/Batcher/run-batch/batch-total';
import BatchCount from './components/Batcher/batch-info/batch-count';
import AOCWindow from './components/Batcher/aoc-calibration/aoc-window';
import BatchInventory from './components/Batcher/batch-inventory/batch-inventory';
import ConstantBatch from './components/Batcher/constant-batch/constant-batch';
import LastBatchTotal from './components/Batcher/batch-info/last-total';
import AlertHistory from './components/Operations/alerts/alert-history';
import ProcessVariable from './components/Operations/process-variable/process-variable';
import ResetAll from './components/Operations/totalizers/reset-all';
import Stop from './components/Operations/totalizers/stop';
import Start from './components/Operations/totalizers/start';
import SeeNOC from './components/Operations/totalizers/see-NOC';
import YesterdayTotals from './components/Operations/totalizers/yesterday-total';
import CurrentTotals from './components/Operations/totalizers/current-total';
import ZeroVerification from './components/Operations/meter-zero/zero-verification';
import ZeroCalibration from './components/Operations/meter-zero/zero-calibration';
import PreviousZero from './components/Operations/meter-zero/previous-zero';
import FactoryZero from './components/Operations/meter-zero/factory-zero';
import ManualEntry from './components/Operations/meter-zero/manual';
import RunVerification from './components/Operations/smart-meter/run-verification';
import ResultDetails from './components/Operations/smart-meter/result-details';
import NextRun from './components/Operations/smart-meter/next-run';
import FirstRun from './components/Operations/smart-meter/first-run';
import Between from './components/Operations/smart-meter/between';
import FlowRange from './components/Operations/flow-range/flow-range';
import TwoPhase from './components/Operations/two-phase/two-phase';
import GasLinear from './components/Operations/gas-linear/gas-linear';
import FuelConsumption from './components/Operations/fuel-consumption/fuel';
import PrintLog from './components/Operations/printer/print-log';
import DecimalsDisplay from './components/Configuration/process-measurement/flow-variables/mass-flow/decimals-display';
import HartAddress from './components/Configuration/input-output/channel-A/hart-settings/address';
import LeftMost from './components/Configuration/input-output/channel-E/printer/ip-address/left-most';
import LeftMiddle from './components/Configuration/input-output/channel-E/printer/ip-address/left-middle';
import RightMiddle from './components/Configuration/input-output/channel-E/printer/ip-address/right-middle';
import RightMost from './components/Configuration/input-output/channel-E/printer/ip-address/right-most';
import BatchTicket from './components/Configuration/input-output/channel-E/printer/ticket-settings/batch-tickets';
import NumberTicket from './components/Configuration/input-output/channel-E/printer/ticket-settings/number-tickets';
import NumberLineFeeds1 from './components/Configuration/input-output/channel-E/printer/ticket-settings/header-line1/number-lineFeeds';
import NumberLineFeeds2 from './components/Configuration/input-output/channel-E/printer/ticket-settings/header-line2/number-lineFeeds';
import NumberLineFeeds3 from './components/Configuration/input-output/channel-E/printer/ticket-settings/header-line3/number-lineFeeds';
import NumberLineFeeds4 from './components/Configuration/input-output/channel-E/printer/ticket-settings/header-line4/number-lineFeeds';
import NumberLineFeedsFooter from './components/Configuration/input-output/channel-E/printer/ticket-settings/footer/number-lineFeeds';
import DataBits from './components/Configuration/input-output/channel-E/printer/printer-settings/data-bits';
import StopBits from './components/Configuration/input-output/channel-E/printer/printer-settings/stop-bits';
import DecimalsOnDisplay from './components/Configuration/display/decimals-display/decimals-display';
import ScrollRate from './components/Configuration/display/scroll-rate/scroll-rate';
import ScreenBrightness from './components/Configuration/display/screen-brightness/screen-brightness';
import ScreenContrast from './components/Configuration/display/screen-contrast/screen-contrast';
import LeftSensitivity from './components/Configuration/display/button-sensitivity/left-sensitivity';
import UpSensitivity from './components/Configuration/display/button-sensitivity/up-sensitivity';
import DownSensitivity from './components/Configuration/display/button-sensitivity/down-sensitivity';
import RightSensitivity from './components/Configuration/display/button-sensitivity/right-sensitivity';
import FaultTimeout from './components/Configuration/alert-setup/output-fault-actions/fault-timeout';
import LogInterval from './components/Configuration/totalizer-log/log-interval/log-interval';
import DefaultFlow from './components/Configuration/process-measurement/pressure/default-flow';
import DefaultDens from './components/Configuration/process-measurement/pressure/default-dens';
import ConfigureMatrix from './components/Configuration/process-measurement/concentration/configure-matrix';
import DifferentialZero from './components/Configuration/process-measurement/fuel-consumption/differential-zero';
import NumberStages from './components/Configuration/process-measurement/batcher/global/number-stages';
import ConfigurePreset from './components/Configuration/process-measurement/batcher/presets/presets';
import PrinterTest from './components/Configuration/input-output/channel-E/printer/printer-test/printer-test';
import GuidedConfiguration from './components/Configuration/guided-setup/guided-config';
import FlowInstallationVerification from './components/ServiceTools/verification-calibration/installation/flow-present/installation-verification';
import D1CalibrationCompleted from './components/ServiceTools/verification-calibration/density/d1/start-calibration';
import D2CalibrationCompleted from './components/ServiceTools/verification-calibration/density/d2/start-calibration';
import DiagnostiicVariable from './components/ServiceTools/service-data/diagnostic-variable';
import IOLevels from './components/ServiceTools/service-data/io-levels';
import LifetimeStats from './components/ServiceTools/service-data/lifetime';
import ConfigSummary from './components/ServiceTools/service-data/config-summary';
import MATrim4 from './components/ServiceTools/mAOuput-trim/mA-trim4';
import MATrim20 from './components/ServiceTools/mAOuput-trim/mA-trim20';
import MAInputTrim4 from './components/ServiceTools/mAInput-trim/mA-trim4';
import RebootTransmitter from './components/ServiceTools/reboot-transmitter/reboot';
import LoadLicense from './components/USB Options/USB Drive/load-license';
import NoFlowInstallationVerification from './components/ServiceTools/verification-calibration/installation/no-flow-present/installation-verification';
import DeviceInfo from './components/About/device-info';
import Versions from './components/About/versions';
import Licenses from './components/About/licenses';
import SensorInfo from './components/About/sensor-info';
import {useTranslation, withTranslation, Trans} from 'react-i18next';
import LockScreen from './components/lock-screen';
import Configuration from './components/Configuration/configuration';
import Proving from './components/Operations/proving/proving';
import ProcessMaxTN from './components/Operations/proving/process-maxTN';
import PulsesunitTN from './components/Operations/proving/pulses-unitTN';
import ZeroTime from './components/Operations/meter-zero/zero-calZeroTime';
import AbortSMV from './components/Operations/smart-meter/abort-smv';
import ThreshValueTN from './components/Configuration/process-measurement/well-performance/compensations/thresh-valueTN';
import DensOverrideTN from './components/Configuration/process-measurement/well-performance/compensations/dens-overrideTN';
import FactorOilTN from './components/Configuration/process-measurement/well-performance/compensations/factor-oilTN';
import WaterCutTN from './components/Configuration/process-measurement/well-performance/external inputs/water-cutTN';
import FlowDampingTN from './components/Configuration/process-measurement/flow-variables/flow-dampingTN';
import LowFlowTN from './components/Configuration/process-measurement/flow-variables/mass-flow/low-flowTN';
import MeterFactor from './components/Configuration/process-measurement/flow-variables/mass-flow/flow-factorTN';
import VolLowFlowTN from './components/Configuration/process-measurement/flow-variables/volume-flow/low-flowTN';
import GasDensityTN from './components/Configuration/process-measurement/flow-variables/volume-flow/gas-densityTN';
import VolMeterFactorTN from './components/Configuration/process-measurement/flow-variables/volume-flow/meter-factorTN';
import DampingTN from './components/Configuration/process-measurement/density/dampingTN';
import CutoffTN from './components/Configuration/process-measurement/density/cutoffTN';
import DensMeterFactorTN from './components/Configuration/process-measurement/density/meter-factorTN';
import FlowHighTN from './components/Configuration/process-measurement/density/flow-highTN';
import FlowLowTN from './components/Configuration/process-measurement/density/flow-lowTN';
import TimeoutTN from './components/Configuration/process-measurement/density/timeoutTN';
import TempDampingTN from './components/Configuration/process-measurement/temperature/dampingTN';
import FixedTempTN from './components/Configuration/process-measurement/temperature/fixed-tempTN';
import DevTag1TN from './components/Configuration/process-measurement/temperature/device-tag1TN';
import ReportingIntervalTN from './components/Configuration/process-measurement/adv-phase/reporting-intervalTN';
import SpecialTZTN from './components/Configuration/process-measurement/adv-phase/special-tzTN';
import ContractStartTN from './components/Configuration/process-measurement/adv-phase/contract-startTN';
import FixedPresTN from './components/Configuration/process-measurement/pressure/fixed-presTN';
import OverrideFlowTN from './components/Configuration/process-measurement/pressure/override-flowTN';
import OverrideDensTN from './components/Configuration/process-measurement/pressure/override-densTN';
import CalibrationPresTN from './components/Configuration/process-measurement/pressure/calibration-pressureTN';
import NameTN from './components/Configuration/process-measurement/totalizers-inventories/nameTN';
import ThermalExpTN from './components/Configuration/process-measurement/api-referral/thermal-expTN';
import ReferenceTempTN from './components/Configuration/process-measurement/api-referral/reference-tempTN';
import ReferencePresTN from './components/Configuration/process-measurement/api-referral/reference-presTN';
import ZeroMaxTN from './components/Configuration/process-measurement/fuel-consumption/zero-maxTN';
import ZeroMinTN from './components/Configuration/process-measurement/fuel-consumption/zero-minTN';
import FlowCutoffTN from './components/Configuration/process-measurement/fuel-consumption/flow-cutoffTN';
import DiffFlowDampingTN from './components/Configuration/process-measurement/fuel-consumption/flow-dampingTN';
import SupplyTN from './components/Configuration/process-measurement/fuel-consumption/supply-transTN';
import MaxTargetTN from './components/Configuration/process-measurement/batcher/global/max-targetTN';
import MaxFillTN from './components/Configuration/process-measurement/batcher/global/max-fillTN';
import FaultDelayTN from './components/Configuration/process-measurement/batcher/global/fault-delayTN';
import FixedValueTN from './components/Configuration/process-measurement/batcher/aoc/fixed-valueTN';
import TimeTN from './components/Configuration/time-date-tag/timeTN';
import DateTN from './components/Configuration/time-date-tag/dateTN';
import ShortTagTN from './components/Configuration/time-date-tag/short-tagTN';
import LongTagTN from './components/Configuration/time-date-tag/long-tagTN';
import MessageTN from './components/Configuration/time-date-tag/messageTN';
import RefreshRateTN from './components/Configuration/display/refresh-rate/refresh-rateTN';
import SetpointTN from './components/Configuration/alert-setup/enhanced-events/setpointTN';
import HysteresisTN from './components/Configuration/alert-setup/enhanced-events/hysteresisTN';
import SetpointATN from './components/Configuration/alert-setup/enhanced-events/setpoint-aTN';
import SetpointBTN from './components/Configuration/alert-setup/enhanced-events/setpoint-bTN';
import FCFTN from './components/Configuration/sensor-param/fcfTN';
import D1TN from './components/Configuration/sensor-param/d1TN';
import D2TN from './components/Configuration/sensor-param/d2TN';
import K1TN from './components/Configuration/sensor-param/k1TN';
import K2TN from './components/Configuration/sensor-param/k2TN';
import DTTN from './components/Configuration/sensor-param/dtTN';
import FDTN from './components/Configuration/sensor-param/fdTN';
import FTGTN from './components/Configuration/sensor-param/ftgTN';
import FFQTN from './components/Configuration/sensor-param/ffqTN';
import DTGTN from './components/Configuration/sensor-param/dtgTN';
import DFQ1TN from './components/Configuration/sensor-param/dfq1TN';
import DFQ2TN from './components/Configuration/sensor-param/dfq2TN';
import SlopeTN from './components/Configuration/sensor-param/slopeTN';
import OffsetTN from './components/Configuration/sensor-param/offsetTN';
import LoggingDateTN from './components/Configuration/totalizer-log/logging-dateTN';
import LoggingTimeTN from './components/Configuration/totalizer-log/logging-timeTN';
import MenuAvailable from './components/Configuration/security/display-security/menu-available';
import SensorSerialTN from './components/Configuration/device-info/sensor-serialTN';
import TransmitterSerialTN from './components/Configuration/device-info/transmitter-serialTN';
import CodeBaseTN from './components/Configuration/device-info/code-baseTN';
import CodeOptionsTN from './components/Configuration/device-info/code-optionsTN';
import SaveConfigTN from './components/Configuration/save-restore/save-configTN';
import SensorError from './components/setAlert/info/sensor-error';
import SensorTemp from './components/setAlert/info/sensor-temp';
import SensorCase from './components/setAlert/info/sensor-case';
import AcknowledgeAlerts from './components/setAlert/info/ack-alerts';
import D1FluidTN from './components/ServiceTools/verification-calibration/density/d1/d1-fluidTN';
import D2FluidTN from './components/ServiceTools/verification-calibration/density/d2/d2-fluidTN';
import SensorFixedValueTN from './components/ServiceTools/sensor-simulation/mass/fixed-valueTN';
import SensorMinTN from './components/ServiceTools/sensor-simulation/mass/minimumTN';
import MassMaxTN from './components/ServiceTools/sensor-simulation/mass/mass-maxTN';
import MassPeriodTN from './components/ServiceTools/sensor-simulation/mass/mass-periodTN';
import DensMaxTN from './components/ServiceTools/sensor-simulation/density/dens-maxTN';
import DensPeriodTN from './components/ServiceTools/sensor-simulation/density/dens-periodTN';
import TempMaxTN from './components/ServiceTools/sensor-simulation/temperature/temp-maxTN';
import TempPeriodTN from './components/ServiceTools/sensor-simulation/temperature/temp-periodTN';
import LicenseTN from './components/ServiceTools/license/licenseTN';
import TrialTN from './components/ServiceTools/license/trialTN';
import {findList, generateAlertsChildren} from './hooks/useCommonMenu';
import IdleTimerContainer from './components/timer/IdleTimerContainer';
import {useIdleTimer} from 'react-idle-timer';
import LoadConfig from './components/Configuration/guided-setup/load-config';
import Language from './components/Configuration/guided-setup/language';
import TimeDate from './components/Configuration/guided-setup/time-date';
import TimeZone from './components/Configuration/guided-setup/timezone';
import ConfigUnits from './components/Configuration/guided-setup/config-unit';
import MassUnit from './components/Configuration/guided-setup/mass-unit';
import VolumeUnit from './components/Configuration/guided-setup/volume-unit';
import DensityUnit from './components/Configuration/guided-setup/density-unit';
import TemperatureUnit from './components/Configuration/guided-setup/temperature-unit';
import ChannelConfig from './components/Configuration/guided-setup/channel-config';
import SensorParameters from './components/Configuration/guided-setup/sensor';
import ConfigurationSummary from './components/Configuration/guided-setup/config-summary';
import SelfTest from './components/Configuration/guided-setup/self-test';
import ChannelSelection from './components/Configuration/guided-setup/channel';
import SetModbus from './components/Configuration/guided-setup/set-modbusTN';
import SplashScreen from './assets/images/splash-screen.JPG';
import SaveConfigPB from './components/Configuration/guided-setup/save-configPB';
import ConcentrationPB from './components/Configuration/process-measurement/concentration/concentrationPB';
import {CommandsContextProvider} from './context/commandsContext';
import {ValuesContextProvider} from './context/valuesContext';
import SensorFailed from './components/setAlert/info/sensor-failed';
import TotalReset from './components/Operations/totalizers/total-reset';
import TotalFullBody from './components/Operations/totalizers/totalizers';
import TotalStop from './components/Operations/totalizers/total-stop';
import TotalStart from './components/Operations/totalizers/total-start';
import TotalPrint from './components/Operations/totalizers/total-print';
import LowerRangeTN from './components/Configuration/input-output/channel-A/io-settings/lower-rangeTN';
import UpperRangeTN from './components/Configuration/input-output/channel-A/io-settings/upper-rangeTN';
import MAOCutoffTN from './components/Configuration/input-output/channel-A/io-settings/mao-cutoffTN';
import MAODampingTN from './components/Configuration/input-output/channel-A/io-settings/mao-dampingTN';
import FaultLevelTN from './components/Configuration/input-output/channel-A/io-settings/fault-levelTN';
import LoopCurrent from './components/Configuration/input-output/channel-A/hart-settings/loop-current';
import TriggerValueTN from './components/Configuration/input-output/channel-A/hart-settings/trigger-valueTN';
import UpdatePeriodTN from './components/Configuration/input-output/channel-A/hart-settings/update-periodTN';
import MaxUpdatePeriodTN from './components/Configuration/input-output/channel-A/hart-settings/max-updateTN';
import FooterCodesTN from './components/Configuration/input-output/channel-E/printer/ticket-settings/footer-codesTN';
import TextTN from './components/Configuration/input-output/channel-E/printer/ticket-settings/textTN';
import BatchCountTN from './components/Configuration/input-output/channel-E/printer/ticket-settings/footer/batch-countTN';
import MaxCharsTN from './components/Configuration/input-output/channel-E/printer/printer-settings/max-charsTN';
import BufferTN from './components/Configuration/input-output/channel-E/printer/printer-settings/bufferTN';
import ModbusTN from './components/Configuration/input-output/channel-E/modbus/modbusTN';

const getAlerts = (id1, id2, id3) => ({
  id: id1,
  name: 'Alerts',
  children: [
    {id: id2, name: 'Alert List', isAlert: true, children: []},
    {id: id3, name: 'Alert History', component: <AlertHistory />},
  ],
});

const getSMV = (id1, id2, id3, id4, id5, id6, id7, id8, id9, id10, id11, id12, id13) => ({
  id: id1,
  name: 'Smart Meter Verification',
  children: [
    {id: id2, name: 'Run Verification', component: <RunVerification />},
    {
      id: id3,
      name: 'Read Verification History',
      children: [
        {id: id4, name: 'ISTR MV HistTime', component: <ResultDetails />},
        {id: id5, name: 'ISTR MV HistTime', component: <ResultDetails />},
        {id: id6, name: 'ISTR MV HistTime', component: <ResultDetails />},
        {id: id7, name: 'ISTR MV HistTime', component: <ResultDetails />},
        {id: id8, name: 'ISTR MV HistTime', component: <ResultDetails />},
        {id: id9, name: 'ISTR MV HistTime', component: <ResultDetails />},
      ],
    },
    {
      id: id10,
      name: 'Schedule Verification',
      children: [
        {id: id11, name: 'Hours to Next Run', component: <NextRun />},
        {id: id12, name: 'Set Hours to 1st Run', component: <FirstRun />},
        {id: id13, name: 'Set Hours Between', component: <Between />},
      ],
    },
  ],
});

const getMeterZero = (id1, id2, id3, id4, id5, id6, id7) => ({
  id: id1,
  name: 'Meter Zero',
  children: [
    {id: id2, name: 'Zero Verification', component: <ZeroVerification />},
    {id: id3, name: 'Zero Calibration', component: <ZeroCalibration />},
    {
      id: id4,
      name: 'Restore Zero',
      children: [
        {id: id5, name: 'Restore Previous Zero', component: <PreviousZero />},
        {id: id6, name: 'Restore Factory Zero', component: <FactoryZero />},
        {id: id7, name: 'Manual Entry', component: <ManualEntry />},
      ],
    },
  ],
});

const getInstallationVerification = (id1, id2, id3) => ({
  id: id1,
  name: 'Installation Verification',
  children: [
    {id: id2, name: 'Flow Present', component: <FlowInstallationVerification />},
    {id: id3, name: 'No Flow Present', component: <NoFlowInstallationVerification />},
  ],
});

const getMaOutTrim = (id1, id2, id3, id4, id5) => ({
  id: id1,
  name: 'mA Output Trim',
  children: [
    {id: id3, name: 'Milliamp Output 1', component: <MATrim4 />},
    {id: id4, name: 'Milliamp Output 2', component: <MATrim4 />},
    {id: id2, name: 'Milliamp Output', component: <MATrim4 />},
    {id: id5, name: 'Milliamp Output 3', component: <MATrim4 />},
  ],
});

const getOutputSimulation = (id1, id2, id3, id4, id5) => ({
  id: id1,
  name: 'Output Simulation',
  children: [
    {id: id2, name: 'Channel A'},
    {id: id3, name: 'Channel B'},
    {id: id4, name: 'Channel C'},
    {id: id5, name: 'Channel D'},
  ],
});

const getSensorSimulation = (
  id1,
  id2,
  id3,
  id4,
  id5,
  id6,
  id7,
  id8,
  id9,
  id10,
  id11,
  id12,
  id13,
  id14,
  id15,
  id16,
  id17,
  id18,
  id19,
  id20,
  id21,
  id22,
  id23,
  id24,
  id25,
  id26,
  id27,
  id28,
  id29,
  id30,
  id31,
) => ({
  id: id1,
  name: 'Sensor Simulation',
  children: [
    {
      id: id2,
      name: 'Simulate Sensor',
      children: [
        {id: id6, name: 'On', requireDoubleRight: true},
        {id: id7, name: 'Off', requireDoubleRight: true},
      ],
    },
    {
      id: id3,
      name: 'Mass Flow',
      children: [
        {
          id: id30,
          name: 'Wave Form',
          children: [
            {id: id12, name: 'SIM_PV_Fixed', requireDoubleRight: true},
            {id: id13, name: 'SIM_PV_Sawtooth', requireDoubleRight: true},
            {id: id14, name: 'SIM_PV_SineWave', requireDoubleRight: true},
          ],
        },
        {id: id8, name: 'Fixed Value', component: <SensorFixedValueTN />},
        {id: id9, name: 'Minimum', component: <SensorMinTN />},
        {id: id10, name: 'Maximum', component: <MassMaxTN />},
        {id: id11, name: 'Period', component: <MassPeriodTN />},
      ],
    },
    {
      id: id4,
      name: 'Density',
      children: [
        {
          id: id15,
          name: 'Wave Form',
          children: [
            {id: id16, name: 'SIM_PV_Fixed', requireDoubleRight: true},
            {id: id17, name: 'SIM_PV_Sawtooth', requireDoubleRight: true},
            {id: id18, name: 'SIM_PV_SineWave', requireDoubleRight: true},
          ],
        },
        {id: id19, name: 'Fixed Value', component: <SensorFixedValueTN />},
        {id: id20, name: 'Minimum', component: <SensorMinTN />},
        {id: id21, name: 'Maximum', component: <DensMaxTN />},
        {id: id22, name: 'Period', component: <DensPeriodTN />},
      ],
    },
    {
      id: id5,
      name: 'Temperature',
      children: [
        {
          id: id31,
          name: 'Wave Form',
          children: [
            {id: id23, name: 'SIM_PV_Fixed', requireDoubleRight: true},
            {id: id24, name: 'SIM_PV_Sawtooth', requireDoubleRight: true},
            {id: id25, name: 'SIM_PV_SineWave', requireDoubleRight: true},
          ],
        },
        {id: id26, name: 'Fixed Value', component: <SensorFixedValueTN />},
        {id: id27, name: 'Minimum', component: <SensorMinTN />},
        {id: id28, name: 'Maximum', component: <TempMaxTN />},
        {id: id29, name: 'Period', component: <TempPeriodTN />},
      ],
    },
  ],
});

const getTotalizerSetting = (
  id1,
  id2,
  id3,
  id4,
  id5,
  id6,
  id7,
  id8,
  id9,
  id10,
  id11,
  id12,
  id13,
  id14,
  id15,
  id16,
  id17,
  id18,
  id19,
  id20,
  id21,
  id22,
  id23,
  id24,
  id25,
  id26,
) => [
  {
    id: id1,
    name: 'Source',
    children: [
      {id: id4, name: 'Mass Flow Rate', requireDoubleRight: true},
      {id: id5, name: 'Volume Flow Rate', requireDoubleRight: true},
      {id: id6, name: 'Referred Volume Flow', requireDoubleRight: true},
      {id: id7, name: 'Standard Vol Flow', requireDoubleRight: true},
      {id: id8, name: 'Net Mass Flow', requireDoubleRight: true},
      {id: id9, name: 'Net Volume Flow Rate', requireDoubleRight: true},
      {id: id10, name: 'GSV Flow Rate', requireDoubleRight: true},
      {id: id11, name: 'FI Flow Rate', requireDoubleRight: true},
      {id: id12, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
      {id: id13, name: 'PV_UNREM_MASS_FLOW', requireDoubleRight: true},
      {id: id14, name: 'PV_UNREM_VOL_FLOW', requireDoubleRight: true},
      {id: id15, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
      {id: id16, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
      {id: id17, name: 'PV_NET_FLOW_WATER_AT_REF', requireDoubleRight: true},
      {id: id18, name: 'PV_NET_FLOW_WATER', requireDoubleRight: true},
      {id: id19, name: 'PV_TMR_LIQUID_FLOW', requireDoubleRight: true},
      {id: id20, name: 'PV_SF_NET_OIL_FLOW_AT_LINE', requireDoubleRight: true},
      {id: id21, name: 'PV_SF_NET_OIL_FLOW_AT_REF', requireDoubleRight: true},
      {id: id22, name: 'PV_SF_VOLUMEFLOW_AT_REF', requireDoubleRight: true},
    ],
  },
  {
    id: id2,
    name: 'Direction',
    children: [
      {id: id23, name: 'Forward', requireDoubleRight: true},
      {id: id24, name: 'Reverse', requireDoubleRight: true},
      {id: id25, name: 'Bidirectional', requireDoubleRight: true},
      {id: id26, name: 'Absolute Value', requireDoubleRight: true},
    ],
  },
  {id: id3, name: 'Name', component: <NameTN />},
];

const getAlertDetection = (id1, id2, id3) => ({
  id: id1,
  name: 'Alert Detection',
  children: [
    {id: id2, name: '0', requireDoubleRight: true},
    {id: id3, name: '1', requireDoubleRight: true},
  ],
});

const getAlertSeverity = (id4, id5, id6, id7, id8) => ({
  id: id4,
  name: 'Alert Severity',
  children: [
    {id: id5, name: 'Failure', requireDoubleRight: true},
    {id: id6, name: 'Out of Specification', requireDoubleRight: true},
    {id: id7, name: 'Maintenance Req', requireDoubleRight: true},
    {id: id8, name: 'Function Check', requireDoubleRight: true},
  ],
});

const masterList = [
  {
    id: 1,
    name: 'Alert List',
    isAlert: true,
    children: [],
  },
  {
    id: 2,
    name: 'Batcher',
    children: [
      {
        id: 21,
        name: 'Run Batch',
        children: [
          {id: 211, name: 'Batch Total', component: <BatchTotal />},
          {id: 212, name: 'Batch Target', component: <BatchTarget />},
          {
            id: 213,
            name: 'Batch Control',
            children: [
              {id: 2131, name: 'Begin', requireDoubleRight: true},
              {id: 2132, name: 'End', requireDoubleRight: true},
              {id: 2133, name: 'Pause', requireDoubleRight: true},
              {id: 2134, name: 'Resume', requireDoubleRight: true},
            ],
          },
          {id: 214, name: 'Print Batch Ticket'},
        ],
      },
      {
        id: 22,
        name: 'AOC Calibration',
        children: [
          {id: 221, name: 'AOC Cal Status'},
          {id: 222, name: 'AOC Window', component: <AOCWindow />},
        ],
      },
      {
        id: 23,
        name: 'Batch Info',
        children: [
          {id: 231, name: 'Last Batch Time', component: <LastBatchTime />},
          {id: 232, name: 'Last Batch Total', component: <LastBatchTotal />},
          {id: 233, name: 'Batch Count', component: <BatchCount />},
        ],
      },
      {
        id: 24,
        name: 'Batch Inventory',
        children: [
          {id: 241, name: 'ISTR BAT PresetN', component: <BatchInventory />},
          {id: 242, name: 'ISTR BAT PresetN', component: <BatchInventory />},
          {id: 243, name: 'ISTR BAT PresetN', component: <BatchInventory />},
          {id: 244, name: 'ISTR BAT PresetN', component: <BatchInventory />},
          {id: 245, name: 'ISTR BAT PresetN', component: <BatchInventory />},
          {id: 246, name: 'ISTR BAT PresetN', component: <BatchInventory />},
        ],
      },
      {id: 25, name: 'Constant Batch Mode', component: <ConstantBatch />},
    ],
  },
  {
    id: 3,
    name: 'Operations',
    children: [
      getAlerts(311, 312, 313),
      {id: 32, name: 'Well Performance Measure'},
      {id: 33, name: 'Process Variable Values', component: <ProcessVariable />},
      {
        id: 34,
        name: 'Totalizers',
        children: [
          {id: 341, name: 'Reset All', component: <ResetAll />},
          {id: 342, name: 'Stop', component: <Stop />},
          {id: 343, name: 'Start', component: <Start />},
          {
            id: 344,
            name: 'See Totals',
            children: [
              {
                id: 3441,
                name: 'Mass Fwd Total',
                children: [
                  {id: 34411, name: 'Mass Fwd Total', component: <TotalFullBody />},
                  {id: 34412, name: 'Clear Rollover'},
                  {id: 34413, name: 'Reset', component: <TotalReset />},
                  {id: 34414, name: 'Stop', component: <TotalStop />, component: <TotalStop />},
                  {id: 34415, name: 'Start', component: <TotalStart />, component: <TotalStart />},
                  {
                    id: 34416,
                    name: 'Print Transfer Ticket',
                    component: <TotalPrint />,
                    component: <TotalPrint />,
                  },
                ],
              },
              {
                id: 3442,
                name: 'Vol Fwd Total',
                children: [
                  {id: 34421, name: 'Vol Fwd Total', component: <TotalFullBody />},
                  {id: 34422, name: 'Clear Rollover'},
                  {id: 34423, name: 'Reset', component: <TotalReset />},
                  {id: 34424, name: 'Stop', component: <TotalStop />},
                  {id: 34425, name: 'Start', component: <TotalStart />},
                  {id: 34426, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3443,
                name: 'CorrVol Fwd Total',
                children: [
                  {id: 34431, name: 'CorrVol Fwd Total', component: <TotalFullBody />},
                  {id: 34432, name: 'Clear Rollover'},
                  {id: 34433, name: 'Reset', component: <TotalReset />},
                  {id: 34434, name: 'Stop', component: <TotalStop />},
                  {id: 34435, name: 'Start', component: <TotalStart />},
                  {id: 34436, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3444,
                name: 'GasVol Fwd Total',
                children: [
                  {id: 34441, name: 'GasVol Fwd Total', component: <TotalFullBody />},
                  {id: 34442, name: 'Clear Rollover'},
                  {id: 34443, name: 'Reset', component: <TotalReset />},
                  {id: 34444, name: 'Stop', component: <TotalStop />},
                  {id: 34445, name: 'Start', component: <TotalStart />},
                  {id: 34446, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3445,
                name: 'StdVol Fwd Total',
                children: [
                  {id: 34451, name: 'StdVol Fwd Total', component: <TotalFullBody />},
                  {id: 34452, name: 'Clear Rollover'},
                  {id: 34453, name: 'Reset', component: <TotalReset />},
                  {id: 34454, name: 'Stop', component: <TotalStop />},
                  {id: 34455, name: 'Start', component: <TotalStart />},
                  {id: 34456, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3446,
                name: 'NetMass Fwd Total',
                children: [
                  {id: 34461, name: 'NetMass Fwd Total', component: <TotalFullBody />},
                  {id: 34462, name: 'Clear Rollover'},
                  {id: 34463, name: 'Reset', component: <TotalReset />},
                  {id: 34464, name: 'Stop', component: <TotalStop />},
                  {id: 34465, name: 'Start', component: <TotalStart />},
                  {id: 34466, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3447,
                name: 'NetVol Fwd Total',
                children: [
                  {id: 34471, name: 'NetVol Fwd Total', component: <TotalFullBody />},
                  {id: 34472, name: 'Clear Rollover'},
                  {id: 34473, name: 'Reset', component: <TotalReset />},
                  {id: 34474, name: 'Stop', component: <TotalStop />},
                  {id: 34475, name: 'Start', component: <TotalStart />},
                  {id: 34476, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3448,
                name: 'Mass Fwd Inv',
                children: [
                  {id: 34481, name: 'Mass Fwd Inv', component: <TotalFullBody />},
                  {id: 34482, name: 'Clear Rollover'},
                  {id: 34483, name: 'Reset', component: <TotalReset />},
                  {id: 34484, name: 'Stop', component: <TotalStop />},
                  {id: 34485, name: 'Start', component: <TotalStart />},
                  {id: 34486, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3449,
                name: 'Vol Fwd Inv',
                children: [
                  {id: 34491, name: 'Vol Fwd Inv', component: <TotalFullBody />},
                  {id: 34492, name: 'Clear Rollover'},
                  {id: 34493, name: 'Reset', component: <TotalReset />},
                  {id: 34494, name: 'Stop', component: <TotalStop />},
                  {id: 34495, name: 'Start', component: <TotalStart />},
                  {id: 34496, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3450,
                name: 'CorrVol Fwd Inv',
                children: [
                  {id: 34501, name: 'CorrVol Fwd Inv', component: <TotalFullBody />},
                  {id: 34502, name: 'Clear Rollover'},
                  {id: 34503, name: 'Reset', component: <TotalReset />, component: <TotalReset />},
                  {id: 34504, name: 'Stop', component: <TotalStop />},
                  {id: 34505, name: 'Start', component: <TotalStart />},
                  {id: 34506, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3451,
                name: 'GasVol Fwd Inv',
                children: [
                  {id: 34511, name: 'GasVol Fwd Inv', component: <TotalFullBody />},
                  {id: 34512, name: 'Clear Rollover'},
                  {id: 34513, name: 'Reset', component: <TotalReset />},
                  {id: 34514, name: 'Stop', component: <TotalStop />},
                  {id: 34515, name: 'Start', component: <TotalStart />},
                  {id: 34516, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3452,
                name: 'StdVol Fwd Inv',
                children: [
                  {id: 34521, name: 'StdVol Fwd Inv', component: <TotalFullBody />},
                  {id: 34522, name: 'Clear Rollover'},
                  {id: 34523, name: 'Reset', component: <TotalReset />},
                  {id: 34524, name: 'Stop', component: <TotalStop />},
                  {id: 34525, name: 'Start', component: <TotalStart />},
                  {id: 34526, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3453,
                name: 'NetMass Fwd Inv',
                children: [
                  {id: 34531, name: 'NetMass Fwd Inv', component: <TotalFullBody />},
                  {id: 34532, name: 'Clear Rollover'},
                  {id: 34533, name: 'Reset', component: <TotalReset />},
                  {id: 34534, name: 'Stop', component: <TotalStop />},
                  {id: 34535, name: 'Start', component: <TotalStart />},
                  {id: 34536, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
              {
                id: 3454,
                name: 'NetVol Fwd Inv',
                children: [
                  {id: 34541, name: 'NetVol Fwd Inv', component: <TotalFullBody />},
                  {id: 34542, name: 'Clear Rollover'},
                  {id: 34543, name: 'Reset', component: <TotalReset />},
                  {id: 34544, name: 'Stop', component: <TotalStop />},
                  {id: 34545, name: 'Start', component: <TotalStart />},
                  {id: 34546, name: 'Print Transfer Ticket', component: <TotalPrint />},
                ],
              },
            ],
          },
          {id: 345, name: 'See NOC Totals', component: <SeeNOC />},
          {
            id: 346,
            name: 'See APM Totals',
            children: [
              {id: 3461, name: "Yesterday's Totals", component: <YesterdayTotals />},
              {id: 3462, name: 'Current Totals', component: <CurrentTotals />},
            ],
          },
        ],
      },
      getMeterZero(35, 351, 352, 353, 3531, 3532, 3533),
      getSMV(36, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 373),
      {id: 37, name: 'Flow Range Status', component: <FlowRange />},
      {
        id: 38,
        name: 'Proving',
        component: <Proving />,
        children: [
          {
            id: 381,
            name: 'Proving Process Var',
            children: [
              {id: 3811, name: 'Mass Flow Rate', requireDoubleRight: true},
              {id: 3812, name: 'Volume Flow Rate', requireDoubleRight: true},
              {id: 3813, name: 'GSV Flow Rate', requireDoubleRight: true},
            ],
          },
          {
            id: 382,
            name: 'Units',
            children: [
              {id: 3821, name: 'Proving Process Var', requireDoubleRight: true},
              {id: 3822, name: 'Units', requireDoubleRight: true},
              {id: 3823, name: 'Process Max Flow', requireDoubleRight: true},
              {id: 3824, name: 'Pulses/Unit', requireDoubleRight: true},
              {id: 3825, name: 'Continue Proving', requireDoubleRight: true},
              {id: 3826, name: 'Smart Meter Verification', requireDoubleRight: true},
              {id: 3827, name: 'Flow Range Status', requireDoubleRight: true},
              {id: 3828, name: 'Proving', requireDoubleRight: true},
              {id: 3829, name: 'Two Phase Flow Detection', requireDoubleRight: true},
              {id: 3830, name: 'Gas Linearization', requireDoubleRight: true},
              {id: 3831, name: 'Fuel Consumption', requireDoubleRight: true},
              {id: 3832, name: 'Printer', requireDoubleRight: true},
              {id: 3833, name: '[STR_MV_HistTime12]', requireDoubleRight: true},
              {id: 3834, name: '[STR_MV_HistTime13]', requireDoubleRight: true},
              {id: 3835, name: '[STR_MV_HistTime14]', requireDoubleRight: true},
              {id: 3836, name: '[STR_MV_HistTime15]', requireDoubleRight: true},
              {id: 3837, name: '[STR_MV_HistTime16]', requireDoubleRight: true},
              {id: 3838, name: '[STR_MV_HistTime17]', requireDoubleRight: true},
              {id: 3839, name: '[STR_MV_HistTime18]', requireDoubleRight: true},
              {id: 3840, name: '[STR_MV_HistTime19]', requireDoubleRight: true},
              {id: 3841, name: 'StdVol Fwd Tota', requireDoubleRight: true},
              {id: 3842, name: 'NetMass Fwd Total', requireDoubleRight: true},
              {id: 3843, name: 'NetVol Fwd Tota', requireDoubleRight: true},
              {id: 3844, name: 'Mass Fwd Inv', requireDoubleRight: true},
              {id: 3845, name: 'Vol Fwd Inv', requireDoubleRight: true},
              {id: 3846, name: 'CorrVol Fwd Inv', requireDoubleRight: true},
              {id: 3847, name: 'GasVol Fwd Inv', requireDoubleRight: true},
              {id: 3848, name: 'StdVol Fwd Inv', requireDoubleRight: true},
              {id: 3849, name: 'NetMass Fwd Inv', requireDoubleRight: true},
              {id: 3850, name: 'NetVol Fwd Inv', requireDoubleRight: true},
              {id: 3851, name: 'Phase', requireDoubleRight: true},
              {id: 3852, name: 'External Pressure', requireDoubleRight: true},
              {id: 3853, name: 'External Temperature', requireDoubleRight: true},
              {id: 3854, name: 'Flow Rate Switch', requireDoubleRight: true},
              {id: 3855, name: 'NetOilFlow @ Line', requireDoubleRight: true},
              {id: 3856, name: 'Watercut @ Line', requireDoubleRight: true},
              {id: 3857, name: 'External Water Cut', requireDoubleRight: true},
              {id: 3858, name: 'NetWaterFlow @ Line', requireDoubleRight: true},
              {id: 3859, name: 'NetOilFlow @ Ref', requireDoubleRight: true},
              {id: 3860, name: 'Watercut @ Ref', requireDoubleRight: true},
              {id: 3861, name: 'NetWaterFlow @ Ref', requireDoubleRight: true},
              {id: 3862, name: 'DensOil @ Line (degAPI)', requireDoubleRight: true},
              {id: 3863, name: 'Gas Void Fraction', requireDoubleRight: true},
              {id: 3864, name: 'Unremediated Mass Flow', requireDoubleRight: true},
              {id: 3865, name: 'Unremediated Vol Flow', requireDoubleRight: true},
              {id: 3866, name: 'Unremediated Density', requireDoubleRight: true},
              {id: 3867, name: 'External Density', requireDoubleRight: true},
              {id: 3868, name: 'Liquid Mass Flow', requireDoubleRight: true},
              {id: 3869, name: 'Calorific Value', requireDoubleRight: true},
              {id: 3870, name: 'Energy Flow', requireDoubleRight: true},
            ],
          },
          {id: 383, name: 'Process Max Flow', component: <ProcessMaxTN />},
          {id: 384, name: 'Pulses/Unit', component: <PulsesunitTN />},
          {id: 385, name: 'Continue Proving', component: <Proving continueProving />},
        ],
      },
      {id: 39, name: 'Two Phase Flow Detection', component: <TwoPhase />},
      {id: 40, name: 'Gas Linearization', component: <GasLinear />},
      {id: 41, name: 'Fuel Consumption', component: <FuelConsumption />},
      {
        id: 42,
        name: 'Printer',
        children: [
          {
            id: 421,
            name: 'Print Ticket',
            children: [
              {id: 4211, name: 'PRINTREQ NONE', requireDoubleRight: true},
              {id: 4212, name: 'PRINTREQ_PROCESS_MONITOR', requireDoubleRight: true},
              {id: 4213, name: 'PRINTREQ PRINT BATCH TICKET', requireDoubleRight: true},
              {id: 4214, name: 'PRINTREQ_ALL_CONFIG_DATA', requireDoubleRight: true},
              {id: 4215, name: 'PRINTREQ_ALARM_HISTORY', requireDoubleRight: true},
              {id: 4216, name: 'PRINTREQ_ACTIVE_ALARM_LOG', requireDoubleRight: true},
              {id: 4217, name: 'PRINTREQ EVENT LOG AUDIT', requireDoubleRight: true},
              {id: 4218, name: 'PRINTREQ_PRINTER_TEST', requireDoubleRight: true},
              {id: 4219, name: 'PRINTREQ_CTE_TOTALS', requireDoubleRight: true},
              {id: 4220, name: 'PRINTREQ_CTE_INVENTORIES', requireDoubleRight: true},
            ],
          },
          {
            id: 422,
            name: 'Print Transfer Log',
            children: [{id: 4221, name: 'Transfer (BOL):', component: <PrintLog />}],
          },
          {id: 423, name: 'Abort Printing'},
        ],
      },
    ],
  },
  {
    id: 5,
    name: 'Configuration',
    component: <Configuration />,
    children: [
      {
        id: 51,
        name: 'Process Measurement',
        children: [
          {
            id: 511,
            name: 'Well Performance Measure',
            children: [
              {id: 5111, name: 'Mode of Operation'},
              {
                id: 5112,
                name: 'Compensations',
                children: [
                  {
                    id: 51121,
                    name: 'DG Thresh Auto',
                    children: [
                      {id: 511211, name: '0', requireDoubleRight: true},
                      {id: 511212, name: '1', requireDoubleRight: true},
                    ],
                  },
                  {id: 51122, name: 'DG Thresh Value', component: <ThreshValueTN />},
                  {id: 51123, name: 'Dens Hold Override', component: <DensOverrideTN />},
                  {
                    id: 51124,
                    name: 'Remediation Action',
                    children: [
                      {id: 511241, name: 'HOLD_LAST_VALUE', requireDoubleRight: true},
                      {id: 511242, name: 'LINE_DENSITY', requireDoubleRight: true},
                    ],
                  },
                  {id: 51125, name: 'Factor for Oil', component: <FactorOilTN />},
                  {
                    id: 51126,
                    name: 'Contract Reset',
                    children: [
                      {id: 511261, name: 'Enabled', requireDoubleRight: true},
                      {id: 511262, name: 'Disabled', requireDoubleRight: true},
                    ],
                  },
                ],
              },
              {
                id: 5113,
                name: 'Reference Temp',
                children: [
                  {id: 51131, name: 'NOC_60F', requireDoubleRight: true},
                  {id: 51132, name: 'NOC_15C', requireDoubleRight: true},
                  {id: 51133, name: 'NOC_20C', requireDoubleRight: true},
                ],
              },
              {id: 5114, name: 'Well Data-Densities'},
              {
                id: 5115,
                name: 'External Inputs',
                children: [
                  {
                    id: 51151,
                    name: 'Water Cut Monitor',
                    children: [
                      {id: 511511, name: 'Enabled', requireDoubleRight: true},
                      {id: 511512, name: 'Disabled', requireDoubleRight: true},
                    ],
                  },
                  {id: 51152, name: 'Ext Water Cut Min', component: <WaterCutTN />},
                  {
                    id: 51153,
                    name: 'Water Cut',
                    children: [
                      {id: 511531, name: 'APM NOC', requireDoubleRight: true},
                      {id: 511532, name: 'MAI', requireDoubleRight: true},
                      {id: 511533, name: 'Polled Variable 1', requireDoubleRight: true},
                      {id: 511534, name: 'Polled Variable 2', requireDoubleRight: true},
                      {id: 511535, name: 'Modbus', requireDoubleRight: true},
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 512,
            name: 'Flow Variables',
            children: [
              {id: 5121, name: 'Flow Damping', component: <FlowDampingTN />},
              {
                id: 5122,
                name: 'Flow Direction',
                children: [
                  {id: 51221, name: 'Forward', requireDoubleRight: true},
                  {id: 51222, name: 'Reverse', requireDoubleRight: true},
                ],
              },
              {
                id: 5123,
                name: 'Mass Flow Settings',
                children: [
                  {
                    id: 51231,
                    name: 'Units',
                    children: [
                      {id: 512311, name: 'gram/s', requireDoubleRight: true},
                      {id: 512312, name: 'gram/min', requireDoubleRight: true},
                      {id: 512313, name: 'gram/h', requireDoubleRight: true},
                      {id: 512314, name: 'kg/s', requireDoubleRight: true},
                      {id: 512315, name: 'kg/min', requireDoubleRight: true},
                      {id: 512316, name: 'kg/h', requireDoubleRight: true},
                      {id: 512317, name: 'kg/d', requireDoubleRight: true},
                      {id: 512318, name: 'MetTon/min', requireDoubleRight: true},
                      {id: 512319, name: 'MetTon/h', requireDoubleRight: true},
                      {id: 512320, name: 'MetTon/d', requireDoubleRight: true},
                      {id: 512321, name: 'lb/s', requireDoubleRight: true},
                      {id: 512322, name: 'lb/min', requireDoubleRight: true},
                      {id: 512323, name: 'lb/h', requireDoubleRight: true},
                      {id: 512324, name: 'lb/d', requireDoubleRight: true},
                      {id: 512325, name: 'STon/min', requireDoubleRight: true},
                      {id: 512326, name: 'STon/h', requireDoubleRight: true},
                      {id: 512327, name: 'STon/d', requireDoubleRight: true},
                      {id: 512328, name: 'LTon/h', requireDoubleRight: true},
                      {id: 512329, name: 'LTon/d', requireDoubleRight: true},
                      {id: 512330, name: 'SPECIAL', requireDoubleRight: true},
                    ],
                  },
                  {id: 51232, name: 'Low Flow Cutoff', component: <LowFlowTN />},
                  {id: 51233, name: 'Decimals on Display', component: <DecimalsDisplay />},
                  {id: 51234, name: 'Meter Factor', component: <MeterFactor />},
                ],
              },
              {
                id: 5124,
                name: 'Volume Flow Settings',
                children: [
                  {
                    id: 51241,
                    name: 'Flow Type',
                    children: [
                      {id: 512411, name: '0', requireDoubleRight: true},
                      {id: 512412, name: '1', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 51242,
                    name: 'Units',
                    children: [
                      {id: 512421, name: 'L/s', requireDoubleRight: true},
                      {id: 512422, name: 'L/min', requireDoubleRight: true},
                      {id: 512423, name: 'L/h', requireDoubleRight: true},
                      {id: 512424, name: 'MML/d', requireDoubleRight: true},
                      {id: 512425, name: 'm3/s', requireDoubleRight: true},
                      {id: 512426, name: 'm3/min', requireDoubleRight: true},
                      {id: 512427, name: 'm3/h', requireDoubleRight: true},
                      {id: 512428, name: 'm3/d', requireDoubleRight: true},
                      {id: 512429, name: 'ft3/s', requireDoubleRight: true},
                      {id: 512430, name: 'ft3/min', requireDoubleRight: true},
                      {id: 512431, name: 'ft3/h', requireDoubleRight: true},
                      {id: 512432, name: 'ft3/d', requireDoubleRight: true},
                      {id: 512433, name: 'gal/s', requireDoubleRight: true},
                      {id: 512434, name: 'gal/min', requireDoubleRight: true},
                      {id: 512435, name: 'gal/h', requireDoubleRight: true},
                      {id: 512436, name: 'gal/d', requireDoubleRight: true},
                      {id: 512437, name: 'MMgal/d', requireDoubleRight: true},
                      {id: 512438, name: 'Impgal/s', requireDoubleRight: true},
                      {id: 512439, name: 'Impgal/min', requireDoubleRight: true},
                      {id: 512440, name: 'Impgal/h', requireDoubleRight: true},
                      {id: 512441, name: 'Impgal/d', requireDoubleRight: true},
                      {id: 512442, name: 'bbl/s', requireDoubleRight: true},
                      {id: 512443, name: 'bbl/min', requireDoubleRight: true},
                      {id: 512444, name: 'bbl/h', requireDoubleRight: true},
                      {id: 512445, name: 'bbl/d', requireDoubleRight: true},
                      {id: 512446, name: 'Beer bbl/s', requireDoubleRight: true},
                      {id: 512447, name: 'Beer bbl/min', requireDoubleRight: true},
                      {id: 512448, name: 'Beer bbl/d', requireDoubleRight: true},
                      {id: 512449, name: 'SPECIAL', requireDoubleRight: true},
                    ],
                  },
                  {id: 51243, name: 'Low Flow Cutoff', component: <VolLowFlowTN />},
                  {id: 51244, name: 'Decimals on Display', component: <DecimalsDisplay />},
                  {id: 51245, name: 'Standard Gas Density', component: <GasDensityTN />},
                  {id: 51246, name: 'Meter Factor', component: <VolMeterFactorTN />},
                ],
              },
            ],
          },
          {
            id: 513,
            name: 'Density',
            children: [
              {
                id: 5131,
                name: 'Units',
                children: [
                  {id: 51311, name: 'SGU', requireDoubleRight: true},
                  {id: 51312, name: 'g/cm3', requireDoubleRight: true},
                  {id: 51313, name: 'g/mL', requireDoubleRight: true},
                  {id: 51314, name: 'g/L', requireDoubleRight: true},
                  {id: 51315, name: 'kg/L', requireDoubleRight: true},
                  {id: 51316, name: 'kg/m3', requireDoubleRight: true},
                  {id: 51317, name: 'lb/gal', requireDoubleRight: true},
                  {id: 51318, name: 'lb/in3', requireDoubleRight: true},
                  {id: 51320, name: 'lb/ft3', requireDoubleRight: true},
                  {id: 51321, name: 'STon/yd3', requireDoubleRight: true},
                  {id: 51322, name: '°API', requireDoubleRight: true},
                ],
              },
              {id: 5132, name: 'Decimals on Display', component: <DecimalsDisplay />},
              {id: 5133, name: 'Damping', component: <DampingTN />},
              {id: 5134, name: 'Cutoff', component: <CutoffTN />},
              {id: 5135, name: 'Meter Factor', component: <DensMeterFactorTN />},
              {id: 5136, name: 'Two-Phase Flow High', component: <FlowHighTN />},
              {id: 5137, name: 'Two-Phase Flow Low', component: <FlowLowTN />},
              {id: 5138, name: 'Two-Phase Timeout', component: <TimeoutTN />},
            ],
          },
          {
            id: 514,
            name: 'Temperature',
            children: [
              {
                id: 5141,
                name: 'Units',
                children: [
                  {id: 51411, name: '°C', requireDoubleRight: true},
                  {id: 51412, name: '°F', requireDoubleRight: true},
                  {id: 51413, name: '°R', requireDoubleRight: true},
                  {id: 51414, name: 'K', requireDoubleRight: true},
                ],
              },
              {id: 5142, name: 'Decimals on Display', component: <DecimalsDisplay />},
              {id: 5143, name: 'Damping', component: <TempDampingTN />},
              {
                id: 5144,
                name: 'External Temperature',
                children: [
                  {
                    id: 51441,
                    name: 'External Temperature',
                    children: [
                      {id: 514411, name: 'On', requireDoubleRight: true},
                      {id: 514412, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                  {id: 51442, name: 'Fixed Temperature', component: <FixedTempTN />},
                  {
                    id: 51443,
                    name: 'Poll External Device',
                    children: [
                      {
                        id: 514431,
                        name: 'Polled Variable 1',
                        children: [
                          {
                            id: 5144311,
                            name: 'Variable',
                            children: [
                              {id: 51443111, name: 'None', requireDoubleRight: true},
                              {
                                id: 51443112,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 51443113, name: 'External Pressure', requireDoubleRight: true},
                              {id: 51443114, name: 'External Density', requireDoubleRight: true},
                              {id: 51443115, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                              {id: 51443116, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 51443117,
                                name: 'PV_DEN_CALORIFIC_VALUE',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5144312,
                            name: 'Polling Control',
                            children: [
                              {id: 51443121, name: 'POLL_NONE', requireDoubleRight: true},
                              {id: 51443122, name: 'POLL_PRIMARY', requireDoubleRight: true},
                              {id: 51443123, name: 'POLL_SECONDARY', requireDoubleRight: true},
                            ],
                          },
                          {id: 5144313, name: 'External Device Tag', component: <DevTag1TN />},
                        ],
                      },
                      {
                        id: 514432,
                        name: 'Polled Variable 2',
                        children: [
                          {
                            id: 5144321,
                            name: 'Variable',
                            children: [
                              {id: 51443211, name: 'None', requireDoubleRight: true},
                              {
                                id: 51443212,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 51443213, name: 'External Pressure', requireDoubleRight: true},
                              {id: 51443214, name: 'External Density', requireDoubleRight: true},
                              {id: 51443215, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                              {id: 51443216, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 51443217,
                                name: 'PV_DEN_CALORIFIC_VALUE',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5144322,
                            name: 'Polling Control',
                            children: [
                              {id: 51443221, name: 'POLL_NONE', requireDoubleRight: true},
                              {id: 51443222, name: 'POLL_PRIMARY', requireDoubleRight: true},
                              {id: 51443223, name: 'POLL_SECONDARY', requireDoubleRight: true},
                            ],
                          },
                          {id: 5144323, name: 'External Device Tag', component: <DevTag1TN />},
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 515,
            name: 'Adv Phase Measurement',
            children: [
              {
                id: 5151,
                name: 'Application Setup',
                children: [
                  {id: 51511, name: 'Disabled', requireDoubleRight: true},
                  {id: 51512, name: 'Net Oil (NOC)', requireDoubleRight: true},
                  {id: 51513, name: 'Gas with Liquid', requireDoubleRight: true},
                  {id: 51514, name: 'Single Liquid', requireDoubleRight: true},
                ],
              },
              {id: 5152, name: 'Reporting Interval', component: <ReportingIntervalTN />},
              {
                id: 5153,
                name: 'Contract Period',
                children: [
                  {
                    id: 51531,
                    name: 'Time Zone',
                    children: [
                      {
                        id: 515311,
                        name: 'Time Zone',
                        children: [
                          {id: 5153111, name: 'TZ_dateLine', requireDoubleRight: true},
                          {id: 5153112, name: 'TZ_samoa', requireDoubleRight: true},
                          {id: 5153113, name: 'TZ_hawaii', requireDoubleRight: true},
                          {id: 5153114, name: 'TZ_alaska', requireDoubleRight: true},
                          {id: 5153115, name: 'TZ_pacific', requireDoubleRight: true},
                          {id: 5153116, name: 'TZ_mountain', requireDoubleRight: true},
                          {id: 5153117, name: 'TZ_central', requireDoubleRight: true},
                          {id: 5153118, name: 'TZ_eastern', requireDoubleRight: true},
                          {id: 5153119, name: 'TZ_atlantic', requireDoubleRight: true},
                          {id: 5153121, name: 'TZ_newfoundLand', requireDoubleRight: true},
                          {id: 5153122, name: 'TZ_saEastern', requireDoubleRight: true},
                          {id: 5153123, name: 'TZ_midAtlantic', requireDoubleRight: true},
                          {id: 5153124, name: 'TZ_azores', requireDoubleRight: true},
                          {id: 5153125, name: 'TZ_greenwich', requireDoubleRight: true},
                          {id: 5153126, name: 'TZ_centralEU', requireDoubleRight: true},
                          {id: 5153127, name: 'TZ_europe', requireDoubleRight: true},
                          {id: 5153128, name: 'TZ_russian', requireDoubleRight: true},
                          {id: 5153129, name: 'TZ_iran', requireDoubleRight: true},
                          {id: 5153130, name: 'TZ_arabian', requireDoubleRight: true},
                          {id: 5153131, name: 'TZ_afghan', requireDoubleRight: true},
                          {id: 5153132, name: 'TZ_westAsia', requireDoubleRight: true},
                          {id: 5153133, name: 'TZ_india', requireDoubleRight: true},
                          {id: 5153134, name: 'TZ_nepal', requireDoubleRight: true},
                          {id: 5153135, name: 'TZ_centralAsia', requireDoubleRight: true},
                          {id: 5153136, name: 'TZ_myanmar', requireDoubleRight: true},
                          {id: 5153137, name: 'TZ_seAsia', requireDoubleRight: true},
                          {id: 5153138, name: 'TZ_china', requireDoubleRight: true},
                          {id: 5153139, name: 'TZ_korea', requireDoubleRight: true},
                          {id: 5153140, name: 'TZ_centralAustralia', requireDoubleRight: true},
                          {id: 5153141, name: 'TZ_eastAustralia', requireDoubleRight: true},
                          {id: 5153142, name: 'TZ_centralPacific', requireDoubleRight: true},
                          {id: 5153143, name: 'TZ_fiji', requireDoubleRight: true},
                          {id: 5153144, name: 'TZ_tonga', requireDoubleRight: true},
                        ],
                      },
                      {id: 515312, name: 'Special Time Zone', component: <SpecialTZTN />},
                    ],
                  },
                  {id: 51532, name: 'Contract Start Hour', component: <ContractStartTN />},
                ],
              },
            ],
          },
          {
            id: 516,
            name: 'Pressure',
            children: [
              {
                id: 5161,
                name: 'Units',
                children: [
                  {id: 51611, name: 'psi', requireDoubleRight: true},
                  {id: 51612, name: 'mbar', requireDoubleRight: true},
                  {id: 51613, name: 'bar', requireDoubleRight: true},
                  {id: 51614, name: 'atm', requireDoubleRight: true},
                  {id: 51615, name: 'Pa', requireDoubleRight: true},
                  {id: 51616, name: 'kPA', requireDoubleRight: true},
                  {id: 51617, name: 'inH20 @4C', requireDoubleRight: true},
                  {id: 51618, name: 'inH20 @60F', requireDoubleRight: true},
                  {id: 51619, name: 'inH20 @68F', requireDoubleRight: true},
                  {id: 51620, name: 'ftH20 @68F', requireDoubleRight: true},
                  {id: 51621, name: 'mmH20 @68°F', requireDoubleRight: true},
                  {id: 51622, name: 'mmHg @0°C', requireDoubleRight: true},
                  {id: 51623, name: 'inHg @0C', requireDoubleRight: true},
                  {id: 51624, name: 'g/cm2', requireDoubleRight: true},
                  {id: 51625, name: 'kg/cm2', requireDoubleRight: true},
                  {id: 51626, name: 'torr', requireDoubleRight: true},
                  {id: 51627, name: 'MPa', requireDoubleRight: true},
                  {id: 51628, name: 'mmH2O @4°C', requireDoubleRight: true},
                ],
              },
              {id: 5162, name: 'Default Flow Factor', component: <DefaultFlow />},
              {id: 5163, name: 'Override Flow Factor', component: <OverrideFlowTN />},
              {id: 5164, name: 'Default Dens Factor', component: <DefaultDens />},
              {id: 5165, name: 'Override Dens Factor', component: <OverrideDensTN />},
              {id: 5166, name: 'Calibration Pressure', component: <CalibrationPresTN />},
              {
                id: 5167,
                name: 'External Pressure',
                children: [
                  {
                    id: 51671,
                    name: 'External Pressure',
                    children: [
                      {id: 516711, name: 'On', requireDoubleRight: true},
                      {id: 516712, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                  {id: 51672, name: 'Fixed Pressure', component: <FixedPresTN />},
                  {
                    id: 51673,
                    name: 'Poll External Device',
                    children: [
                      {
                        id: 516732,
                        name: 'Polled Variable 1',
                        children: [
                          {
                            id: 5167321,
                            name: 'Variable',
                            children: [
                              {id: 51673211, name: 'None', requireDoubleRight: true},
                              {
                                id: 51673212,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 51673213, name: 'External Pressure', requireDoubleRight: true},
                              {id: 51673214, name: 'External Density', requireDoubleRight: true},
                              {id: 51673215, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                              {id: 51673216, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 51673217,
                                name: 'PV_DEN_CALORIFIC_VALUE',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5167322,
                            name: 'Polling Control',
                            children: [
                              {id: 51673221, name: 'POLL_NONE', requireDoubleRight: true},
                              {id: 51673222, name: 'POLL_PRIMARY', requireDoubleRight: true},
                              {id: 51673223, name: 'POLL_SECONDARY', requireDoubleRight: true},
                            ],
                          },
                          {id: 5167323, name: 'External Device Tag', component: <DevTag1TN />},
                        ],
                      },
                      {
                        id: 516733,
                        name: 'Polled Variable 2',
                        children: [
                          {
                            id: 5167331,
                            name: 'Variable',
                            children: [
                              {id: 51673311, name: 'None', requireDoubleRight: true},
                              {
                                id: 51673312,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 51673313, name: 'External Pressure', requireDoubleRight: true},
                              {id: 51673314, name: 'External Density', requireDoubleRight: true},
                              {id: 51673315, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                              {id: 51673316, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 51673317,
                                name: 'PV_DEN_CALORIFIC_VALUE',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5167332,
                            name: 'Polling Control',
                            children: [
                              {id: 51673321, name: 'POLL_NONE', requireDoubleRight: true},
                              {id: 51673322, name: 'POLL_PRIMARY', requireDoubleRight: true},
                              {id: 51673323, name: 'POLL_SECONDARY', requireDoubleRight: true},
                            ],
                          },
                          {id: 5167333, name: 'External Device Tag', component: <DevTag1TN />},
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 517,
            name: 'Totalizers & Inventories',
            children: [
              {
                id: 5171,
                name: 'Mass Fwd Total',
                children: getTotalizerSetting(
                  51711,
                  51712,
                  51713,
                  51714,
                  51715,
                  51716,
                  51717,
                  51718,
                  51719,
                  51720,
                  51721,
                  51722,
                  51723,
                  51724,
                  51725,
                  51726,
                  51727,
                  51728,
                  51729,
                  51730,
                  51731,
                  51732,
                  51733,
                  51734,
                  51735,
                  51736,
                ),
              },
              {
                id: 5172,
                name: 'Vol Fwd Total',
                children: getTotalizerSetting(
                  517111,
                  517112,
                  517113,
                  517114,
                  517115,
                  517116,
                  517117,
                  517118,
                  517119,
                  517210,
                  517211,
                  517212,
                  517213,
                  517214,
                  517215,
                  517216,
                  517217,
                  517218,
                  517219,
                  517310,
                  517311,
                  517312,
                  517313,
                  517314,
                  517315,
                  517316,
                ),
              },
              {
                id: 5173,
                name: 'CorrVol Fwd Total',
                children: getTotalizerSetting(
                  517121,
                  517122,
                  517123,
                  517124,
                  517125,
                  517126,
                  517127,
                  517128,
                  517129,
                  517220,
                  517221,
                  517222,
                  517223,
                  517224,
                  517225,
                  517226,
                  517227,
                  517228,
                  517229,
                  517320,
                  517321,
                  517322,
                  517323,
                  517324,
                  517325,
                  517326,
                ),
              },
              {
                id: 5174,
                name: 'GasVol Fwd Total',
                children: getTotalizerSetting(
                  517131,
                  517132,
                  517133,
                  517134,
                  517135,
                  517136,
                  517137,
                  517138,
                  517139,
                  517230,
                  517231,
                  517232,
                  517233,
                  517234,
                  517235,
                  517236,
                  517237,
                  517238,
                  517239,
                  517330,
                  517331,
                  517332,
                  517333,
                  517334,
                  517335,
                  517336,
                ),
              },
              {
                id: 5175,
                name: 'StdVol Fwd Total',
                children: getTotalizerSetting(
                  517141,
                  517142,
                  517143,
                  517144,
                  517145,
                  517146,
                  517147,
                  517148,
                  517149,
                  517240,
                  517241,
                  517242,
                  517243,
                  517244,
                  517245,
                  517246,
                  517247,
                  517248,
                  517249,
                  517340,
                  517341,
                  517342,
                  517343,
                  517344,
                  517345,
                  517346,
                ),
              },
              {
                id: 5176,
                name: 'NetMass Fwd Total',
                children: getTotalizerSetting(
                  517151,
                  517152,
                  517153,
                  517154,
                  517155,
                  517156,
                  517157,
                  517158,
                  517159,
                  517250,
                  517251,
                  517252,
                  517253,
                  517254,
                  517255,
                  517256,
                  517257,
                  517258,
                  517259,
                  517350,
                  517351,
                  517352,
                  517353,
                  517354,
                  517355,
                  517356,
                ),
              },
              {
                id: 5177,
                name: 'NetVol Fwd Total',
                children: getTotalizerSetting(
                  517161,
                  517162,
                  517163,
                  517164,
                  517165,
                  517166,
                  517167,
                  517168,
                  517169,
                  517260,
                  517261,
                  517262,
                  517263,
                  517264,
                  517265,
                  517266,
                  517267,
                  517268,
                  517269,
                  517360,
                  517361,
                  517362,
                  517363,
                  517364,
                  517365,
                  517366,
                ),
              },
              {
                id: 5178,
                name: 'Mass Fwd Inv',
                children: getTotalizerSetting(
                  517171,
                  517172,
                  517173,
                  517174,
                  517175,
                  517176,
                  517177,
                  517178,
                  517179,
                  517270,
                  517271,
                  517272,
                  517273,
                  517274,
                  517275,
                  517276,
                  517277,
                  517278,
                  517279,
                  517370,
                  517371,
                  517372,
                  517373,
                  517374,
                  517375,
                  517376,
                ),
              },
              {
                id: 5179,
                name: 'Vol Fwd Inv',
                children: getTotalizerSetting(
                  517181,
                  517182,
                  517183,
                  517184,
                  517185,
                  517186,
                  517187,
                  517188,
                  517189,
                  517280,
                  517281,
                  517282,
                  517283,
                  517284,
                  517285,
                  517286,
                  517287,
                  517288,
                  517289,
                  517380,
                  517381,
                  517382,
                  517383,
                  517384,
                  517385,
                  517386,
                ),
              },
              {
                id: 5180,
                name: 'CorrVol Fwd Inv',
                children: getTotalizerSetting(
                  517191,
                  517192,
                  517193,
                  517194,
                  517195,
                  517196,
                  517197,
                  517198,
                  517199,
                  517290,
                  517291,
                  517292,
                  517293,
                  517294,
                  517295,
                  517296,
                  517297,
                  517298,
                  517299,
                  517390,
                  517391,
                  517392,
                  517393,
                  517394,
                  517395,
                  517396,
                ),
              },
              {
                id: 5181,
                name: 'GasVol Fwd Inv',
                children: getTotalizerSetting(
                  511711,
                  511712,
                  511713,
                  511714,
                  511715,
                  511716,
                  511717,
                  511718,
                  511719,
                  511720,
                  511721,
                  511722,
                  511723,
                  511724,
                  511725,
                  511726,
                  511727,
                  511728,
                  511729,
                  511730,
                  511731,
                  511732,
                  511733,
                  511734,
                  511735,
                  511736,
                ),
              },
              {
                id: 5182,
                name: 'StdVol Fwd Inv',
                children: getTotalizerSetting(
                  512711,
                  512712,
                  512713,
                  512714,
                  512715,
                  512716,
                  512717,
                  512718,
                  512719,
                  512720,
                  512721,
                  512722,
                  512723,
                  512724,
                  512725,
                  512726,
                  512727,
                  512728,
                  512729,
                  512730,
                  512731,
                  512732,
                  512733,
                  512734,
                  512735,
                  512736,
                ),
              },
              {
                id: 5183,
                name: 'NetMass Fwd Inv',
                children: getTotalizerSetting(
                  513711,
                  513712,
                  513713,
                  513714,
                  513715,
                  513716,
                  513717,
                  513718,
                  513719,
                  513720,
                  513721,
                  513722,
                  513723,
                  513724,
                  513725,
                  513726,
                  513727,
                  513728,
                  513729,
                  513730,
                  513731,
                  513732,
                  513733,
                  513734,
                  513735,
                  513736,
                ),
              },
              {
                id: 5184,
                name: 'NetVol Fwd Inv',
                children: getTotalizerSetting(
                  514711,
                  514712,
                  514713,
                  514714,
                  514715,
                  514716,
                  514717,
                  514718,
                  514719,
                  514720,
                  514721,
                  514722,
                  514723,
                  514724,
                  514725,
                  514726,
                  514727,
                  514728,
                  514729,
                  514730,
                  514731,
                  514732,
                  514733,
                  514734,
                  514735,
                  514736,
                ),
              },
            ],
          },
          {
            id: 518,
            name: 'Velocity',
            children: [
              {
                id: 51811,
                name: 'Units',
                children: [
                  {id: 518111, name: 'm/s', requireDoubleRight: true},
                  {id: 518112, name: 'm/h', requireDoubleRight: true},
                  {id: 518113, name: 'in/s', requireDoubleRight: true},
                  {id: 518114, name: 'in/min', requireDoubleRight: true},
                  {id: 518115, name: 'ft/s', requireDoubleRight: true},
                  {id: 518116, name: 'ft/min', requireDoubleRight: true},
                ],
              },
              {id: 51812, name: 'Decimals on Display', component: <DecimalsDisplay />},
            ],
          },
          {
            id: 519,
            name: 'Response Time',
            children: [
              {id: 5191, name: 'Normal (Default)', requireDoubleRight: true},
              {id: 5192, name: 'Fast (Proving)', requireDoubleRight: true},
              {id: 5193, name: 'Smooth (Gas)', requireDoubleRight: true},
            ],
          },
          {
            id: 520,
            name: 'API Referral',
            children: [
              {
                id: 5201,
                name: 'Enable/Disable',
                children: [
                  {id: 52011, name: 'Enabled', requireDoubleRight: true},
                  {id: 52012, name: 'Disabled', requireDoubleRight: true},
                ],
              },
              {
                id: 5202,
                name: 'API Table',
                children: [
                  {id: 52021, name: 'API_TABLE_5A', requireDoubleRight: true},
                  {id: 52022, name: 'API_TABLE_23A', requireDoubleRight: true},
                  {id: 52023, name: 'API_TABLE_53A', requireDoubleRight: true},
                  {id: 52024, name: 'API_TABLE_5B', requireDoubleRight: true},
                  {id: 52025, name: 'API_TABLE_23B', requireDoubleRight: true},
                  {id: 52026, name: 'API_TABLE_53B', requireDoubleRight: true},
                  {id: 52027, name: 'API_TABLE_6C', requireDoubleRight: true},
                  {id: 52028, name: 'API_TABLE_24C', requireDoubleRight: true},
                  {id: 52029, name: 'API_TABLE_54C', requireDoubleRight: true},
                  {id: 52030, name: 'API_TABLE_5D', requireDoubleRight: true},
                  {id: 52031, name: 'API_TABLE_23D', requireDoubleRight: true},
                  {id: 52032, name: 'API_TABLE_53D', requireDoubleRight: true},
                  {id: 52033, name: 'API_TABLE_23E', requireDoubleRight: true},
                  {id: 52034, name: 'API_TABLE_24E', requireDoubleRight: true},
                  {id: 52035, name: 'API_TABLE_53E', requireDoubleRight: true},
                  {id: 52036, name: 'API_TABLE_54E', requireDoubleRight: true},
                  {id: 52037, name: 'API_TABLE_59A', requireDoubleRight: true},
                  {id: 52038, name: 'API_TABLE_59B', requireDoubleRight: true},
                  {id: 52039, name: 'API_TABLE_59D', requireDoubleRight: true},
                  {id: 52040, name: 'API_TABLE_59E', requireDoubleRight: true},
                  {id: 52041, name: 'API_TABLE_60A', requireDoubleRight: true},
                  {id: 52042, name: 'API_TABLE_60B', requireDoubleRight: true},
                  {id: 52043, name: 'API_TABLE_60D', requireDoubleRight: true},
                  {id: 52044, name: 'API_TABLE_60E', requireDoubleRight: true},
                ],
              },
              {id: 5203, name: 'Thermal Exp Coeff', component: <ThermalExpTN />},
              {id: 5204, name: 'Reference Temp', component: <ReferenceTempTN />},
              {
                id: 5205,
                name: 'Pressure Comp.',
                children: [
                  {id: 52051, name: 'On', requireDoubleRight: true},
                  {id: 52052, name: 'Off', requireDoubleRight: true},
                ],
              },
              {id: 5206, name: 'Reference Pressure', component: <ReferencePresTN />},
            ],
          },
          {
            id: 521,
            name: 'Concentration Measurement',
            children: [
              {
                id: 5211,
                name: 'Enable/Disable',
                children: [
                  {id: 52111, name: 'Enabled', requireDoubleRight: true},
                  {id: 52112, name: 'Disabled', requireDoubleRight: true},
                ],
              },
              {
                id: 5212,
                name: 'Configure Application',
                children: [
                  {
                    id: 52121,
                    name: 'Derived Variable',
                    children: [
                      {id: 521211, name: 'ED_Mode_DensAtRef', requireDoubleRight: true},
                      {id: 521212, name: 'ED_Mode_SG', requireDoubleRight: true},
                      {id: 521213, name: 'ED_Mode_MassConcDens', requireDoubleRight: true},
                      {id: 521214, name: 'ED_Mode_MassConcSG', requireDoubleRight: true},
                      {id: 521215, name: 'ED_Mode_VolConcDens', requireDoubleRight: true},
                      {id: 521216, name: 'ED_Mode_VolConcSG', requireDoubleRight: true},
                      {id: 521217, name: 'ED_Mode_ConcDens', requireDoubleRight: true},
                      {id: 521218, name: 'ED_Mode_ConcSG', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 52122,
                    name: 'Active Matrix',
                    children: [
                      {id: 521221, name: '[STR_CM_CurveName1]'},
                      {id: 521222, name: '[STR_CM_CurveName2]'},
                      {id: 521223, name: '[STR_CM_CurveName3]'},
                      {id: 521224, name: '[STR_CM_CurveName4]'},
                      {id: 521225, name: '[STR_CM_CurveName5]'},
                      {id: 521226, name: '[STR_CM_CurveName6]'},
                    ],
                  },
                  {
                    id: 52123,
                    name: 'Extrapolation Alerts',
                    children: [
                      {
                        id: 521231,
                        name: 'Low Limit (Density)',
                        children: [
                          {id: 5212311, name: 'On', requireDoubleRight: true},
                          {id: 5212312, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 521232,
                        name: 'High Limit (Density)',
                        children: [
                          {id: 5212321, name: 'On', requireDoubleRight: true},
                          {id: 5212322, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 521233,
                        name: 'Low Limit (Temp)',
                        children: [
                          {id: 5212331, name: 'On', requireDoubleRight: true},
                          {id: 5212332, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 521234,
                        name: 'High Limit (Temp)',
                        children: [
                          {id: 5212341, name: 'On', requireDoubleRight: true},
                          {id: 5212342, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5213,
                name: 'Configure Matrix',
                children: [
                  {id: 52131, name: '[STR_CM_CurveName1]', component: <ConfigureMatrix />},
                  {id: 52132, name: '[STR_CM_CurveName2]', component: <ConfigureMatrix />},
                  {id: 52133, name: '[STR_CM_CurveName3]', component: <ConfigureMatrix />},
                  {id: 52134, name: '[STR_CM_CurveName4]', component: <ConfigureMatrix />},
                  {id: 52135, name: '[STR_CM_CurveName5]', component: <ConfigureMatrix />},
                ],
              },
              {id: 5214, name: 'Load Matrix'},
              {
                id: 5215,
                name: 'Save Matrix',
                children: [
                  {id: 52151, name: '[STR_CM_CurveName1]', component: <ConcentrationPB />},
                  {id: 52152, name: '[STR_CM_CurveName2]', component: <ConcentrationPB />},
                  {id: 52153, name: '[STR_CM_CurveName3]', component: <ConcentrationPB />},
                  {id: 52154, name: '[STR_CM_CurveName4]', component: <ConcentrationPB />},
                  {id: 52155, name: '[STR_CM_CurveName5]', component: <ConcentrationPB />},
                  {id: 52156, name: '[STR_CM_CurveName6]', component: <ConcentrationPB />},
                ],
              },
            ],
          },
          {
            id: 522,
            name: 'Fuel Consumption',
            children: [
              {id: 5221, name: 'Sensor Model'},
              {
                id: 5222,
                name: 'Enable/Disable',
                children: [
                  {id: 52221, name: 'Enabled', requireDoubleRight: true},
                  {id: 52222, name: 'Disabled', requireDoubleRight: true},
                ],
              },
              {id: 5223, name: 'Differential Zero', component: <DifferentialZero />},
              {id: 5224, name: 'Diff. Zero Max', component: <ZeroMaxTN />},
              {id: 5225, name: 'Diff. Zero Min', component: <ZeroMinTN />},
              {id: 5226, name: 'Diff. Flow Cutoff', component: <FlowCutoffTN />},
              {id: 5227, name: 'Diff. Flow Damping', component: <DiffFlowDampingTN />},
              {id: 5228, name: 'SUPPLY Transmitter', component: <SupplyTN />},
            ],
          },
          {
            id: 523,
            name: 'Batcher',
            children: [
              {
                id: 5231,
                name: 'Global',
                children: [
                  {
                    id: 52311,
                    name: 'Batch Variable',
                    children: [
                      {id: 523111, name: 'Mass Flow Rate', requireDoubleRight: true},
                      {id: 523112, name: 'Volume Flow Rate', requireDoubleRight: true},
                      {id: 523113, name: 'GSV Flow Rate', requireDoubleRight: true},
                      {id: 523114, name: 'Referred Volume Flow', requireDoubleRight: true},
                      {id: 523115, name: 'Net Mass Flow', requireDoubleRight: true},
                      {id: 523116, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                      {id: 523117, name: 'Standard Vol Flow', requireDoubleRight: true},
                      {id: 523118, name: 'FI Flow Rate', requireDoubleRight: true},
                    ],
                  },
                  {id: 52312, name: 'Max Target', component: <MaxTargetTN />},
                  {id: 52313, name: 'Max Fill Time', component: <MaxFillTN />},
                  {id: 52314, name: 'Decimals on Display', component: <DecimalsDisplay />},
                  {id: 52315, name: 'Number of Stages', component: <NumberStages />},
                  {
                    id: 52316,
                    name: 'Configure Presets by',
                    children: [
                      {id: 523161, name: 'BAT_BYPERCENT', requireDoubleRight: true},
                      {id: 523162, name: 'BAT_BYQUANTITY', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 52317,
                    name: 'Reset On Start',
                    children: [
                      {id: 523171, name: 'Yes', requireDoubleRight: true},
                      {id: 523172, name: 'No', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 52318,
                    name: 'Lockout Target',
                    children: [
                      {id: 523181, name: 'Yes', requireDoubleRight: true},
                      {id: 523182, name: 'No', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 52319,
                    name: 'Ignore Source Alerts',
                    children: [
                      {id: 523191, name: 'Yes', requireDoubleRight: true},
                      {id: 523192, name: 'No', requireDoubleRight: true},
                    ],
                  },
                  {id: 52320, name: 'Fault Delay Alert', component: <FaultDelayTN />},
                  {
                    id: 52321,
                    name: 'Enable Overrun Alert',
                    children: [
                      {id: 523211, name: 'Enabled', requireDoubleRight: true},
                      {id: 523212, name: 'Disabled', requireDoubleRight: true},
                    ],
                  },
                ],
              },
              {
                id: 5232,
                name: 'Presets',
                children: [
                  {id: 5232111, name: '[STR_BAT_PresetName1]', component: <ConfigurePreset />},
                  {id: 5232112, name: '[STR_BAT_PresetName2]', component: <ConfigurePreset />},
                  {id: 5232113, name: '[STR_BAT_PresetName3]', component: <ConfigurePreset />},
                  {id: 5232114, name: '[STR_BAT_PresetName4]', component: <ConfigurePreset />},
                  {id: 5232115, name: '[STR_BAT_PresetName5]', component: <ConfigurePreset />},
                  {id: 5232116, name: '[STR_BAT_PresetName6]', component: <ConfigurePreset />},
                ],
              },
              {
                id: 5233,
                name: 'AOC',
                children: [
                  {
                    id: 52331,
                    name: 'Compensation Mode',
                    children: [
                      {id: 523311, name: 'Off', requireDoubleRight: true},
                      {id: 523312, name: 'Fixed', requireDoubleRight: true},
                      {id: 523313, name: 'AOC', requireDoubleRight: true},
                    ],
                  },
                  {id: 52332, name: 'Fixed Value', component: <FixedValueTN />},
                ],
              },
            ],
          },
          {
            id: 524,
            name: 'Gas Linearization',
            children: [
              {
                id: 5241,
                name: 'Enable/Disable',
                children: [
                  {id: 52411, name: 'Enabled', requireDoubleRight: true},
                  {id: 52412, name: 'Disabled', requireDoubleRight: true},
                ],
              },
            ],
          },
          {
            id: 525,
            name: 'Energy Flow',
            children: [
              {
                id: 5251,
                name: 'Energy Flow',
                children: [
                  {id: 52511, name: 'MJ/h', requireDoubleRight: true},
                  {id: 52512, name: 'UNIT_BTU_hr', requireDoubleRight: true},
                  {id: 52513, name: 'UNIT_MJ_min', requireDoubleRight: true},
                  {id: 52514, name: 'UNIT_BTU_min', requireDoubleRight: true},
                  {id: 52515, name: 'UNIT_BTU_day', requireDoubleRight: true},
                ],
              },
              {
                id: 5252,
                name: 'Calorific Value',
                children: [
                  {id: 52521, name: 'UNIT_MJ_kgm', requireDoubleRight: true},
                  {id: 52522, name: 'UNIT_MJ_m3', requireDoubleRight: true},
                  {id: 52523, name: 'UNIT_BTU_lb', requireDoubleRight: true},
                  {id: 52524, name: 'UNIT_BTU_scf', requireDoubleRight: true},
                ],
              },
            ],
          },
        ],
      },
      {
        id: 52,
        name: 'Time/Date/Tag',
        children: [
          {
            id: 520111,
            name: 'Time',
            children: [
              {
                id: 5201111,
                name: 'Time Zone',
                children: [
                  {
                    id: 52011111,
                    name: 'Time Zone',
                    children: [
                      {id: 520111111, name: 'TZ_dateLine', requireDoubleRight: true},
                      {id: 520111112, name: 'TZ_samoa', requireDoubleRight: true},
                      {id: 520111113, name: 'TZ_hawaii', requireDoubleRight: true},
                      {id: 520111114, name: 'TZ_alaska', requireDoubleRight: true},
                      {id: 520111115, name: 'TZ_pacific', requireDoubleRight: true},
                      {id: 520111116, name: 'TZ_mountain', requireDoubleRight: true},
                      {id: 520111117, name: 'TZ_central', requireDoubleRight: true},
                      {id: 520111118, name: 'TZ_eastern', requireDoubleRight: true},
                      {id: 520111119, name: 'TZ_atlantic', requireDoubleRight: true},
                      {id: 520111120, name: 'TZ_newfoundLand', requireDoubleRight: true},
                      {id: 520111121, name: 'TZ_saEastern', requireDoubleRight: true},
                      {id: 520111122, name: 'TZ_midAtlantic', requireDoubleRight: true},
                      {id: 520111123, name: 'TZ_azores', requireDoubleRight: true},
                      {id: 520111124, name: 'TZ_greenwich', requireDoubleRight: true},
                      {id: 520111125, name: 'TZ_centralEU', requireDoubleRight: true},
                      {id: 520111126, name: 'TZ_europe', requireDoubleRight: true},
                      {id: 520111127, name: 'TZ_russian', requireDoubleRight: true},
                      {id: 520111128, name: 'TZ_iran', requireDoubleRight: true},
                      {id: 520111129, name: 'TZ_arabian', requireDoubleRight: true},
                      {id: 520111130, name: 'TZ_afghan', requireDoubleRight: true},
                      {id: 520111131, name: 'TZ_westAsia', requireDoubleRight: true},
                      {id: 520111132, name: 'TZ_india', requireDoubleRight: true},
                      {id: 520111133, name: 'TZ_nepal', requireDoubleRight: true},
                      {id: 520111134, name: 'TZ_centralAsia', requireDoubleRight: true},
                      {id: 520111135, name: 'TZ_myanmar', requireDoubleRight: true},
                      {id: 520111136, name: 'TZ_seAsia', requireDoubleRight: true},
                      {id: 520111137, name: 'TZ_china', requireDoubleRight: true},
                      {id: 520111138, name: 'TZ_korea', requireDoubleRight: true},
                      {id: 520111139, name: 'TZ_centralAustralia', requireDoubleRight: true},
                      {id: 520111140, name: 'TZ_eastAustralia', requireDoubleRight: true},
                      {id: 520111141, name: 'TZ_centralPacific', requireDoubleRight: true},
                      {id: 520111142, name: 'TZ_fiji', requireDoubleRight: true},
                      {id: 520111143, name: 'TZ_tonga', requireDoubleRight: true},
                    ],
                  },
                  {id: 52011112, name: 'Special Time Zone', component: <SpecialTZTN />},
                ],
              },
              {id: 5201112, name: 'Time', component: <TimeTN />},
              {id: 5201113, name: 'Daylight Savings'},
            ],
          },
          {id: 520112, name: 'Date', component: <DateTN />},
          {id: 520113, name: 'Short Tag', component: <ShortTagTN />},
          {id: 520114, name: 'Long Tag', component: <LongTagTN />},
          {id: 520115, name: 'Message', component: <MessageTN />},
        ],
      },
      {
        id: 53,
        name: 'Inputs/Outputs',
        children: [
          {
            id: 531,
            name: 'Channel A',
            children: [
              {id: 5311, name: 'I/O Type', children: [{id: 53111, name: 'Milliamp Output 1'}]},
              {
                id: 5312,
                name: 'I/O Settings',
                children: [
                  {
                    id: 53121,
                    name: 'Source',
                    children: [
                      {id: 531211, name: 'Mass Flow Rate', requireDoubleRight: true},
                      {id: 531212, name: 'Volume Flow Rate', requireDoubleRight: true},
                      {id: 531213, name: 'Drive Gain', requireDoubleRight: true},
                      {id: 531214, name: 'GSV Flow Rate', requireDoubleRight: true},
                      {id: 531215, name: 'Velocity', requireDoubleRight: true},
                      {id: 531216, name: 'Temperature', requireDoubleRight: true},
                      {id: 531217, name: 'Density', requireDoubleRight: true},
                      {id: 531218, name: 'External Pressure', requireDoubleRight: true},
                      {id: 531219, name: 'External Temperature', requireDoubleRight: true},
                      {id: 531220, name: 'External Density', requireDoubleRight: true},
                      {id: 531221, name: 'FI Flow Rate', requireDoubleRight: true},
                      {id: 531222, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
                      {id: 531223, name: 'Referred Density', requireDoubleRight: true},
                      {id: 531224, name: 'Referred Volume Flow', requireDoubleRight: true},
                      {id: 531225, name: 'Avg. Line Density', requireDoubleRight: true},
                      {id: 531226, name: 'Avg. Temperature', requireDoubleRight: true},
                      {id: 531227, name: 'Referred Density', requireDoubleRight: true},
                      {id: 531228, name: 'Specific Gravity', requireDoubleRight: true},
                      {id: 531229, name: 'Standard Vol Flow', requireDoubleRight: true},
                      {id: 531230, name: 'Net Mass Flow', requireDoubleRight: true},
                      {id: 531231, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                      {id: 531232, name: 'Concentration', requireDoubleRight: true},
                      {id: 531233, name: '% of Fill', requireDoubleRight: true},
                      {id: 531234, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                      {id: 531235, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                      {id: 531236, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                      {id: 531237, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                      {id: 531238, name: 'PV_NET_FLOW_WATER_AT_LINE', requireDoubleRight: true},
                      {id: 531239, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                      {id: 531240, name: 'PV_WATERCUT_AT_REF', requireDoubleRight: true},
                      {id: 531241, name: 'PV_NET_FLOW_WATER_AT_REF', requireDoubleRight: true},
                      {id: 531242, name: 'PV_GAS_VOID_FRACTION', requireDoubleRight: true},
                      {id: 531243, name: 'PV_UNREM_MASS_FLOW', requireDoubleRight: true},
                      {id: 531244, name: 'PV_UNREM_VOL_FLOW', requireDoubleRight: true},
                      {id: 531245, name: 'PV_UNREM_DENSITY', requireDoubleRight: true},
                      {id: 531246, name: 'PV_DEN_CALORIFIC_VALUE', requireDoubleRight: true},
                      {id: 531247, name: 'PV_DEN_ENERGY_FLOW', requireDoubleRight: true},
                      {id: 531248, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 531249, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 531250, name: 'PV_NOC_AVE_UNC_OIL_FLOW', requireDoubleRight: true},
                      {id: 531251, name: 'PV_NOC_AVE_UNC_WATER_CUT', requireDoubleRight: true},
                      {id: 531252, name: 'PV_NOC_AVE_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 531253, name: 'PV_NOC_AVE_UNC_WATER_FLOW', requireDoubleRight: true},
                      {id: 531254, name: 'PV_NOC_AVE_UNC_BACK_FLOW', requireDoubleRight: true},
                      {id: 531255, name: 'PV_NOC_AVE_NET_OIL_FLOW', requireDoubleRight: true},
                      {id: 531256, name: 'PV_NOC_AVE_NET_WATER_CUT', requireDoubleRight: true},
                      {id: 531257, name: 'PV_NOC_AVE_NET_GROSS_FLOW', requireDoubleRight: true},
                      {id: 531258, name: 'PV_NOC_AVE_NET_WATER_FLOW', requireDoubleRight: true},
                      {id: 531259, name: 'PV_NOC_AVE_DENSITY', requireDoubleRight: true},
                      {id: 531260, name: 'PV_NOC_AVE_TEMPERATURE', requireDoubleRight: true},
                      {id: 531261, name: 'PV_NOC_AVE_MASS_FLOW', requireDoubleRight: true},
                      {id: 531262, name: 'PV_TMR_LIQUID_FLOW', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 53122,
                    name: 'Direction',
                    children: [
                      {id: 5312201, name: 'Normal', requireDoubleRight: true},
                      {id: 5312202, name: 'Absolute Value', requireDoubleRight: true},
                    ],
                  },
                  {id: 53123, name: 'Lower Range Value', component: <LowerRangeTN />},
                  {id: 53124, name: 'Upper Range Value', component: <UpperRangeTN />},
                  {id: 53125, name: 'MAO Cutoff', component: <MAOCutoffTN />},
                  {id: 53126, name: 'MAO Damping', component: <MAODampingTN />},
                  {
                    id: 53127,
                    name: 'Fault Action',
                    children: [
                      {id: 531271, name: 'Upscale', requireDoubleRight: true},
                      {id: 531272, name: 'Downscale', requireDoubleRight: true},
                      {id: 531273, name: 'Internal Zero', requireDoubleRight: true},
                      {id: 531274, name: 'None', requireDoubleRight: true},
                    ],
                  },
                  {id: 53128, name: 'Fault Level', component: <FaultLevelTN />},
                ],
              },
              {
                id: 5313,
                name: 'Power',
                children: [
                  {id: 53131, name: 'Active', requireDoubleRight: true},
                  {id: 53132, name: 'Passive', requireDoubleRight: true},
                ],
              },
              {
                id: 5314,
                name: 'HART Settings',
                children: [
                  {id: 53141, name: 'HART Address', component: <HartAddress />},
                  {
                    id: 53142,
                    name: 'Loop Current',
                    children: [
                      {id: 531421, name: 'Loop Current Fixed', component: <LoopCurrent />},
                      {id: 531422, name: 'Loop Current Active', component: <LoopCurrent />},
                    ],
                  },
                  {
                    id: 53143,
                    name: 'HART Find Device',
                    children: [
                      {id: 531431, name: 'On', requireDoubleRight: true},
                      {id: 531432, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 53144,
                    name: 'HART Variables',
                    children: [
                      {
                        id: 531441,
                        name: 'PV (MAO1 Source)',
                        children: [
                          {id: 10111011, name: 'Mass Flow Rate', requireDoubleRight: true},
                          {id: 101112, name: 'Volume Flow Rate', requireDoubleRight: true},
                          {id: 101113, name: 'Drive Gain', requireDoubleRight: true},
                          {id: 101114, name: 'GSV Flow Rate', requireDoubleRight: true},
                          {id: 101115, name: 'Velocity', requireDoubleRight: true},
                          {id: 101116, name: 'Temperature', requireDoubleRight: true},
                          {id: 101117, name: 'Density', requireDoubleRight: true},
                          {id: 101118, name: 'External Pressure', requireDoubleRight: true},
                          {id: 101119, name: 'External Temperature', requireDoubleRight: true},
                          {id: 101120, name: 'External Density', requireDoubleRight: true},
                          {id: 101121, name: 'FI Flow Rate', requireDoubleRight: true},
                          {id: 101122, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
                          {id: 101123, name: 'Referred Density', requireDoubleRight: true},
                          {id: 101124, name: 'Referred Volume Flow', requireDoubleRight: true},
                          {id: 101125, name: 'Avg. Line Density', requireDoubleRight: true},
                          {id: 101126, name: 'Avg. Temperature', requireDoubleRight: true},
                          {id: 101127, name: 'Referred Density', requireDoubleRight: true},
                          {id: 101128, name: 'Specific Gravity', requireDoubleRight: true},
                          {id: 101129, name: 'Standard Vol Flow', requireDoubleRight: true},
                          {id: 101130, name: 'Net Mass Flow', requireDoubleRight: true},
                          {id: 101131, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                          {id: 101132, name: 'Concentration', requireDoubleRight: true},
                          {id: 101133, name: '% of Fill', requireDoubleRight: true},
                          {id: 101134, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                          {id: 101135, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                          {id: 101136, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                          {id: 101137, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                          {id: 101138, name: 'PV_NET_FLOW_WATER_AT_LINE', requireDoubleRight: true},
                          {id: 101139, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                          {id: 101140, name: 'PV_WATERCUT_AT_REF', requireDoubleRight: true},
                          {id: 101141, name: 'PV_NET_FLOW_WATER_AT_REF', requireDoubleRight: true},
                          {id: 101142, name: 'PV_GAS_VOID_FRACTION', requireDoubleRight: true},
                          {id: 101143, name: 'PV_UNREM_MASS_FLOW', requireDoubleRight: true},
                          {id: 101144, name: 'PV_UNREM_VOL_FLOW', requireDoubleRight: true},
                          {id: 101145, name: 'PV_UNREM_DENSITY', requireDoubleRight: true},
                          {id: 101146, name: 'PV_DEN_CALORIFIC_VALUE', requireDoubleRight: true},
                          {id: 101147, name: 'PV_DEN_ENERGY_FLOW', requireDoubleRight: true},
                          {id: 101148, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                          {id: 101149, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                          {id: 101150, name: 'PV_NOC_AVE_UNC_OIL_FLOW', requireDoubleRight: true},
                          {id: 101151, name: 'PV_NOC_AVE_UNC_WATER_CUT', requireDoubleRight: true},
                          {id: 101152, name: 'PV_NOC_AVE_UNC_GROSS_FLOW', requireDoubleRight: true},
                          {id: 101153, name: 'PV_NOC_AVE_UNC_WATER_FLOW', requireDoubleRight: true},
                          {id: 101154, name: 'PV_NOC_AVE_UNC_BACK_FLOW', requireDoubleRight: true},
                          {id: 101155, name: 'PV_NOC_AVE_NET_OIL_FLOW', requireDoubleRight: true},
                          {id: 101156, name: 'PV_NOC_AVE_NET_WATER_CUT', requireDoubleRight: true},
                          {id: 101157, name: 'PV_NOC_AVE_NET_GROSS_FLOW', requireDoubleRight: true},
                          {id: 101158, name: 'PV_NOC_AVE_NET_WATER_FLOW', requireDoubleRight: true},
                          {id: 101159, name: 'PV_NOC_AVE_DENSITY', requireDoubleRight: true},
                          {id: 101160, name: 'PV_NOC_AVE_TEMPERATURE', requireDoubleRight: true},
                          {id: 101161, name: 'PV_NOC_AVE_MASS_FLOW', requireDoubleRight: true},
                          {id: 101162, name: 'PV_TMR_LIQUID_FLOW', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 531442,
                        name: 'SV',
                        children: [
                          {id: 1531431, name: 'PV (MAO1 Source)', requireDoubleRight: true},
                          {id: 1531432, name: 'SV', requireDoubleRight: true},
                          {id: 1531433, name: 'TV', requireDoubleRight: true},
                          {id: 1531434, name: 'QV', requireDoubleRight: true},
                          {id: 1531435, name: 'Velocity', requireDoubleRight: true},
                          {id: 1531436, name: 'Temperature', requireDoubleRight: true},
                          {id: 1531437, name: 'Density', requireDoubleRight: true},
                          {id: 1531438, name: 'External Pressure', requireDoubleRight: true},
                          {id: 1531439, name: 'External Temperature', requireDoubleRight: true},
                          {id: 1531440, name: 'External Density', requireDoubleRight: true},
                          {id: 1531441, name: 'FI Flow Rate', requireDoubleRight: true},
                          {id: 1531442, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
                          {id: 1531443, name: 'Referred Density', requireDoubleRight: true},
                          {id: 1531444, name: 'Referred Volume Flow', requireDoubleRight: true},
                          {id: 1531445, name: 'Avg. Line Density', requireDoubleRight: true},
                          {id: 1531446, name: 'Avg. Temperature', requireDoubleRight: true},
                          {id: 1531447, name: 'Referred Density', requireDoubleRight: true},
                          {id: 1531448, name: 'Specific Gravity', requireDoubleRight: true},
                          {id: 1531449, name: 'Standard Vol Flow', requireDoubleRight: true},
                          {id: 1531450, name: 'Net Mass Flow', requireDoubleRight: true},
                          {id: 1531451, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                          {id: 1531452, name: 'Concentration', requireDoubleRight: true},
                          {id: 1531453, name: '% of Fill', requireDoubleRight: true},
                          {id: 1531454, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                          {id: 1531455, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                          {id: 1531456, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                          {id: 1531457, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                          {
                            id: 1531458,
                            name: 'PV_NET_FLOW_WATER_AT_LINE',
                            requireDoubleRight: true,
                          },
                          {id: 1531459, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 531443,
                        name: 'TV',
                        children: [
                          {id: 10531431, name: 'PV (MAO1 Source)', requireDoubleRight: true},
                          {id: 10531432, name: 'SV', requireDoubleRight: true},
                          {id: 10531433, name: 'TV', requireDoubleRight: true},
                          {id: 10531434, name: 'QV', requireDoubleRight: true},
                          {id: 10531435, name: 'Poll External Device', requireDoubleRight: true},
                          {id: 10531436, name: 'Burst Message 1', requireDoubleRight: true},
                          {id: 10531437, name: 'Burst Message 2', requireDoubleRight: true},
                          {id: 10531438, name: 'Burst Message 3', requireDoubleRight: true},
                          {id: 10531439, name: 'External Temperature', requireDoubleRight: true},
                          {id: 10531440, name: 'External Density', requireDoubleRight: true},
                          {id: 10531441, name: 'FI Flow Rate', requireDoubleRight: true},
                          {id: 10531442, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
                          {id: 10531443, name: 'Referred Density', requireDoubleRight: true},
                          {id: 10531444, name: 'Referred Volume Flow', requireDoubleRight: true},
                          {id: 10531445, name: 'Avg. Line Density', requireDoubleRight: true},
                          {id: 10531446, name: 'Avg. Temperature', requireDoubleRight: true},
                          {id: 10531447, name: 'Referred Density', requireDoubleRight: true},
                          {id: 10531448, name: 'Specific Gravity', requireDoubleRight: true},
                          {id: 10531449, name: 'Standard Vol Flow', requireDoubleRight: true},
                          {id: 10531450, name: 'Net Mass Flow', requireDoubleRight: true},
                          {id: 10531451, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                          {id: 10531452, name: 'Concentration', requireDoubleRight: true},
                          {id: 10531453, name: '% of Fill', requireDoubleRight: true},
                          {id: 10531454, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                          {id: 10531455, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                          {id: 10531456, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                          {id: 10531457, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                          {
                            id: 10531458,
                            name: 'PV_NET_FLOW_WATER_AT_LINE',
                            requireDoubleRight: true,
                          },
                          {id: 10531459, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 531444,
                        name: 'QV',
                        children: [
                          {id: 11531431, name: 'PV (MAO1 Source)', requireDoubleRight: true},
                          {id: 11531432, name: 'SV', requireDoubleRight: true},
                          {id: 11531433, name: 'TV', requireDoubleRight: true},
                          {id: 11531434, name: 'QV', requireDoubleRight: true},
                          {id: 11531435, name: 'Poll External Device', requireDoubleRight: true},
                          {id: 11531436, name: 'Burst Message 1', requireDoubleRight: true},
                          {id: 11531437, name: 'Burst Message 2', requireDoubleRight: true},
                          {id: 11531438, name: 'Burst Message 3', requireDoubleRight: true},
                          {id: 11531439, name: 'External Temperature', requireDoubleRight: true},
                          {id: 11531440, name: 'External Density', requireDoubleRight: true},
                          {id: 11531441, name: 'FI Flow Rate', requireDoubleRight: true},
                          {id: 11531442, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
                          {id: 11531443, name: 'Referred Density', requireDoubleRight: true},
                          {id: 11531444, name: 'Referred Volume Flow', requireDoubleRight: true},
                          {id: 11531445, name: 'Avg. Line Density', requireDoubleRight: true},
                          {id: 11531446, name: 'Avg. Temperature', requireDoubleRight: true},
                          {id: 11531447, name: 'Referred Density', requireDoubleRight: true},
                          {id: 11531448, name: 'Specific Gravity', requireDoubleRight: true},
                          {id: 11531449, name: 'Standard Vol Flow', requireDoubleRight: true},
                          {id: 11531450, name: 'Net Mass Flow', requireDoubleRight: true},
                          {id: 11531451, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                          {id: 11531452, name: 'Concentration', requireDoubleRight: true},
                          {id: 11531453, name: '% of Fill', requireDoubleRight: true},
                          {id: 11531454, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                          {id: 11531455, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                          {id: 11531456, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                          {id: 11531457, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                          {
                            id: 11531458,
                            name: 'PV_NET_FLOW_WATER_AT_LINE',
                            requireDoubleRight: true,
                          },
                          {id: 11531459, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 53145,
                    name: 'Poll External Device',
                    children: [
                      {
                        id: 531451,
                        name: 'Polled Variable 1',
                        children: [
                          {
                            id: 5314511,
                            name: 'Variable',
                            children: [
                              {id: 53145111, name: 'None', requireDoubleRight: true},
                              {
                                id: 53145112,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 53145113, name: 'External Pressure', requireDoubleRight: true},
                              {id: 53145114, name: 'External Density', requireDoubleRight: true},
                              {id: 53145115, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                              {id: 53145116, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 53145117,
                                name: 'PV_DEN_CALORIFIC_VALUE',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5314512,
                            name: 'Polling Control',
                            children: [
                              {id: 53145121, name: 'POLL_NONE', requireDoubleRight: true},
                              {id: 53145122, name: 'POLL_PRIMARY', requireDoubleRight: true},
                              {id: 53145123, name: 'POLL_SECONDARY', requireDoubleRight: true},
                            ],
                          },
                          {id: 5314513, name: 'External Device Tag', component: <DevTag1TN />},
                        ],
                      },
                      {
                        id: 531452,
                        name: 'Polled Variable 2',
                        children: [
                          {
                            id: 5314521,
                            name: 'Variable',
                            children: [
                              {id: 531452101, name: 'None', requireDoubleRight: true},
                              {
                                id: 531452102,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 531452103, name: 'External Pressure', requireDoubleRight: true},
                              {id: 531452104, name: 'External Density', requireDoubleRight: true},
                              {
                                id: 531452105,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 531452106, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 531452107,
                                name: 'PV_DEN_CALORIFIC_VALUE',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5314522,
                            name: 'Polling Control',
                            children: [
                              {id: 53145221, name: 'POLL_NONE', requireDoubleRight: true},
                              {id: 53145222, name: 'POLL_PRIMARY', requireDoubleRight: true},
                              {id: 53145223, name: 'POLL_SECONDARY', requireDoubleRight: true},
                            ],
                          },
                          {id: 5314523, name: 'External Device Tag', component: <DevTag1TN />},
                        ],
                      },
                    ],
                  },
                  {
                    id: 53146,
                    name: 'Burst Message 1',
                    children: [
                      {
                        id: 51145211,
                        name: 'State',
                        children: [
                          {id: 511452111, name: 'On', requireDoubleRight: true},
                          {id: 511452112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 51145212,
                        name: 'Command',
                        children: [
                          {id: 511452121, name: '1', requireDoubleRight: true},
                          {id: 511452122, name: '2', requireDoubleRight: true},
                          {id: 511452123, name: '3', requireDoubleRight: true},
                          {id: 511452124, name: '9', requireDoubleRight: true},
                          {id: 511452125, name: '33', requireDoubleRight: true},
                          {id: 511452126, name: '48', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 51145213,
                        name: 'Variables',
                        children: [
                          {
                            id: 511452131,
                            name: 'Burst Variable 1',
                            children: [
                              {id: 5011452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5011452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5011452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5011452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5011452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5011452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5011452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5011452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5011452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5011452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5011452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5011452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5011452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5011452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5011452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5011452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5011452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5011452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5011452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5011452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5011452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5011452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5011452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5011452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5011452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5011452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5011452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5011452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5011452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 511452132,
                            name: 'Burst Variable 2',
                            children: [
                              {id: 5111452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5111452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5111452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5111452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5111452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5111452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5111452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5111452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5111452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5111452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5111452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5111452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5111452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5111452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5111452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5111452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5111452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5111452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5111452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5111452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5111452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5111452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5111452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5111452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5111452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5111452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5111452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5111452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5111452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 511452133,
                            name: 'Burst Variable 3',
                            children: [
                              {id: 5211452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5211452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5211452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5211452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5211452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5211452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5211452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5211452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5211452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5211452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5211452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5211452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5211452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5211452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5211452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5211452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5211452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5211452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5211452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5211452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5211452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5211452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5211452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5211452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5211452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5211452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5211452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5211452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5211452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 511452134,
                            name: 'Burst Variable 4',
                            children: [
                              {id: 5311452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5311452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5311452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5311452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5311452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5311452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5311452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5311452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5311452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5311452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5311452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5311452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5311452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5311452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5311452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5311452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5311452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5311452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5311452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5311452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5311452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5311452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5311452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5311452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5311452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5311452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5311452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5311452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5311452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 511452135,
                            name: 'Burst Variable 5',
                            children: [
                              {id: 5411452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5411452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5411452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5411452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5411452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5411452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5411452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5411452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5411452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5411452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5411452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5411452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5411452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5411452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5411452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5411452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5411452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5411452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5411452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5411452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5411452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5411452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5411452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5411452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5411452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5411452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5411452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5411452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5411452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 511452136,
                            name: 'Burst Variable 6',
                            children: [
                              {id: 5511452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5511452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5511452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5511452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5511452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5511452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5511452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5511452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5511452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5511452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5511452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5511452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5511452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5511452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5511452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5511452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5511452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5511452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5511452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5511452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5511452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5511452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5511452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5511452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5511452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5511452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5511452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5511452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5511452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 511452137,
                            name: 'Burst Variable 7',
                            children: [
                              {id: 5611452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5611452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5611452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5611452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5611452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5611452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5611452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5611452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5611452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5611452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5611452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5611452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5611452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5611452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5611452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5611452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5611452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5611452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5611452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5611452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5611452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5611452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5611452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5611452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5611452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5611452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5611452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5611452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5611452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 511452138,
                            name: 'Burst Variable 8',
                            children: [
                              {id: 5711452131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 5711452132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 5711452133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 5711452134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 5711452135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 5711452136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 5711452137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 5711452138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 5711452139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 5711452140, name: 'External Density', requireDoubleRight: true},
                              {id: 5711452141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 5711452142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 5711452143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 5711452144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {id: 5711452145, name: 'Avg. Line Density', requireDoubleRight: true},
                              {id: 5711452146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 5711452147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 5711452148, name: 'Specific Gravity', requireDoubleRight: true},
                              {id: 5711452149, name: 'Standard Vol Flow', requireDoubleRight: true},
                              {id: 5711452150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 5711452151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 5711452152, name: 'Concentration', requireDoubleRight: true},
                              {id: 5711452153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 5711452154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5711452155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5711452156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 5711452157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 5711452158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 5711452159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 51145214,
                        name: 'Trigger Mode',
                        children: [
                          {id: 5114521411, name: '0', requireDoubleRight: true},
                          {id: 5114521412, name: '1', requireDoubleRight: true},
                          {id: 5114521413, name: '2', requireDoubleRight: true},
                          {id: 5114521414, name: '3', requireDoubleRight: true},
                          {id: 5114521415, name: '4', requireDoubleRight: true},
                        ],
                      },
                      {id: 51145215, name: 'Trigger Value', component: <TriggerValueTN />},
                      {id: 51145216, name: 'Update Period', component: <UpdatePeriodTN />},
                      {id: 51145217, name: 'Max Update Period', component: <MaxUpdatePeriodTN />},
                    ],
                  },
                  {
                    id: 53147,
                    name: 'Burst Message 2',
                    children: [
                      {
                        id: 52145211,
                        name: 'State',
                        children: [
                          {id: 521452111, name: 'On', requireDoubleRight: true},
                          {id: 521452112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 52145212,
                        name: 'Command',
                        children: [
                          {id: 521452121, name: '1', requireDoubleRight: true},
                          {id: 521452122, name: '2', requireDoubleRight: true},
                          {id: 521452123, name: '3', requireDoubleRight: true},
                          {id: 521452124, name: '9', requireDoubleRight: true},
                          {id: 521452125, name: '33', requireDoubleRight: true},
                          {id: 521452126, name: '48', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 52145213,
                        name: 'Variables',
                        children: [
                          {
                            id: 5114521311,
                            name: 'Burst Variable 1',
                            children: [
                              {id: 50114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 50114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 50114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 50114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 50114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 50114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 50114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 50114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 50114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 50114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 50114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 50114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 50114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 50114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 50114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 50114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 50114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 50114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 50114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 50114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 50114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 50114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 50114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 50114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 50114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5114521321,
                            name: 'Burst Variable 2',
                            children: [
                              {id: 51114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 51114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 51114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 51114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 51114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 51114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 51114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 51114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 51114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 51114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 51114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 51114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 51114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 51114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 51114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 51114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 51114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 51114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 51114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 51114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 51114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 51114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 51114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 51114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 51114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5114521331,
                            name: 'Burst Variable 3',
                            children: [
                              {id: 52114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 52114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 52114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 52114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 52114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 52114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 52114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 52114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 52114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 52114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 52114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 52114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 52114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 52114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 52114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 52114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 52114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 52114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 52114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 52114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 52114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 52114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 52114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 52114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 52114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5114521341,
                            name: 'Burst Variable 4',
                            children: [
                              {id: 53114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 53114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 53114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 53114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 53114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 53114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 53114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 53114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 53114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 53114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 53114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 53114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 53114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 53114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 53114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 53114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 53114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 53114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 53114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 53114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 53114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 53114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 53114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 53114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 53114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5114521351,
                            name: 'Burst Variable 5',
                            children: [
                              {id: 54114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 54114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 54114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 54114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 54114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 54114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 54114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 54114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 54114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 54114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 54114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 54114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 54114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 54114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 54114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 54114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 54114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 54114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 54114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 54114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 54114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 54114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 54114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 54114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 54114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5114521361,
                            name: 'Burst Variable 6',
                            children: [
                              {id: 55114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 55114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 55114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 55114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 55114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 55114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 55114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 55114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 55114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 55114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 55114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 55114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 55114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 55114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 55114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 55114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 55114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 55114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 55114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 55114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 55114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 55114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 55114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 55114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 55114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5114521371,
                            name: 'Burst Variable 7',
                            children: [
                              {id: 56114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 56114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 56114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 56114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 56114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 56114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 56114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 56114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 56114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 56114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 56114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 56114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 56114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 56114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 56114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 56114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 56114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 56114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 56114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 56114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 56114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 56114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 56114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 56114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 56114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 5114521381,
                            name: 'Burst Variable 8',
                            children: [
                              {id: 57114521131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 57114521132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 57114521133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 57114521134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 57114521135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 57114521136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 57114521137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 57114521138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 57114521139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 57114521140, name: 'External Density', requireDoubleRight: true},
                              {id: 57114521141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 57114521142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 57114521143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 57114521144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114521145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 57114521146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 57114521147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 57114521148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 57114521149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 57114521150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 57114521151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 57114521152, name: 'Concentration', requireDoubleRight: true},
                              {id: 57114521153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 57114521154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114521155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114521156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 57114521157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 57114521158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114521159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 52145214,
                        name: 'Trigger Mode',
                        children: [
                          {id: 5214521411, name: '0', requireDoubleRight: true},
                          {id: 5214521412, name: '1', requireDoubleRight: true},
                          {id: 5214521413, name: '2', requireDoubleRight: true},
                          {id: 5214521414, name: '3', requireDoubleRight: true},
                          {id: 5214521415, name: '4', requireDoubleRight: true},
                        ],
                      },
                      {id: 52145215, name: 'Trigger Value', component: <TriggerValueTN />},
                      {id: 52145216, name: 'Update Period', component: <UpdatePeriodTN />},
                      {id: 52145217, name: 'Max Update Period', component: <MaxUpdatePeriodTN />},
                    ],
                  },
                  {
                    id: 53148,
                    name: 'Burst Message 3',
                    children: [
                      {
                        id: 53145211,
                        name: 'State',
                        children: [
                          {id: 531452111, name: 'On', requireDoubleRight: true},
                          {id: 531452112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 53145212,
                        name: 'Command',
                        children: [
                          {id: 531452121, name: '1', requireDoubleRight: true},
                          {id: 531452122, name: '2', requireDoubleRight: true},
                          {id: 531452123, name: '3', requireDoubleRight: true},
                          {id: 531452124, name: '9', requireDoubleRight: true},
                          {id: 531452125, name: '33', requireDoubleRight: true},
                          {id: 531452126, name: '48', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 53145213,
                        name: 'Variables',
                        children: [
                          {
                            id: 51145213111,
                            name: 'Burst Variable 1',
                            children: [
                              {id: 50114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 50114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 50114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 50114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 50114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 50114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 50114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 50114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 50114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 50114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 50114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 50114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 50114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 50114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 50114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 50114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 50114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 50114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 50114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 50114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 50114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 50114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 50114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 50114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 50114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 50114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 51145213211,
                            name: 'Burst Variable 2',
                            children: [
                              {id: 51114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 51114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 51114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 51114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 51114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 51114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 51114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 51114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 51114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 51114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 51114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 51114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 51114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 51114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 51114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 51114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 51114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 51114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 51114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 51114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 51114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 51114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 51114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 51114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 51114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 51114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 51145213311,
                            name: 'Burst Variable 3',
                            children: [
                              {id: 52114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 52114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 52114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 52114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 52114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 52114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 52114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 52114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 52114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 52114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 52114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 52114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 52114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 52114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 52114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 52114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 52114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 52114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 52114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 52114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 52114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 52114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 52114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 52114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 52114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 52114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 51145213411,
                            name: 'Burst Variable 4',
                            children: [
                              {id: 53114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 53114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 53114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 53114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 53114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 53114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 53114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 53114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 53114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 53114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 53114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 53114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 53114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 53114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 53114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 53114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 53114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 53114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 53114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 53114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 53114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 53114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 53114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 53114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 53114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 53114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 51145213511,
                            name: 'Burst Variable 5',
                            children: [
                              {id: 54114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 54114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 54114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 54114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 54114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 54114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 54114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 54114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 54114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 54114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 54114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 54114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 54114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 54114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 54114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 54114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 54114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 54114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 54114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 54114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 54114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 54114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 54114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 54114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 54114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 54114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 51145213611,
                            name: 'Burst Variable 6',
                            children: [
                              {id: 55114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 55114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 55114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 55114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 55114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 55114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 55114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 55114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 55114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 55114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 55114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 55114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 55114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 55114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 55114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 55114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 55114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 55114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 55114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 55114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 55114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 55114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 55114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 55114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 55114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 55114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 51145213711,
                            name: 'Burst Variable 7',
                            children: [
                              {id: 56114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 56114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 56114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 56114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 56114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 56114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 56114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 56114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 56114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 56114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 56114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 56114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 56114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 56114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 56114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 56114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 56114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 56114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 56114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 56114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 56114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 56114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 56114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 56114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 56114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 56114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                          {
                            id: 51145213811,
                            name: 'Burst Variable 8',
                            children: [
                              {id: 57114522131, name: 'Burst Variable 1', requireDoubleRight: true},
                              {id: 57114522132, name: 'Burst Variable 2', requireDoubleRight: true},
                              {id: 57114522133, name: 'Burst Variable 3', requireDoubleRight: true},
                              {id: 57114522134, name: 'Burst Variable 4', requireDoubleRight: true},
                              {id: 57114522135, name: 'Burst Variable 5', requireDoubleRight: true},
                              {id: 57114522136, name: 'Burst Variable 6', requireDoubleRight: true},
                              {id: 57114522137, name: 'Burst Variable 7', requireDoubleRight: true},
                              {id: 57114522138, name: 'Burst Variable 8', requireDoubleRight: true},
                              {
                                id: 57114522139,
                                name: 'External Temperature',
                                requireDoubleRight: true,
                              },
                              {id: 57114522140, name: 'External Density', requireDoubleRight: true},
                              {id: 57114522141, name: 'FI Flow Rate', requireDoubleRight: true},
                              {
                                id: 57114522142,
                                name: 'PV_PG_FLOW_SEVERITY',
                                requireDoubleRight: true,
                              },
                              {id: 57114522143, name: 'Referred Density', requireDoubleRight: true},
                              {
                                id: 57114522144,
                                name: 'Referred Volume Flow',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114522145,
                                name: 'Avg. Line Density',
                                requireDoubleRight: true,
                              },
                              {id: 57114522146, name: 'Avg. Temperature', requireDoubleRight: true},
                              {id: 57114522147, name: 'Referred Density', requireDoubleRight: true},
                              {id: 57114522148, name: 'Specific Gravity', requireDoubleRight: true},
                              {
                                id: 57114522149,
                                name: 'Standard Vol Flow',
                                requireDoubleRight: true,
                              },
                              {id: 57114522150, name: 'Net Mass Flow', requireDoubleRight: true},
                              {
                                id: 57114522151,
                                name: 'Net Volume Flow Rate',
                                requireDoubleRight: true,
                              },
                              {id: 57114522152, name: 'Concentration', requireDoubleRight: true},
                              {id: 57114522153, name: '% of Fill', requireDoubleRight: true},
                              {
                                id: 57114522154,
                                name: 'PV_FUEL_DIFF_MASS_FLOW',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114522155,
                                name: 'PV_NET_FLOW_OIL_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114522156,
                                name: 'PV_WATERCUT_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {id: 57114522157, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                              {
                                id: 57114522158,
                                name: 'PV_NET_FLOW_WATER_AT_LINE',
                                requireDoubleRight: true,
                              },
                              {
                                id: 57114522159,
                                name: 'PV_NET_FLOW_OIL_AT_REF',
                                requireDoubleRight: true,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 53145214,
                        name: 'Trigger Mode',
                        children: [
                          {id: 5314521411, name: '0', requireDoubleRight: true},
                          {id: 5314521412, name: '1', requireDoubleRight: true},
                          {id: 5314521413, name: '2', requireDoubleRight: true},
                          {id: 5314521414, name: '3', requireDoubleRight: true},
                          {id: 5314521415, name: '4', requireDoubleRight: true},
                        ],
                      },
                      {id: 53145215, name: 'Trigger Value', component: <TriggerValueTN />},
                      {id: 53145216, name: 'Update Period', component: <UpdatePeriodTN />},
                      {id: 53145217, name: 'Max Update Period', component: <MaxUpdatePeriodTN />},
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 532,
            name: 'Channel B',
            children: [
              {
                id: 5321,
                name: 'I/O Type',
                children: [
                  {id: 53211, name: 'Milliamp Output 2', subName: 'MO2', requireDoubleRight: true},
                  {id: 53212, name: 'Frequency Output 2', subName: 'FO2', requireDoubleRight: true},
                  {id: 53213, name: 'Discrete Output 1', subName: 'DO1', requireDoubleRight: true},
                  {id: 53214, name: 'None', requireDoubleRight: true},
                ],
              },
              {
                id: 5322,
                name: 'I/O Settings',
                children: [
                  {
                    id: 5312111,
                    name: 'Source',
                    children: [
                      {id: 541211, name: 'Mass Flow Rate', requireDoubleRight: true},
                      {id: 541212, name: 'Volume Flow Rate', requireDoubleRight: true},
                      {id: 541213, name: 'Drive Gain', requireDoubleRight: true},
                      {id: 541214, name: 'GSV Flow Rate', requireDoubleRight: true},
                      {id: 541215, name: 'Velocity', requireDoubleRight: true},
                      {id: 541216, name: 'Temperature', requireDoubleRight: true},
                      {id: 541217, name: 'Density', requireDoubleRight: true},
                      {id: 541218, name: 'External Pressure', requireDoubleRight: true},
                      {id: 541219, name: 'External Temperature', requireDoubleRight: true},
                      {id: 541220, name: 'External Density', requireDoubleRight: true},
                      {id: 541221, name: 'FI Flow Rate', requireDoubleRight: true},
                      {id: 541222, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
                      {id: 541223, name: 'Referred Density', requireDoubleRight: true},
                      {id: 541224, name: 'Referred Volume Flow', requireDoubleRight: true},
                      {id: 541225, name: 'Avg. Line Density', requireDoubleRight: true},
                      {id: 541226, name: 'Avg. Temperature', requireDoubleRight: true},
                      {id: 541227, name: 'Referred Density', requireDoubleRight: true},
                      {id: 541228, name: 'Specific Gravity', requireDoubleRight: true},
                      {id: 541229, name: 'Standard Vol Flow', requireDoubleRight: true},
                      {id: 541230, name: 'Net Mass Flow', requireDoubleRight: true},
                      {id: 541231, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                      {id: 541232, name: 'Concentration', requireDoubleRight: true},
                      {id: 541233, name: '% of Fill', requireDoubleRight: true},
                      {id: 541234, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                      {id: 541235, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                      {id: 541236, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                      {id: 541237, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                      {id: 541238, name: 'PV_NET_FLOW_WATER_AT_LINE', requireDoubleRight: true},
                      {id: 541239, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                      {id: 541240, name: 'PV_WATERCUT_AT_REF', requireDoubleRight: true},
                      {id: 541241, name: 'PV_NET_FLOW_WATER_AT_REF', requireDoubleRight: true},
                      {id: 541242, name: 'PV_GAS_VOID_FRACTION', requireDoubleRight: true},
                      {id: 541243, name: 'PV_UNREM_MASS_FLOW', requireDoubleRight: true},
                      {id: 541244, name: 'PV_UNREM_VOL_FLOW', requireDoubleRight: true},
                      {id: 541245, name: 'PV_UNREM_DENSITY', requireDoubleRight: true},
                      {id: 541246, name: 'PV_DEN_CALORIFIC_VALUE', requireDoubleRight: true},
                      {id: 541247, name: 'PV_DEN_ENERGY_FLOW', requireDoubleRight: true},
                      {id: 541248, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 541249, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 541250, name: 'PV_NOC_AVE_UNC_OIL_FLOW', requireDoubleRight: true},
                      {id: 541251, name: 'PV_NOC_AVE_UNC_WATER_CUT', requireDoubleRight: true},
                      {id: 541252, name: 'PV_NOC_AVE_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 541253, name: 'PV_NOC_AVE_UNC_WATER_FLOW', requireDoubleRight: true},
                      {id: 541254, name: 'PV_NOC_AVE_UNC_BACK_FLOW', requireDoubleRight: true},
                      {id: 541255, name: 'PV_NOC_AVE_NET_OIL_FLOW', requireDoubleRight: true},
                      {id: 541256, name: 'PV_NOC_AVE_NET_WATER_CUT', requireDoubleRight: true},
                      {id: 541257, name: 'PV_NOC_AVE_NET_GROSS_FLOW', requireDoubleRight: true},
                      {id: 541258, name: 'PV_NOC_AVE_NET_WATER_FLOW', requireDoubleRight: true},
                      {id: 541259, name: 'PV_NOC_AVE_DENSITY', requireDoubleRight: true},
                      {id: 541260, name: 'PV_NOC_AVE_TEMPERATURE', requireDoubleRight: true},
                      {id: 541261, name: 'PV_NOC_AVE_MASS_FLOW', requireDoubleRight: true},
                      {id: 541262, name: 'PV_TMR_LIQUID_FLOW', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 5312112,
                    name: 'Direction',
                    children: [
                      {id: 5412201, name: 'Normal', requireDoubleRight: true},
                      {id: 5412202, name: 'Absolute Value', requireDoubleRight: true},
                    ],
                  },
                  {id: 5312113, name: 'Lower Range Value', component: <LowerRangeTN />},
                  {id: 5312114, name: 'Upper Range Value', component: <UpperRangeTN />},
                  {id: 5312115, name: 'MAO Cutoff', component: <MAOCutoffTN />},
                  {id: 5312116, name: 'MAO Damping', component: <MAODampingTN />},
                  {
                    id: 5312117,
                    name: 'Fault Action',
                    children: [
                      {id: 541271, name: 'Upscale', requireDoubleRight: true},
                      {id: 541272, name: 'Downscale', requireDoubleRight: true},
                      {id: 541273, name: 'Internal Zero', requireDoubleRight: true},
                      {id: 541274, name: 'None', requireDoubleRight: true},
                    ],
                  },
                  {id: 5312118, name: 'Fault Level', component: <FaultLevelTN />},
                ],
              },
              {
                id: 5323,
                name: 'Power',
                children: [
                  {id: 551271, name: 'Active', requireDoubleRight: true},
                  {id: 551272, name: 'Passive', requireDoubleRight: true},
                ],
              },
            ],
          },
          {
            id: 533,
            name: 'Channel C',
            children: [
              {
                id: 5331,
                name: 'I/O Type',
                children: [
                  {id: 53311, name: 'Milliamp Output 3', subName: 'MO3', requireDoubleRight: true},
                  {id: 53312, name: 'Milliamp Output 3', subName: 'MO3', requireDoubleRight: true},
                  {id: 53313, name: 'Frequency Output 1', subName: 'FO1', requireDoubleRight: true},
                  {id: 53314, name: 'Discrete Output 1', subName: 'DO1', requireDoubleRight: true},
                  {id: 53315, name: 'Discrete Output 2', subName: 'DO2', requireDoubleRight: true},
                  {id: 53316, name: 'Discrete Input 1', subName: 'DI1', requireDoubleRight: true},
                  {id: 53317, name: 'None', requireDoubleRight: true},
                ],
              },
              {
                id: 5332,
                name: 'I/O Settings',
                children: [
                  {
                    id: 5412111,
                    name: 'Source',
                    children: [
                      {id: 5041211, name: 'Mass Flow Rate', requireDoubleRight: true},
                      {id: 5041212, name: 'Volume Flow Rate', requireDoubleRight: true},
                      {id: 5041213, name: 'Drive Gain', requireDoubleRight: true},
                      {id: 5041214, name: 'GSV Flow Rate', requireDoubleRight: true},
                      {id: 5041215, name: 'Velocity', requireDoubleRight: true},
                      {id: 5041216, name: 'Temperature', requireDoubleRight: true},
                      {id: 5041217, name: 'Density', requireDoubleRight: true},
                      {id: 5041218, name: 'External Pressure', requireDoubleRight: true},
                      {id: 5041219, name: 'External Temperature', requireDoubleRight: true},
                      {id: 5041220, name: 'External Density', requireDoubleRight: true},
                      {id: 5041221, name: 'FI Flow Rate', requireDoubleRight: true},
                      {id: 5041222, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
                      {id: 5041223, name: 'Referred Density', requireDoubleRight: true},
                      {id: 5041224, name: 'Referred Volume Flow', requireDoubleRight: true},
                      {id: 5041225, name: 'Avg. Line Density', requireDoubleRight: true},
                      {id: 5041226, name: 'Avg. Temperature', requireDoubleRight: true},
                      {id: 5041227, name: 'Referred Density', requireDoubleRight: true},
                      {id: 5041228, name: 'Specific Gravity', requireDoubleRight: true},
                      {id: 5041229, name: 'Standard Vol Flow', requireDoubleRight: true},
                      {id: 5041230, name: 'Net Mass Flow', requireDoubleRight: true},
                      {id: 5041231, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                      {id: 5041232, name: 'Concentration', requireDoubleRight: true},
                      {id: 5041233, name: '% of Fill', requireDoubleRight: true},
                      {id: 5041234, name: 'PV_FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                      {id: 5041235, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                      {id: 5041236, name: 'PV_WATERCUT_AT_LINE', requireDoubleRight: true},
                      {id: 5041237, name: 'PV_EXT_WATERCUT', requireDoubleRight: true},
                      {id: 5041238, name: 'PV_NET_FLOW_WATER_AT_LINE', requireDoubleRight: true},
                      {id: 5041239, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                      {id: 5041240, name: 'PV_WATERCUT_AT_REF', requireDoubleRight: true},
                      {id: 5041241, name: 'PV_NET_FLOW_WATER_AT_REF', requireDoubleRight: true},
                      {id: 5041242, name: 'PV_GAS_VOID_FRACTION', requireDoubleRight: true},
                      {id: 5041243, name: 'PV_UNREM_MASS_FLOW', requireDoubleRight: true},
                      {id: 5041244, name: 'PV_UNREM_VOL_FLOW', requireDoubleRight: true},
                      {id: 5041245, name: 'PV_UNREM_DENSITY', requireDoubleRight: true},
                      {id: 5041246, name: 'PV_DEN_CALORIFIC_VALUE', requireDoubleRight: true},
                      {id: 5041247, name: 'PV_DEN_ENERGY_FLOW', requireDoubleRight: true},
                      {id: 5041248, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 5041249, name: 'PV_NOC_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 5041250, name: 'PV_NOC_AVE_UNC_OIL_FLOW', requireDoubleRight: true},
                      {id: 5041251, name: 'PV_NOC_AVE_UNC_WATER_CUT', requireDoubleRight: true},
                      {id: 5041252, name: 'PV_NOC_AVE_UNC_GROSS_FLOW', requireDoubleRight: true},
                      {id: 5041253, name: 'PV_NOC_AVE_UNC_WATER_FLOW', requireDoubleRight: true},
                      {id: 5041254, name: 'PV_NOC_AVE_UNC_BACK_FLOW', requireDoubleRight: true},
                      {id: 5041255, name: 'PV_NOC_AVE_NET_OIL_FLOW', requireDoubleRight: true},
                      {id: 5041256, name: 'PV_NOC_AVE_NET_WATER_CUT', requireDoubleRight: true},
                      {id: 5041257, name: 'PV_NOC_AVE_NET_GROSS_FLOW', requireDoubleRight: true},
                      {id: 5041258, name: 'PV_NOC_AVE_NET_WATER_FLOW', requireDoubleRight: true},
                      {id: 5041259, name: 'PV_NOC_AVE_DENSITY', requireDoubleRight: true},
                      {id: 5041260, name: 'PV_NOC_AVE_TEMPERATURE', requireDoubleRight: true},
                      {id: 5041261, name: 'PV_NOC_AVE_MASS_FLOW', requireDoubleRight: true},
                      {id: 5041262, name: 'PV_TMR_LIQUID_FLOW', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 5412112,
                    name: 'Direction',
                    children: [
                      {id: 50412201, name: 'Normal', requireDoubleRight: true},
                      {id: 50412202, name: 'Absolute Value', requireDoubleRight: true},
                    ],
                  },
                  {id: 5412113, name: 'Lower Range Value', component: <LowerRangeTN />},
                  {id: 5412114, name: 'Upper Range Value', component: <UpperRangeTN />},
                  {id: 5412115, name: 'MAO Cutoff', component: <MAOCutoffTN />},
                  {id: 5412116, name: 'MAO Damping', component: <MAODampingTN />},
                  {
                    id: 5412117,
                    name: 'Fault Action',
                    children: [
                      {id: 5041271, name: 'Upscale', requireDoubleRight: true},
                      {id: 5041272, name: 'Downscale', requireDoubleRight: true},
                      {id: 5041273, name: 'Internal Zero', requireDoubleRight: true},
                      {id: 5041274, name: 'None', requireDoubleRight: true},
                    ],
                  },
                  {id: 5412118, name: 'Fault Level', component: <FaultLevelTN />},
                ],
              },
              {
                id: 5333,
                name: 'Power',
                children: [
                  {id: 5051271, name: 'Active', requireDoubleRight: true},
                  {id: 5051272, name: 'Passive', requireDoubleRight: true},
                ],
              },
            ],
          },
          {
            id: 534,
            name: 'Channel D',
            children: [
              {
                id: 5341,
                name: 'I/O Type',
                children: [
                  {id: 53411, name: 'Frequency Output 2', subName: 'FO2', requireDoubleRight: true},
                  {id: 53412, name: 'Discrete Output 2', subName: 'DO2', requireDoubleRight: true},
                  {id: 53413, name: 'Discrete Output 3', subName: 'DO3', requireDoubleRight: true},
                  {id: 53414, name: 'Discrete Input 2', subName: 'DI2', requireDoubleRight: true},
                  {id: 53415, name: 'Milliamp Input 1', subName: 'MAI1', requireDoubleRight: true},
                  {id: 53416, name: 'Frequency Input', subName: 'MO2', requireDoubleRight: true},
                  {id: 53417, name: 'None', requireDoubleRight: true},
                ],
              },
              {
                id: 5342,
                name: 'I/O Settings',
                children: [
                  {
                    id: 5512111,
                    name: 'Source',
                    children: [
                      {id: 5141211, name: 'Basic Event 1', requireDoubleRight: true},
                      {id: 5141212, name: 'Basic Event 2', requireDoubleRight: true},
                      {id: 5141213, name: 'PV_APM_REMEDIATION', requireDoubleRight: true},
                      {id: 5141214, name: 'Enhanced Event 1', requireDoubleRight: true},
                      {id: 5141215, name: 'Enhanced Event 2', requireDoubleRight: true},
                      {id: 5141216, name: 'Enhanced Event 3', requireDoubleRight: true},
                      {id: 5141217, name: 'Enhanced Event 4', requireDoubleRight: true},
                      {id: 5141218, name: 'Enhanced Event 5', requireDoubleRight: true},
                      {id: 5141219, name: 'Flow Direction', requireDoubleRight: true},
                      {id: 5141220, name: 'Zero in Progress', requireDoubleRight: true},
                      {id: 5141221, name: 'Fault', requireDoubleRight: true},
                      {id: 5141222, name: 'PV_MV_FAIL', requireDoubleRight: true},
                      {id: 5141223, name: 'PV_BATCH_PRIMARY_VALVE', requireDoubleRight: true},
                      {id: 5141224, name: 'PV_BATCH_SECONDARY_VALVE', requireDoubleRight: true},
                      {id: 5141225, name: 'PV_BATCH_PUMP', requireDoubleRight: true},
                      {id: 5141226, name: 'PV_CTE_PRINT_FAIL', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 5512112,
                    name: 'Polarity',
                    children: [
                      {id: 51412201, name: 'Active Low', requireDoubleRight: true},
                      {id: 51412202, name: 'Active High', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 5512113,
                    name: 'Fault Action',
                    children: [
                      {id: 5141271, name: 'Upscale', requireDoubleRight: true},
                      {id: 5141272, name: 'Downscale', requireDoubleRight: true},
                      {id: 5141273, name: 'None', requireDoubleRight: true},
                    ],
                  },
                ],
              },
              {
                id: 5343,
                name: 'Power',
                children: [
                  {id: 5151271, name: 'Active', requireDoubleRight: true},
                  {id: 5151272, name: 'Passive', requireDoubleRight: true},
                ],
              },
            ],
          },
          {
            id: 535,
            name: 'Channel E',
            children: [
              {
                id: 5351,
                name: 'Printer',
                children: [
                  {
                    id: 53511,
                    name: 'Printer Type',
                    children: [
                      {id: 535111, name: 'PRINTER_NONE', requireDoubleRight: true},
                      {id: 535112, name: 'PRINTER_EPSON_TMT88', requireDoubleRight: true},
                      {id: 535113, name: 'PRINTER_EPSON', requireDoubleRight: true},
                      {id: 535114, name: 'PRINTER_DIGITEC', requireDoubleRight: true},
                      {id: 535115, name: 'PRINTER_TERMINAL', requireDoubleRight: true},
                      {id: 535116, name: 'PRINTER_GENERIC', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 53512,
                    name: 'Printer IP Address',
                    children: [
                      {id: 535121, name: 'Left Most Octet', component: <LeftMost />},
                      {id: 535122, name: 'Left Middle Octet', component: <LeftMiddle />},
                      {id: 535123, name: 'Right Middle Octet', component: <RightMiddle />},
                      {id: 535124, name: 'Right Most Octet', component: <RightMost />},
                    ],
                  },
                  {
                    id: 53513,
                    name: 'Ticket Settings',
                    children: [
                      {id: 535131, name: 'No. of Batch Tickets', component: <BatchTicket />},
                      {
                        id: 535132,
                        name: 'Auto Print',
                        children: [
                          {id: 5351321, name: 'On', requireDoubleRight: true},
                          {id: 5351322, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {id: 535133, name: 'Batch Count Start No.', component: <BatchCountTN />},
                      {
                        id: 535134,
                        name: 'Transfer Ticket Settings',
                        children: [
                          {id: 5351341, name: 'BOL Start Number', component: <BatchCountTN />},
                          {id: 5351342, name: 'Number of Tickets', component: <NumberTicket />},
                          {
                            id: 5351343,
                            name: 'Print Condition',
                            children: [
                              {id: 53513431, name: 'PRINT_NoFlow', requireDoubleRight: true},
                              {id: 53513432, name: 'PRINT_WithFlow', requireDoubleRight: true},
                            ],
                          },
                          {
                            id: 5351344,
                            name: 'Print Form Feed',
                            children: [
                              {id: 53513441, name: 'On', requireDoubleRight: true},
                              {id: 53513442, name: 'Off', requireDoubleRight: true},
                            ],
                          },
                          {
                            id: 5351345,
                            name: 'Print Alarm Occurred',
                            children: [
                              {id: 53513451, name: 'On', requireDoubleRight: true},
                              {id: 53513452, name: 'Off', requireDoubleRight: true},
                            ],
                          },
                        ],
                      },
                      {id: 535135, name: 'Pre Header Codes', component: <FooterCodesTN />},
                      {
                        id: 535136,
                        name: 'Header Line 1',
                        children: [
                          {id: 5351361, name: 'Text', component: <TextTN />},
                          {
                            id: 5351362,
                            name: 'Number of Line Feeds',
                            component: <NumberLineFeeds1 />,
                          },
                          {
                            id: 5351363,
                            name: 'Font Size',
                            children: [
                              {id: 53513631, name: 'PRINT_NormalHeight', requireDoubleRight: true},
                              {id: 53513632, name: 'PRINT_DoubleHeight', requireDoubleRight: true},
                            ],
                          },
                        ],
                      },
                      {
                        id: 535137,
                        name: 'Header Line 2',
                        children: [
                          {id: 5351371, name: 'Text', component: <TextTN />},
                          {
                            id: 5351372,
                            name: 'Number of Line Feeds',
                            component: <NumberLineFeeds2 />,
                          },
                          {
                            id: 5351373,
                            name: 'Font Size',
                            children: [
                              {id: 53513731, name: 'PRINT_NormalHeight', requireDoubleRight: true},
                              {id: 53513732, name: 'PRINT_DoubleHeight', requireDoubleRight: true},
                            ],
                          },
                        ],
                      },
                      {
                        id: 535138,
                        name: 'Header Line 3',
                        children: [
                          {id: 5351381, name: 'Text', component: <TextTN />},
                          {
                            id: 5351382,
                            name: 'Number of Line Feeds',
                            component: <NumberLineFeeds3 />,
                          },
                          {
                            id: 5351383,
                            name: 'Font Size',
                            children: [
                              {id: 53513831, name: 'PRINT_NormalHeight', requireDoubleRight: true},
                              {id: 53513832, name: 'PRINT_DoubleHeight', requireDoubleRight: true},
                            ],
                          },
                        ],
                      },
                      {
                        id: 535139,
                        name: 'Header Line 4',
                        children: [
                          {id: 5351391, name: 'Text', component: <TextTN />},
                          {
                            id: 5351392,
                            name: 'Number of Line Feeds',
                            component: <NumberLineFeeds4 />,
                          },
                          {
                            id: 5351393,
                            name: 'Font Size',
                            children: [
                              {id: 53513931, name: 'PRINT_NormalHeight', requireDoubleRight: true},
                              {id: 53513932, name: 'PRINT_DoubleHeight', requireDoubleRight: true},
                            ],
                          },
                        ],
                      },
                      {
                        id: 535140,
                        name: 'Footer',
                        children: [
                          {id: 5351401, name: 'Text', component: <TextTN />},
                          {
                            id: 5351402,
                            name: 'Number of Line Feeds',
                            component: <NumberLineFeedsFooter />,
                          },
                          {
                            id: 5351403,
                            name: 'Font Size',
                            children: [
                              {id: 53514031, name: 'PRINT_NormalHeight', requireDoubleRight: true},
                              {id: 53514032, name: 'PRINT_DoubleHeight', requireDoubleRight: true},
                            ],
                          },
                        ],
                      },
                      {id: 535141, name: 'Post Footer Codes', component: <FooterCodesTN />},
                    ],
                  },
                  {id: 53514, name: 'Printer Test', component: <PrinterTest />},
                  {
                    id: 53515,
                    name: 'Printer Settings',
                    children: [
                      {
                        id: 535151,
                        name: 'Baud Rate',
                        children: [
                          {id: 5351511, name: 'BAUD_1200', requireDoubleRight: true},
                          {id: 5351512, name: 'BAUD_2400', requireDoubleRight: true},
                          {id: 5351513, name: 'BAUD_4800', requireDoubleRight: true},
                          {id: 5351514, name: 'BAUD_9600', requireDoubleRight: true},
                          {id: 5351515, name: 'BAUD_19200', requireDoubleRight: true},
                          {id: 5351516, name: 'BAUD_38400', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 535152,
                        name: 'Parity',
                        children: [
                          {id: 5351521, name: 'PARITY_NONE', requireDoubleRight: true},
                          {id: 5351522, name: 'PARITY_ODD', requireDoubleRight: true},
                          {id: 5351523, name: 'PARITY_EVEN', requireDoubleRight: true},
                        ],
                      },
                      {id: 535153, name: 'Data Bits', component: <DataBits />},
                      {id: 535154, name: 'Stop Bits', component: <StopBits />},
                      {id: 535155, name: 'Maximum Chars/Sec', component: <MaxCharsTN />},
                      {id: 535156, name: 'Printer Buffer Size', component: <BufferTN />},
                      {
                        id: 535157,
                        name: 'Paper Check',
                        children: [
                          {id: 5351571, name: 'Enabled', requireDoubleRight: true},
                          {id: 5351572, name: 'Disabled', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5352,
                name: 'Modbus',
                children: [
                  {id: 53521, name: 'Modbus Address', component: <ModbusTN />},
                  {
                    id: 53522,
                    name: 'Modbus Float Order',
                    children: [
                      {id: 535221, name: 'FLOAT_12_34', requireDoubleRight: true},
                      {id: 535222, name: 'FLOAT_34_12', requireDoubleRight: true},
                      {id: 535223, name: 'FLOAT_21_43', requireDoubleRight: true},
                      {id: 535224, name: 'FLOAT_43_21', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 53523,
                    name: 'Modbus Double Order',
                    children: [
                      {id: 535231, name: 'DOUBLE_1234_5678', requireDoubleRight: true},
                      {id: 535232, name: 'DOUBLE_3412_7856', requireDoubleRight: true},
                      {id: 535233, name: 'DOUBLE_2143_6587', requireDoubleRight: true},
                      {id: 535234, name: 'DOUBLE_4321_8765', requireDoubleRight: true},
                      {id: 535235, name: 'DOUBLE_5678_1234', requireDoubleRight: true},
                      {id: 535236, name: 'DOUBLE_7856_3412', requireDoubleRight: true},
                      {id: 535237, name: 'DOUBLE_6587_2143', requireDoubleRight: true},
                      {id: 535238, name: 'DOUBLE_8765_4321', requireDoubleRight: true},
                    ],
                  },
                ],
              },
              {
                id: 5353,
                name: 'Fault Action',
                children: [
                  {id: 53531, name: 'COMM_FAULT_UPSCALE', requireDoubleRight: true},
                  {id: 53532, name: 'COMM_FAULT_DOWNSCALE', requireDoubleRight: true},
                  {id: 53533, name: 'COMM_FAULT_ZERO', requireDoubleRight: true},
                  {id: 53534, name: 'COMM_FAULT_NAN', requireDoubleRight: true},
                  {id: 53535, name: 'COMM_FAULT_FLOWONLY_ZERO', requireDoubleRight: true},
                  {id: 53536, name: 'COMM_FAULT_NONE', requireDoubleRight: true},
                ],
              },
            ],
          },
        ],
      },
      {
        id: 54,
        name: 'Display Settings',
        children: [
          {
            id: 541,
            name: 'Language',
            children: [
              {id: 5411, name: 'English', requireDoubleRight: true},
              {id: 5412, name: '中文', requireDoubleRight: true},
              {id: 5413, name: 'Español', requireDoubleRight: true},
              {id: 5414, name: 'Deutsch', requireDoubleRight: true},
              {id: 5415, name: 'Français', requireDoubleRight: true},
              {id: 5416, name: '日本語', requireDoubleRight: true},
              {id: 5417, name: 'Русский', requireDoubleRight: true},
              {id: 5418, name: 'Português', requireDoubleRight: true},
            ],
          },
          {
            id: 542,
            name: 'Display Variables',
            children: [
              {id: 5421, name: '1-Value View'},
              {id: 5422, name: '2-Value View'},
            ],
          },
          {
            id: 543,
            name: 'Decimals on Display',
            children: [
              {id: 5431, name: 'Mass Flow Rate', component: <DecimalsOnDisplay />},
              {id: 5432, name: 'Volume Flow Rate', component: <DecimalsOnDisplay />},
              {id: 5433, name: 'GSV Flow Rate', component: <DecimalsOnDisplay />},
              {id: 5434, name: 'Density', component: <DecimalsOnDisplay />},
              {id: 5435, name: 'Temperature', component: <DecimalsOnDisplay />},
              {id: 5436, name: 'Referred Density', component: <DecimalsOnDisplay />},
              {id: 5437, name: 'Referred Volume Flow', component: <DecimalsOnDisplay />},
              {id: 5438, name: 'Average Line Density', component: <DecimalsOnDisplay />},
              {id: 5439, name: 'Average Temperature', component: <DecimalsOnDisplay />},
              {id: 5440, name: 'CTPL', component: <DecimalsOnDisplay />},
              {id: 5441, name: 'Specific Gravity', component: <DecimalsOnDisplay />},
              {id: 5442, name: 'Standard Vol Flow', component: <DecimalsOnDisplay />},
              {id: 5443, name: 'Net Mass Flow', component: <DecimalsOnDisplay />},
              {id: 5444, name: 'Net Volume Flow Rate', component: <DecimalsOnDisplay />},
              {id: 5445, name: 'Concentration', component: <DecimalsOnDisplay />},
              {id: 5446, name: 'Mass Fwd Total', component: <DecimalsOnDisplay />},
              {id: 5447, name: 'Vol Fwd Total', component: <DecimalsOnDisplay />},
              {id: 5448, name: 'CorrVol Fwd Total', component: <DecimalsOnDisplay />},
              {id: 5449, name: 'GasVol Fwd Total', component: <DecimalsOnDisplay />},
              {id: 5450, name: 'StdVol Fwd Total', component: <DecimalsOnDisplay />},
              {id: 5451, name: 'NetMass Fwd Total', component: <DecimalsOnDisplay />},
              {id: 5452, name: 'NetVol Fwd Total', component: <DecimalsOnDisplay />},
              {id: 5453, name: 'Mass Fwd Inv', component: <DecimalsOnDisplay />},
              {id: 5454, name: 'Vol Fwd Inv', component: <DecimalsOnDisplay />},
              {id: 5455, name: 'CorrVol Fwd Inv', component: <DecimalsOnDisplay />},
              {id: 5456, name: 'GasVol Fwd Inv', component: <DecimalsOnDisplay />},
              {id: 5457, name: 'StdVol Fwd Inv', component: <DecimalsOnDisplay />},
              {id: 5458, name: 'NetMass Fwd Inv', component: <DecimalsOnDisplay />},
              {id: 5459, name: 'NetVol Fwd Inv', component: <DecimalsOnDisplay />},
              {id: 5460, name: 'Velocity', component: <DecimalsOnDisplay />},
              {id: 5461, name: 'Tube Frequency', component: <DecimalsOnDisplay />},
              {id: 5462, name: 'Drive Gain', component: <DecimalsOnDisplay />},
              {id: 5463, name: 'Case Temperature', component: <DecimalsOnDisplay />},
              {id: 5464, name: 'LPO Amplitude', component: <DecimalsOnDisplay />},
              {id: 5465, name: 'RPO Amplitude', component: <DecimalsOnDisplay />},
              {id: 5466, name: 'Field Verification Zero', component: <DecimalsOnDisplay />},
              {id: 5467, name: 'Board Temperature', component: <DecimalsOnDisplay />},
              {id: 5468, name: 'Input Voltage', component: <DecimalsOnDisplay />},
              {id: 5469, name: 'External Pressure', component: <DecimalsOnDisplay />},
              {id: 5470, name: 'External Temperature', component: <DecimalsOnDisplay />},
              {id: 5471, name: 'Live Zero', component: <DecimalsOnDisplay />},
              {id: 5472, name: 'Unremediated Mass Flow', component: <DecimalsOnDisplay />},
              {id: 5473, name: 'Unremediated Vol Flow', component: <DecimalsOnDisplay />},
              {id: 5474, name: 'Unremediated Density', component: <DecimalsOnDisplay />},
              {id: 5475, name: 'External Density', component: <DecimalsOnDisplay />},
              {id: 5476, name: 'Calorific Value', component: <DecimalsOnDisplay />},
              {id: 5477, name: 'Energy Flow', component: <DecimalsOnDisplay />},
              {id: 5478, name: 'NetOilFlow @ Line', component: <DecimalsOnDisplay />},
              {id: 5479, name: 'NetWaterFlow @ Line', component: <DecimalsOnDisplay />},
              {id: 5480, name: 'NetOilFlow @ Ref', component: <DecimalsOnDisplay />},
              {id: 5481, name: 'NetWaterFlow @ Ref', component: <DecimalsOnDisplay />},
            ],
          },
          {
            id: 544,
            name: 'Auto Scroll',
            children: [
              {id: 54411, name: 'On', requireDoubleRight: true},
              {id: 54412, name: 'Off', requireDoubleRight: true},
            ],
          },
          {id: 545, name: 'Scroll Rate', component: <ScrollRate />},
          {id: 546, name: 'Refresh Rate', component: <RefreshRateTN />},
          {
            id: 547,
            name: 'Backlight',
            children: [
              {id: 54711, name: 'On', requireDoubleRight: true},
              {id: 54712, name: 'Off', requireDoubleRight: true},
            ],
          },
          {id: 548, name: 'Screen Brightness', component: <ScreenBrightness />},
          {id: 549, name: 'Screen Contrast', component: <ScreenContrast />},
          {
            id: 550,
            name: 'Button Sensitivity',
            children: [
              {id: 5501, name: '( &lt ) Sensitivity', component: <LeftSensitivity />},
              {id: 5502, name: '( ^ ) Sensitivity', component: <UpSensitivity />},
              {id: 5503, name: '( v ) Sensitivity', component: <DownSensitivity />},
              {id: 5504, name: '( &gt ) Sensitivity', component: <RightSensitivity />},
            ],
          },
        ],
      },
      {
        id: 55,
        name: 'Alert Setup',
        children: [
          {
            id: 551,
            name: 'Output Fault Actions',
            children: [
              {id: 5511, name: 'Fault Timeout (sec)', component: <FaultTimeout />},
              {id: 5512, name: 'Channel A'},
              {id: 5513, name: 'Channel B'},
              {id: 5514, name: 'Channel C'},
              {id: 5515, name: 'Channel D'},
              {id: 5516, name: 'Channel E'},
              {
                id: 5517,
                name: 'Digital Comm.',
                children: [
                  {id: 55171, name: 'COMM_FAULT_UPSCALE', requireDoubleRight: true},
                  {id: 55172, name: 'COMM_FAULT_DOWNSCALE', requireDoubleRight: true},
                  {id: 55173, name: 'COMM_FAULT_ZERO', requireDoubleRight: true},
                  {id: 55174, name: 'COMM_FAULT_NAN', requireDoubleRight: true},
                  {id: 55175, name: 'COMM_FAULT_FLOWONLY_ZERO', requireDoubleRight: true},
                  {id: 55176, name: 'COMM_FAULT_NONE', requireDoubleRight: true},
                ],
              },
            ],
          },
          {
            id: 552,
            name: 'Response to Alerts',
            children: [
              {
                id: 5521,
                name: 'Configuration Error',
                children: [
                  {
                    id: 55211,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552111,
                        name: 'Bad Core Software',
                        children: [
                          {id: 5521111, name: '0', requireDoubleRight: true},
                          {id: 5521112, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552112,
                        name: 'Time Not Set',
                        children: [
                          {id: 5521121, name: '0', requireDoubleRight: true},
                          {id: 5521122, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552113,
                        name: 'Batch Not Configured',
                        children: [
                          {id: 5521131, name: '0', requireDoubleRight: true},
                          {id: 5521132, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5522,
                name: 'Security Breach',
                children: [
                  {
                    id: 55221,
                    name: 'Alert Severity',
                    children: [
                      {id: 552211, name: 'Failure', requireDoubleRight: true},
                      {id: 552212, name: 'Out of Specification', requireDoubleRight: true},
                      {id: 552213, name: 'Maintenance Req', requireDoubleRight: true},
                      {id: 552214, name: 'Function Check', requireDoubleRight: true},
                    ],
                  },
                ],
              },
              {
                id: 5523,
                name: 'Tube Not Full',
                children: [
                  getAlertDetection(55231, 552311, 552312),
                  getAlertSeverity(55232, 552321, 552322, 552323, 552324),
                  {
                    id: 55233,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552331,
                        name: '[033] Low Pickoff Sig.',
                        children: [
                          {id: 5523311, name: '0', requireDoubleRight: true},
                          {id: 5523312, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5524,
                name: 'Function Check in Progress',
                children: [
                  {
                    id: 55241,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552411,
                        name: '[131] Outputs to LMV',
                        children: [
                          {id: 5524111, name: '0', requireDoubleRight: true},
                          {id: 5524112, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5525,
                name: 'Output Fixed',
                children: [
                  getAlertDetection(55251, 552511, 552512),
                  getAlertSeverity(55252, 552521, 552522, 552523, 552524),
                  {
                    id: 55253,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552531,
                        name: '[101] MAO1 Fixed',
                        children: [
                          {id: 5525311, name: '0', requireDoubleRight: true},
                          {id: 5525312, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5526,
                name: 'Drive Overrange',
                children: [
                  getAlertDetection(55261, 552611, 552612),
                  getAlertSeverity(55262, 552621, 552622, 552623, 552624),
                  {
                    id: 55263,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552631,
                        name: '[102] Drive Overrange',
                        children: [
                          {id: 5526311, name: '0', requireDoubleRight: true},
                          {id: 5526312, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5527,
                name: 'Process Aberration',
                children: [
                  getAlertDetection(55271, 552711, 552712),
                  getAlertSeverity(55272, 552721, 552722, 552723, 552724),
                  {
                    id: 55273,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552731,
                        name: '[105] Two-Phase Flow',
                        children: [
                          {id: 5527311, name: '0', requireDoubleRight: true},
                          {id: 5527312, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552732,
                        name: '[140] Remediation Active',
                        children: [
                          {id: 5527321, name: '0', requireDoubleRight: true},
                          {id: 5527322, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552733,
                        name: '[115] No Input',
                        children: [
                          {id: 5527331, name: '0', requireDoubleRight: true},
                          {id: 5527332, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552734,
                        name: '[121] Extrapol. Alert',
                        children: [
                          {id: 5527341, name: '0', requireDoubleRight: true},
                          {id: 5527342, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552735,
                        name: '[116] Temp OOR',
                        children: [
                          {id: 5527351, name: '0', requireDoubleRight: true},
                          {id: 5527352, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552736,
                        name: '[117] Density OOR',
                        children: [
                          {id: 5527361, name: '0', requireDoubleRight: true},
                          {id: 5527362, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552737,
                        name: '[123] Pressure OOR',
                        children: [
                          {id: 5527371, name: '0', requireDoubleRight: true},
                          {id: 5527372, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552738,
                        name: 'MAI Input Failure',
                        children: [
                          {id: 5527381, name: '0', requireDoubleRight: true},
                          {id: 5527382, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552739,
                        name: 'Moderate Two-Phase',
                        children: [
                          {id: 5527391, name: '0', requireDoubleRight: true},
                          {id: 5527392, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552740,
                        name: 'Severe Two-Phase',
                        children: [
                          {id: 5527401, name: '0', requireDoubleRight: true},
                          {id: 5527402, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552741,
                        name: 'Batch Timeout',
                        children: [
                          {id: 5527411, name: '0', requireDoubleRight: true},
                          {id: 5527412, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552742,
                        name: 'Watercut unavailable.',
                        children: [
                          {id: 5527421, name: '0', requireDoubleRight: true},
                          {id: 5527422, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5528,
                name: 'Event Active',
                children: [
                  getAlertDetection(55281, 552811, 552812),
                  getAlertSeverity(55282, 552821, 552822, 552823, 552824),
                  {
                    id: 55283,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552831,
                        name: 'Enhanced Event 1 ON',
                        children: [
                          {id: 5528311, name: '0', requireDoubleRight: true},
                          {id: 5528312, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552832,
                        name: 'Enhanced Event 2 ON',
                        children: [
                          {id: 5528321, name: '0', requireDoubleRight: true},
                          {id: 5528322, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552833,
                        name: 'Enhanced Event 3 ON',
                        children: [
                          {id: 5528331, name: '0', requireDoubleRight: true},
                          {id: 5528332, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552834,
                        name: 'Enhanced Event 4 ON',
                        children: [
                          {id: 5528341, name: '0', requireDoubleRight: true},
                          {id: 5528342, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552835,
                        name: 'Enhanced Event 5 ON',
                        children: [
                          {id: 5528351, name: '0', requireDoubleRight: true},
                          {id: 5528352, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552836,
                        name: '[108] Event 1 ON',
                        children: [
                          {id: 5528361, name: '0', requireDoubleRight: true},
                          {id: 5528362, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552837,
                        name: '[109] Event 2 ON',
                        children: [
                          {id: 5528371, name: '0', requireDoubleRight: true},
                          {id: 5528372, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5529,
                name: 'Output Saturated',
                children: [
                  getAlertDetection(55291, 552911, 552912),
                  getAlertSeverity(55292, 552921, 552922, 552923, 552924),
                  {
                    id: 55293,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 552931,
                        name: '[100] MAO1 Saturated',
                        children: [
                          {id: 5529311, name: '0', requireDoubleRight: true},
                          {id: 5529312, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552932,
                        name: '[113] MAO2 Saturated',
                        children: [
                          {id: 5529321, name: '0', requireDoubleRight: true},
                          {id: 5529322, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552933,
                        name: 'MAO3 Saturated',
                        children: [
                          {id: 5529331, name: '0', requireDoubleRight: true},
                          {id: 5529332, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552934,
                        name: '[110] FO1 Saturated',
                        children: [
                          {id: 5529341, name: '0', requireDoubleRight: true},
                          {id: 5529342, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552935,
                        name: 'FO2 Saturated',
                        children: [
                          {id: 5529351, name: '0', requireDoubleRight: true},
                          {id: 5529352, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552936,
                        name: '[124] FI Saturated',
                        children: [
                          {id: 5529361, name: '0', requireDoubleRight: true},
                          {id: 5529362, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552937,
                        name: 'Watercut limited to 100%.',
                        children: [
                          {id: 5529371, name: '0', requireDoubleRight: true},
                          {id: 5529372, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 552938,
                        name: 'Watercut limited to 0%.',
                        children: [
                          {id: 5529381, name: '0', requireDoubleRight: true},
                          {id: 5529382, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5530,
                name: 'Function Check Fail',
                children: [
                  getAlertDetection(55301, 553011, 553012),
                  getAlertSeverity(55302, 553021, 553022, 553023, 553024),
                  {
                    id: 55303,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 553031,
                        name: '[034] SMV Failed',
                        children: [
                          {id: 5530311, name: '0', requireDoubleRight: true},
                          {id: 5530312, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553032,
                        name: '[035] SMV Aborted',
                        children: [
                          {id: 5530321, name: '0', requireDoubleRight: true},
                          {id: 5530322, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553033,
                        name: '[130] Paper Out/Printer Offline',
                        children: [
                          {id: 5530331, name: '0', requireDoubleRight: true},
                          {id: 5530332, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5531,
                name: 'Configuration Warning',
                children: [
                  getAlertDetection(55311, 553111, 553112),
                  getAlertSeverity(55312, 553121, 553122, 553123, 553124),
                  {
                    id: 55313,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 553131,
                        name: 'Firmware Update Fail',
                        children: [
                          {id: 5531311, name: '0', requireDoubleRight: true},
                          {id: 5531312, name: '1', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553132,
                        name: '[103] Data Loss Poss.',
                        children: [
                          {id: 5531321, name: '0', requireDoubleRight: true},
                          {id: 5531322, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5532,
                name: 'Disp Read Fail',
                children: [
                  getAlertDetection(55321, 553211, 553212),
                  getAlertSeverity(55322, 553221, 553222, 553223, 553224),
                  {
                    id: 55323,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 553231,
                        name: '[129] Display Readback Fail',
                        children: [
                          {id: 5532311, name: '0', requireDoubleRight: true},
                          {id: 5532312, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 5533,
                name: 'Disp Comm Error',
                children: [
                  getAlertDetection(55331, 553311, 553312),
                  getAlertSeverity(55332, 553321, 553322, 553323, 553324),
                  {
                    id: 55333,
                    name: 'Condition Detection',
                    children: [
                      {
                        id: 553331,
                        name: '[135] Display Comm Error',
                        children: [
                          {id: 5533311, name: '0', requireDoubleRight: true},
                          {id: 5533312, name: '1', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 553,
            name: 'Enhanced Events',
            children: [
              {
                id: 5531111,
                name: 'Flow Rate Switch',
                children: [
                  {
                    id: 55311111,
                    name: 'Variable',
                    children: [
                      {id: 55333111, name: 'Mass Flow Rate', requireDoubleRight: true},
                      {id: 55333112, name: 'Volume Flow Rate', requireDoubleRight: true},
                      {id: 55333113, name: 'GSV Flow Rate', requireDoubleRight: true},
                      {id: 55333114, name: 'FI Flow Rate', requireDoubleRight: true},
                      {id: 55333115, name: 'Referred Volume Flow', requireDoubleRight: true},
                      {id: 55333116, name: 'Standard Vol Flow', requireDoubleRight: true},
                      {id: 55333117, name: 'Net Mass Flow', requireDoubleRight: true},
                      {id: 55333118, name: 'Net Volume Flow Rate', requireDoubleRight: true},
                      {id: 55333119, name: 'FUEL_DIFF_MASS_FLOW', requireDoubleRight: true},
                      {id: 55333120, name: 'PV_NET_FLOW_OIL_AT_LINE', requireDoubleRight: true},
                      {id: 55333121, name: 'PV_NET_FLOW_WATER_AT_LINE', requireDoubleRight: true},
                      {id: 55333122, name: 'PV_NET_FLOW_OIL_AT_REF', requireDoubleRight: true},
                      {id: 55333123, name: 'PV_NET_FLOW_WATER_AT_REF', requireDoubleRight: true},
                      {id: 55333124, name: 'PV_UNREM_MASS_FLOW', requireDoubleRight: true},
                      {id: 55333125, name: 'PV_UNREM_VOL_FLOW', requireDoubleRight: true},
                      {id: 55333126, name: 'PV_DEN_ENERGY_FLOW', requireDoubleRight: true},
                      {id: 55333127, name: 'PV_NOC_UNC_BACK_FLOW', requireDoubleRight: true},
                      {id: 55333128, name: 'PV_TMR_LIQUID_FLOW', requireDoubleRight: true},
                    ],
                  },
                  {id: 55311112, name: 'Setpoint', component: <SetpointTN />},
                  {id: 55311113, name: 'Hysteresis', component: <HysteresisTN />},
                ],
              },
              {
                id: 5531112,
                name: 'Enhanced Event 1',
                children: [
                  {
                    id: 55311121,
                    name: 'Variable',
                    children: [
                      {id: 553111211, name: 'Variable', requireDoubleRight: true},
                      {id: 553111212, name: 'Event Type', requireDoubleRight: true},
                      {id: 553111213, name: 'Setpoint A', requireDoubleRight: true},
                      {id: 553111214, name: 'Setpoint B', requireDoubleRight: true},
                      {id: 553111215, name: 'Assign Actions', requireDoubleRight: true},
                      {id: 553111216, name: 'Print Ticket Actions', requireDoubleRight: true},
                      {id: 553111217, name: 'Transfer Ticket Action', requireDoubleRight: true},
                      {id: 553111218, name: 'Reset Total 7', requireDoubleRight: true},
                      {id: 553111219, name: 'Increment Matrix', requireDoubleRight: true},
                      {id: 553111220, name: 'Reset All Totals', requireDoubleRight: true},
                      {id: 553111221, name: 'Start/stop all totalizers', requireDoubleRight: true},
                      {id: 553111222, name: 'Start/stop totalizer 1', requireDoubleRight: true},
                      {id: 553111223, name: 'Start/stop totalizer 2', requireDoubleRight: true},
                      {id: 553111224, name: 'Start/stop totalizer 3', requireDoubleRight: true},
                      {id: 553111225, name: 'Start/stop totalizer 4', requireDoubleRight: true},
                      {id: 553111226, name: 'Start/stop totalizer 5', requireDoubleRight: true},
                      {id: 553111227, name: 'Start/stop totalizer 6', requireDoubleRight: true},
                      {id: 553111228, name: 'Start/stop totalizer 7', requireDoubleRight: true},
                      {id: 553111229, name: 'Start/stop inv 1', requireDoubleRight: true},
                      {id: 553111230, name: 'Start/stop inv 2', requireDoubleRight: true},
                      {id: 553111231, name: 'Start/stop inv 3', requireDoubleRight: true},
                      {id: 553111232, name: 'Start/stop inv 4', requireDoubleRight: true},
                      {id: 553111233, name: 'Start/stop inv 5', requireDoubleRight: true},
                      {id: 553111234, name: 'Start/stop inv 6', requireDoubleRight: true},
                      {id: 553111235, name: 'Start/stop inv 7', requireDoubleRight: true},
                      {id: 553111236, name: 'Start SMV', requireDoubleRight: true},
                      {id: 553111237, name: 'Resume Batch', requireDoubleRight: true},
                      {id: 553111238, name: 'Pause Batch', requireDoubleRight: true},
                      {id: 553111239, name: 'Begin Batch', requireDoubleRight: true},
                      {id: 553111240, name: 'End Batch', requireDoubleRight: true},
                      {id: 553111241, name: 'Reset Batch Total', requireDoubleRight: true},
                      {id: 553111242, name: 'Inhibit Batch', requireDoubleRight: true},
                      {id: 553111243, name: 'Inhibit Totalizer', requireDoubleRight: true},
                      {id: 553111244, name: 'Inhibit Flow', requireDoubleRight: true},
                      {id: 553111245, name: 'Increment Preset', requireDoubleRight: true},
                      {id: 553111246, name: 'Print Ticket', requireDoubleRight: true},
                      {id: 553111247, name: 'Print Transfer Ticket', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 55311122,
                    name: 'Event Type',
                    children: [
                      {id: 5531112211, name: 'PC_LO', requireDoubleRight: true},
                      {id: 5531112222, name: 'PC_HI', requireDoubleRight: true},
                      {id: 5531112233, name: 'PC_IN_HI_LO', requireDoubleRight: true},
                      {id: 5531112244, name: 'PC_OUT_HI_LO', requireDoubleRight: true},
                    ],
                  },
                  {id: 55311123, name: 'Setpoint A', component: <SetpointATN />},
                  {id: 55311124, name: 'Setpoint B', component: <SetpointBTN />},
                  {
                    id: 55311125,
                    name: 'Assign Actions',
                    children: [
                      {
                        id: 553111251,
                        name: 'Start Zero Calibration',
                        children: [
                          {id: 5531112511, name: 'None', requireDoubleRight: true},
                          {id: 5531112512, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112513, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112514, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112515, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112516, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112517, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112518, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111252,
                        name: 'Reset Total 1',
                        children: [
                          {id: 5531112521, name: 'None', requireDoubleRight: true},
                          {id: 5531112522, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112523, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112524, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112525, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112526, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112527, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112528, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111253,
                        name: 'Reset Total 2',
                        children: [
                          {id: 5531112531, name: 'None', requireDoubleRight: true},
                          {id: 5531112532, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112533, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112534, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112535, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112536, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112537, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112538, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111254,
                        name: 'Reset Total 3',
                        children: [
                          {id: 5531112541, name: 'None', requireDoubleRight: true},
                          {id: 5531112542, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112543, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112544, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112545, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112546, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112547, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112548, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111255,
                        name: 'Reset Total 4',
                        children: [
                          {id: 5531112551, name: 'None', requireDoubleRight: true},
                          {id: 5531112552, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112553, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112554, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112555, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112556, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112557, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112558, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111256,
                        name: 'Reset Total 5',
                        children: [
                          {id: 5531112561, name: 'None', requireDoubleRight: true},
                          {id: 5531112562, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112563, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112564, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112565, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112566, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112567, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112568, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111257,
                        name: 'Reset Total 6',
                        children: [
                          {id: 5531112571, name: 'None', requireDoubleRight: true},
                          {id: 5531112572, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112573, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112574, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112575, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112576, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112577, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112578, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111258,
                        name: 'Reset Total 7',
                        children: [
                          {id: 5531112581, name: 'None', requireDoubleRight: true},
                          {id: 5531112582, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112583, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112584, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112585, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112586, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112587, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112588, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111259,
                        name: 'Increment Matrix',
                        children: [
                          {id: 5531112591, name: 'None', requireDoubleRight: true},
                          {id: 5531112592, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112593, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112594, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112595, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112596, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112597, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112598, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111260,
                        name: 'Reset All Totals',
                        children: [
                          {id: 5531112601, name: 'None', requireDoubleRight: true},
                          {id: 5531112602, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112603, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112604, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112605, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112606, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112607, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112608, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111261,
                        name: 'Start/stop all totalizers',
                        children: [
                          {id: 5531112611, name: 'None', requireDoubleRight: true},
                          {id: 5531112612, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112613, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112614, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112615, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112616, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112617, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112618, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111262,
                        name: 'Start/stop totalizer 1',
                        children: [
                          {id: 5531112621, name: 'None', requireDoubleRight: true},
                          {id: 5531112622, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112623, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112624, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112625, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112626, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112627, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112628, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111263,
                        name: 'Start/stop totalizer 2',
                        children: [
                          {id: 5531112631, name: 'None', requireDoubleRight: true},
                          {id: 5531112632, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112633, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112634, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112635, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112636, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112637, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112638, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111264,
                        name: 'Start/stop totalizer 3',
                        children: [
                          {id: 5531112641, name: 'None', requireDoubleRight: true},
                          {id: 5531112642, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112643, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112644, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112645, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112646, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112647, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112648, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111265,
                        name: 'Start/stop totalizer 4',
                        children: [
                          {id: 5531112651, name: 'None', requireDoubleRight: true},
                          {id: 5531112652, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112653, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112654, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112655, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112656, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112657, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112658, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111266,
                        name: 'Start/stop totalizer 5',
                        children: [
                          {id: 5531112661, name: 'None', requireDoubleRight: true},
                          {id: 5531112662, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112663, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112664, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112665, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112666, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112667, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112668, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111267,
                        name: 'Start/stop totalizer 6',
                        children: [
                          {id: 5531112671, name: 'None', requireDoubleRight: true},
                          {id: 5531112672, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112673, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112674, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112675, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112676, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112677, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112678, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111268,
                        name: 'Start/stop totalizer 7',
                        children: [
                          {id: 5531112681, name: 'None', requireDoubleRight: true},
                          {id: 5531112682, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112683, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112684, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112685, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112686, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112687, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112688, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111269,
                        name: 'Start/stop inv 1',
                        children: [
                          {id: 5531112691, name: 'None', requireDoubleRight: true},
                          {id: 5531112692, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112693, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112694, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112695, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112696, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112697, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112698, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111270,
                        name: 'Start/stop inv 2',
                        children: [
                          {id: 5531112701, name: 'None', requireDoubleRight: true},
                          {id: 5531112702, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112703, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112704, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112705, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112706, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112707, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112708, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111271,
                        name: 'Start/stop inv 3',
                        children: [
                          {id: 5531112711, name: 'None', requireDoubleRight: true},
                          {id: 5531112712, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112713, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112714, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112715, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112716, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112717, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112718, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111272,
                        name: 'Start/stop inv 4',
                        children: [
                          {id: 5531112721, name: 'None', requireDoubleRight: true},
                          {id: 5531112722, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112723, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112724, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112725, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112726, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112727, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112728, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111273,
                        name: 'Start/stop inv 5',
                        children: [
                          {id: 5531112731, name: 'None', requireDoubleRight: true},
                          {id: 5531112732, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112733, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112734, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112735, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112736, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112737, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112738, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111274,
                        name: 'Start/stop inv 6',
                        children: [
                          {id: 5531112741, name: 'None', requireDoubleRight: true},
                          {id: 5531112742, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112743, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112744, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112745, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112746, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112747, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112748, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111275,
                        name: 'Start/stop inv 7',
                        children: [
                          {id: 5531112751, name: 'None', requireDoubleRight: true},
                          {id: 5531112752, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112753, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112754, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112755, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112756, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112757, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112758, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111276,
                        name: 'Start SMV',
                        children: [
                          {id: 5531112761, name: 'None', requireDoubleRight: true},
                          {id: 5531112762, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112763, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112764, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112765, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112766, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112767, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112768, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111277,
                        name: 'Resume Batch',
                        children: [
                          {id: 5531112771, name: 'None', requireDoubleRight: true},
                          {id: 5531112772, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112773, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112774, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112775, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112776, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112777, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112778, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111278,
                        name: 'Pause Batch',
                        children: [
                          {id: 5531112781, name: 'None', requireDoubleRight: true},
                          {id: 5531112782, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112783, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112784, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112785, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112786, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112787, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112788, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111279,
                        name: 'Begin Batch',
                        children: [
                          {id: 5531112791, name: 'None', requireDoubleRight: true},
                          {id: 5531112792, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112793, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112794, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112795, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112796, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112797, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112798, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111280,
                        name: 'End Batch',
                        children: [
                          {id: 5531112801, name: 'None', requireDoubleRight: true},
                          {id: 5531112802, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112803, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112804, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112805, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112806, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112807, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112808, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111281,
                        name: 'Reset Batch Total',
                        children: [
                          {id: 5531112811, name: 'None', requireDoubleRight: true},
                          {id: 5531112812, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112813, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112814, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112815, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112816, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112817, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112818, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111282,
                        name: 'Inhibit Batch',
                        children: [
                          {id: 5531112821, name: 'None', requireDoubleRight: true},
                          {id: 5531112822, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112823, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112824, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112825, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112826, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112827, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112828, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111283,
                        name: 'Inhibit Totalizer',
                        children: [
                          {id: 5531112831, name: 'None', requireDoubleRight: true},
                          {id: 5531112832, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112833, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112834, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112835, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112836, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112837, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112838, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111284,
                        name: 'Inhibit Flow',
                        children: [
                          {id: 5531112841, name: 'None', requireDoubleRight: true},
                          {id: 5531112842, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112843, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112844, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112845, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112846, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112847, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112848, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111285,
                        name: 'Increment Preset',
                        children: [
                          {id: 5531112851, name: 'None', requireDoubleRight: true},
                          {id: 5531112852, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112853, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112854, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112855, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112856, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112857, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112858, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111286,
                        name: 'Print Ticket',
                        children: [
                          {id: 5531112861, name: 'None', requireDoubleRight: true},
                          {id: 5531112862, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112863, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112864, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112865, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112866, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112867, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112868, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111287,
                        name: 'Print Transfer Ticket',
                        children: [
                          {id: 5531112871, name: 'None', requireDoubleRight: true},
                          {id: 5531112872, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112873, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112874, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112875, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112876, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112877, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112878, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311126,
                    name: 'Print Ticket Actions',
                    children: [
                      {
                        id: 55311126111,
                        name: 'Print Process Screen',
                        children: [
                          {id: 553111261111, name: 'On', requireDoubleRight: true},
                          {id: 553111261122, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126211,
                        name: 'Print Batch Ticket',
                        children: [
                          {id: 553111262111, name: 'On', requireDoubleRight: true},
                          {id: 553111262112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126311,
                        name: 'Print Config Data',
                        children: [
                          {id: 553111263111, name: 'On', requireDoubleRight: true},
                          {id: 553111263112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126411,
                        name: 'Print Alert History',
                        children: [
                          {id: 553111264111, name: 'On', requireDoubleRight: true},
                          {id: 553111264112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126511,
                        name: 'Print Active Alerts',
                        children: [
                          {id: 553111265111, name: 'On', requireDoubleRight: true},
                          {id: 553111265112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126611,
                        name: 'Print Audit Trail',
                        children: [
                          {id: 553111266111, name: 'On', requireDoubleRight: true},
                          {id: 553111266112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126711,
                        name: 'Print Test Page',
                        children: [
                          {id: 553111267111, name: 'On', requireDoubleRight: true},
                          {id: 553111267112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126811,
                        name: 'Print Transfer Totals',
                        children: [
                          {id: 553111268111, name: 'On', requireDoubleRight: true},
                          {id: 553111268112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126911,
                        name: 'Print Transfer Inventories',
                        children: [
                          {id: 553111269111, name: 'On', requireDoubleRight: true},
                          {id: 553111269112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311127,
                    name: 'Transfer Ticket Action',
                    children: [
                      {
                        id: 55311127111,
                        name: 'PRINT_PrintMassandVolumeTransferTotals',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127222,
                        name: 'PRINT_PrintMassandVolumeInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127333,
                        name: 'PRINT_PrintMassandVolumeTransferTotalsandInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127444,
                        name: 'PRINT_PrintAPITransferTotalandInventory',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127555,
                        name: 'PRINT_PrintEDNetMasstotalandinventory',
                        requireDoubleRight: true,
                      },
                    ],
                  },
                ],
              },
              {
                id: 5531113,
                name: 'Enhanced Event 2',
                children: [
                  {
                    id: 5531112111,
                    name: 'Variable',
                    children: [
                      {id: 553111211, name: 'Variable', requireDoubleRight: true},
                      {id: 553111212, name: 'Event Type', requireDoubleRight: true},
                      {id: 553111213, name: 'Setpoint A', requireDoubleRight: true},
                      {id: 553111214, name: 'Setpoint B', requireDoubleRight: true},
                      {id: 553111215, name: 'Assign Actions', requireDoubleRight: true},
                      {id: 553111216, name: 'Print Ticket Actions', requireDoubleRight: true},
                      {id: 553111217, name: 'Transfer Ticket Action', requireDoubleRight: true},
                      {id: 553111218, name: 'Reset Total 7', requireDoubleRight: true},
                      {id: 553111219, name: 'Increment Matrix', requireDoubleRight: true},
                      {id: 553111220, name: 'Reset All Totals', requireDoubleRight: true},
                      {id: 553111221, name: 'Start/stop all totalizers', requireDoubleRight: true},
                      {id: 553111222, name: 'Start/stop totalizer 1', requireDoubleRight: true},
                      {id: 553111223, name: 'Start/stop totalizer 2', requireDoubleRight: true},
                      {id: 553111224, name: 'Start/stop totalizer 3', requireDoubleRight: true},
                      {id: 553111225, name: 'Start/stop totalizer 4', requireDoubleRight: true},
                      {id: 553111226, name: 'Start/stop totalizer 5', requireDoubleRight: true},
                      {id: 553111227, name: 'Start/stop totalizer 6', requireDoubleRight: true},
                      {id: 553111228, name: 'Start/stop totalizer 7', requireDoubleRight: true},
                      {id: 553111229, name: 'Start/stop inv 1', requireDoubleRight: true},
                      {id: 553111230, name: 'Start/stop inv 2', requireDoubleRight: true},
                      {id: 553111231, name: 'Start/stop inv 3', requireDoubleRight: true},
                      {id: 553111232, name: 'Start/stop inv 4', requireDoubleRight: true},
                      {id: 553111233, name: 'Start/stop inv 5', requireDoubleRight: true},
                      {id: 553111234, name: 'Start/stop inv 6', requireDoubleRight: true},
                      {id: 553111235, name: 'Start/stop inv 7', requireDoubleRight: true},
                      {id: 553111236, name: 'Start SMV', requireDoubleRight: true},
                      {id: 553111237, name: 'Resume Batch', requireDoubleRight: true},
                      {id: 553111238, name: 'Pause Batch', requireDoubleRight: true},
                      {id: 553111239, name: 'Begin Batch', requireDoubleRight: true},
                      {id: 553111240, name: 'End Batch', requireDoubleRight: true},
                      {id: 553111241, name: 'Reset Batch Total', requireDoubleRight: true},
                      {id: 553111242, name: 'Inhibit Batch', requireDoubleRight: true},
                      {id: 553111243, name: 'Inhibit Totalizer', requireDoubleRight: true},
                      {id: 553111244, name: 'Inhibit Flow', requireDoubleRight: true},
                      {id: 553111245, name: 'Increment Preset', requireDoubleRight: true},
                      {id: 553111246, name: 'Print Ticket', requireDoubleRight: true},
                      {id: 553111247, name: 'Print Transfer Ticket', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 55311122,
                    name: 'Event Type',
                    children: [
                      {id: 5531112211, name: 'PC_LO', requireDoubleRight: true},
                      {id: 5531112222, name: 'PC_HI', requireDoubleRight: true},
                      {id: 5531112233, name: 'PC_IN_HI_LO', requireDoubleRight: true},
                      {id: 5531112244, name: 'PC_OUT_HI_LO', requireDoubleRight: true},
                    ],
                  },
                  {id: 55311123, name: 'Setpoint A', component: <SetpointATN />},
                  {id: 55311124, name: 'Setpoint B', component: <SetpointBTN />},
                  {
                    id: 55311125,
                    name: 'Assign Actions',
                    children: [
                      {
                        id: 553111251,
                        name: 'Start Zero Calibration',
                        children: [
                          {id: 5531112511, name: 'None', requireDoubleRight: true},
                          {id: 5531112512, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112513, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112514, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112515, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112516, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112517, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112518, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111252,
                        name: 'Reset Total 1',
                        children: [
                          {id: 5531112521, name: 'None', requireDoubleRight: true},
                          {id: 5531112522, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112523, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112524, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112525, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112526, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112527, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112528, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111253,
                        name: 'Reset Total 2',
                        children: [
                          {id: 5531112531, name: 'None', requireDoubleRight: true},
                          {id: 5531112532, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112533, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112534, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112535, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112536, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112537, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112538, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111254,
                        name: 'Reset Total 3',
                        children: [
                          {id: 5531112541, name: 'None', requireDoubleRight: true},
                          {id: 5531112542, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112543, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112544, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112545, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112546, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112547, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112548, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111255,
                        name: 'Reset Total 4',
                        children: [
                          {id: 5531112551, name: 'None', requireDoubleRight: true},
                          {id: 5531112552, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112553, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112554, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112555, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112556, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112557, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112558, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111256,
                        name: 'Reset Total 5',
                        children: [
                          {id: 5531112561, name: 'None', requireDoubleRight: true},
                          {id: 5531112562, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112563, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112564, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112565, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112566, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112567, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112568, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111257,
                        name: 'Reset Total 6',
                        children: [
                          {id: 5531112571, name: 'None', requireDoubleRight: true},
                          {id: 5531112572, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112573, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112574, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112575, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112576, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112577, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112578, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111258,
                        name: 'Reset Total 7',
                        children: [
                          {id: 5531112581, name: 'None', requireDoubleRight: true},
                          {id: 5531112582, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112583, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112584, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112585, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112586, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112587, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112588, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111259,
                        name: 'Increment Matrix',
                        children: [
                          {id: 5531112591, name: 'None', requireDoubleRight: true},
                          {id: 5531112592, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112593, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112594, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112595, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112596, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112597, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112598, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111260,
                        name: 'Reset All Totals',
                        children: [
                          {id: 5531112601, name: 'None', requireDoubleRight: true},
                          {id: 5531112602, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112603, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112604, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112605, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112606, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112607, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112608, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111261,
                        name: 'Start/stop all totalizers',
                        children: [
                          {id: 5531112611, name: 'None', requireDoubleRight: true},
                          {id: 5531112612, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112613, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112614, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112615, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112616, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112617, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112618, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111262,
                        name: 'Start/stop totalizer 1',
                        children: [
                          {id: 5531112621, name: 'None', requireDoubleRight: true},
                          {id: 5531112622, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112623, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112624, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112625, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112626, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112627, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112628, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111263,
                        name: 'Start/stop totalizer 2',
                        children: [
                          {id: 5531112631, name: 'None', requireDoubleRight: true},
                          {id: 5531112632, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112633, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112634, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112635, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112636, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112637, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112638, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111264,
                        name: 'Start/stop totalizer 3',
                        children: [
                          {id: 5531112641, name: 'None', requireDoubleRight: true},
                          {id: 5531112642, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112643, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112644, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112645, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112646, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112647, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112648, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111265,
                        name: 'Start/stop totalizer 4',
                        children: [
                          {id: 5531112651, name: 'None', requireDoubleRight: true},
                          {id: 5531112652, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112653, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112654, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112655, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112656, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112657, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112658, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111266,
                        name: 'Start/stop totalizer 5',
                        children: [
                          {id: 5531112661, name: 'None', requireDoubleRight: true},
                          {id: 5531112662, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112663, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112664, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112665, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112666, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112667, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112668, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111267,
                        name: 'Start/stop totalizer 6',
                        children: [
                          {id: 5531112671, name: 'None', requireDoubleRight: true},
                          {id: 5531112672, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112673, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112674, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112675, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112676, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112677, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112678, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111268,
                        name: 'Start/stop totalizer 7',
                        children: [
                          {id: 5531112681, name: 'None', requireDoubleRight: true},
                          {id: 5531112682, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112683, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112684, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112685, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112686, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112687, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112688, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111269,
                        name: 'Start/stop inv 1',
                        children: [
                          {id: 5531112691, name: 'None', requireDoubleRight: true},
                          {id: 5531112692, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112693, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112694, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112695, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112696, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112697, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112698, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111270,
                        name: 'Start/stop inv 2',
                        children: [
                          {id: 5531112701, name: 'None', requireDoubleRight: true},
                          {id: 5531112702, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112703, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112704, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112705, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112706, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112707, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112708, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111271,
                        name: 'Start/stop inv 3',
                        children: [
                          {id: 5531112711, name: 'None', requireDoubleRight: true},
                          {id: 5531112712, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112713, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112714, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112715, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112716, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112717, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112718, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111272,
                        name: 'Start/stop inv 4',
                        children: [
                          {id: 5531112721, name: 'None', requireDoubleRight: true},
                          {id: 5531112722, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112723, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112724, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112725, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112726, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112727, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112728, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111273,
                        name: 'Start/stop inv 5',
                        children: [
                          {id: 5531112731, name: 'None', requireDoubleRight: true},
                          {id: 5531112732, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112733, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112734, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112735, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112736, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112737, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112738, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111274,
                        name: 'Start/stop inv 6',
                        children: [
                          {id: 5531112741, name: 'None', requireDoubleRight: true},
                          {id: 5531112742, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112743, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112744, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112745, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112746, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112747, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112748, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111275,
                        name: 'Start/stop inv 7',
                        children: [
                          {id: 5531112751, name: 'None', requireDoubleRight: true},
                          {id: 5531112752, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112753, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112754, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112755, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112756, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112757, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112758, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111276,
                        name: 'Start SMV',
                        children: [
                          {id: 5531112761, name: 'None', requireDoubleRight: true},
                          {id: 5531112762, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112763, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112764, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112765, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112766, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112767, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112768, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111277,
                        name: 'Resume Batch',
                        children: [
                          {id: 5531112771, name: 'None', requireDoubleRight: true},
                          {id: 5531112772, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112773, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112774, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112775, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112776, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112777, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112778, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111278,
                        name: 'Pause Batch',
                        children: [
                          {id: 5531112781, name: 'None', requireDoubleRight: true},
                          {id: 5531112782, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112783, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112784, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112785, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112786, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112787, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112788, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111279,
                        name: 'Begin Batch',
                        children: [
                          {id: 5531112791, name: 'None', requireDoubleRight: true},
                          {id: 5531112792, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112793, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112794, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112795, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112796, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112797, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112798, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111280,
                        name: 'End Batch',
                        children: [
                          {id: 5531112801, name: 'None', requireDoubleRight: true},
                          {id: 5531112802, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112803, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112804, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112805, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112806, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112807, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112808, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111281,
                        name: 'Reset Batch Total',
                        children: [
                          {id: 5531112811, name: 'None', requireDoubleRight: true},
                          {id: 5531112812, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112813, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112814, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112815, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112816, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112817, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112818, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111282,
                        name: 'Inhibit Batch',
                        children: [
                          {id: 5531112821, name: 'None', requireDoubleRight: true},
                          {id: 5531112822, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112823, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112824, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112825, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112826, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112827, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112828, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111283,
                        name: 'Inhibit Totalizer',
                        children: [
                          {id: 5531112831, name: 'None', requireDoubleRight: true},
                          {id: 5531112832, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112833, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112834, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112835, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112836, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112837, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112838, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111284,
                        name: 'Inhibit Flow',
                        children: [
                          {id: 5531112841, name: 'None', requireDoubleRight: true},
                          {id: 5531112842, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112843, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112844, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112845, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112846, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112847, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112848, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111285,
                        name: 'Increment Preset',
                        children: [
                          {id: 5531112851, name: 'None', requireDoubleRight: true},
                          {id: 5531112852, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112853, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112854, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112855, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112856, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112857, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112858, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111286,
                        name: 'Print Ticket',
                        children: [
                          {id: 5531112861, name: 'None', requireDoubleRight: true},
                          {id: 5531112862, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112863, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112864, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112865, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112866, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112867, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112868, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111287,
                        name: 'Print Transfer Ticket',
                        children: [
                          {id: 5531112871, name: 'None', requireDoubleRight: true},
                          {id: 5531112872, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112873, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112874, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112875, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112876, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112877, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112878, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311126,
                    name: 'Print Ticket Actions',
                    children: [
                      {
                        id: 55311126111,
                        name: 'Print Process Screen',
                        children: [
                          {id: 553111261111, name: 'On', requireDoubleRight: true},
                          {id: 553111261122, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126211,
                        name: 'Print Batch Ticket',
                        children: [
                          {id: 553111262111, name: 'On', requireDoubleRight: true},
                          {id: 553111262112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126311,
                        name: 'Print Config Data',
                        children: [
                          {id: 553111263111, name: 'On', requireDoubleRight: true},
                          {id: 553111263112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126411,
                        name: 'Print Alert History',
                        children: [
                          {id: 553111264111, name: 'On', requireDoubleRight: true},
                          {id: 553111264112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126511,
                        name: 'Print Active Alerts',
                        children: [
                          {id: 553111265111, name: 'On', requireDoubleRight: true},
                          {id: 553111265112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126611,
                        name: 'Print Audit Trail',
                        children: [
                          {id: 553111266111, name: 'On', requireDoubleRight: true},
                          {id: 553111266112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126711,
                        name: 'Print Test Page',
                        children: [
                          {id: 553111267111, name: 'On', requireDoubleRight: true},
                          {id: 553111267112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126811,
                        name: 'Print Transfer Totals',
                        children: [
                          {id: 553111268111, name: 'On', requireDoubleRight: true},
                          {id: 553111268112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126911,
                        name: 'Print Transfer Inventories',
                        children: [
                          {id: 553111269111, name: 'On', requireDoubleRight: true},
                          {id: 553111269112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311127,
                    name: 'Transfer Ticket Action',
                    children: [
                      {
                        id: 55311127111,
                        name: 'PRINT_PrintMassandVolumeTransferTotals',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127222,
                        name: 'PRINT_PrintMassandVolumeInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127333,
                        name: 'PRINT_PrintMassandVolumeTransferTotalsandInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127444,
                        name: 'PRINT_PrintAPITransferTotalandInventory',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127555,
                        name: 'PRINT_PrintEDNetMasstotalandinventory',
                        requireDoubleRight: true,
                      },
                    ],
                  },
                ],
              },
              {
                id: 5531114,
                name: 'Enhanced Event 3',
                children: [
                  {
                    id: 55311121,
                    name: 'Variable',
                    children: [
                      {id: 553111211, name: 'Variable', requireDoubleRight: true},
                      {id: 553111212, name: 'Event Type', requireDoubleRight: true},
                      {id: 553111213, name: 'Setpoint A', requireDoubleRight: true},
                      {id: 553111214, name: 'Setpoint B', requireDoubleRight: true},
                      {id: 553111215, name: 'Assign Actions', requireDoubleRight: true},
                      {id: 553111216, name: 'Print Ticket Actions', requireDoubleRight: true},
                      {id: 553111217, name: 'Transfer Ticket Action', requireDoubleRight: true},
                      {id: 553111218, name: 'Reset Total 7', requireDoubleRight: true},
                      {id: 553111219, name: 'Increment Matrix', requireDoubleRight: true},
                      {id: 553111220, name: 'Reset All Totals', requireDoubleRight: true},
                      {id: 553111221, name: 'Start/stop all totalizers', requireDoubleRight: true},
                      {id: 553111222, name: 'Start/stop totalizer 1', requireDoubleRight: true},
                      {id: 553111223, name: 'Start/stop totalizer 2', requireDoubleRight: true},
                      {id: 553111224, name: 'Start/stop totalizer 3', requireDoubleRight: true},
                      {id: 553111225, name: 'Start/stop totalizer 4', requireDoubleRight: true},
                      {id: 553111226, name: 'Start/stop totalizer 5', requireDoubleRight: true},
                      {id: 553111227, name: 'Start/stop totalizer 6', requireDoubleRight: true},
                      {id: 553111228, name: 'Start/stop totalizer 7', requireDoubleRight: true},
                      {id: 553111229, name: 'Start/stop inv 1', requireDoubleRight: true},
                      {id: 553111230, name: 'Start/stop inv 2', requireDoubleRight: true},
                      {id: 553111231, name: 'Start/stop inv 3', requireDoubleRight: true},
                      {id: 553111232, name: 'Start/stop inv 4', requireDoubleRight: true},
                      {id: 553111233, name: 'Start/stop inv 5', requireDoubleRight: true},
                      {id: 553111234, name: 'Start/stop inv 6', requireDoubleRight: true},
                      {id: 553111235, name: 'Start/stop inv 7', requireDoubleRight: true},
                      {id: 553111236, name: 'Start SMV', requireDoubleRight: true},
                      {id: 553111237, name: 'Resume Batch', requireDoubleRight: true},
                      {id: 553111238, name: 'Pause Batch', requireDoubleRight: true},
                      {id: 553111239, name: 'Begin Batch', requireDoubleRight: true},
                      {id: 553111240, name: 'End Batch', requireDoubleRight: true},
                      {id: 553111241, name: 'Reset Batch Total', requireDoubleRight: true},
                      {id: 553111242, name: 'Inhibit Batch', requireDoubleRight: true},
                      {id: 553111243, name: 'Inhibit Totalizer', requireDoubleRight: true},
                      {id: 553111244, name: 'Inhibit Flow', requireDoubleRight: true},
                      {id: 553111245, name: 'Increment Preset', requireDoubleRight: true},
                      {id: 553111246, name: 'Print Ticket', requireDoubleRight: true},
                      {id: 553111247, name: 'Print Transfer Ticket', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 55311122,
                    name: 'Event Type',
                    children: [
                      {id: 5531112211, name: 'PC_LO', requireDoubleRight: true},
                      {id: 5531112222, name: 'PC_HI', requireDoubleRight: true},
                      {id: 5531112233, name: 'PC_IN_HI_LO', requireDoubleRight: true},
                      {id: 5531112244, name: 'PC_OUT_HI_LO', requireDoubleRight: true},
                    ],
                  },
                  {id: 55311123, name: 'Setpoint A', component: <SetpointATN />},
                  {id: 55311124, name: 'Setpoint B', component: <SetpointBTN />},
                  {
                    id: 55311125,
                    name: 'Assign Actions',
                    children: [
                      {
                        id: 553111251,
                        name: 'Start Zero Calibration',
                        children: [
                          {id: 5531112511, name: 'None', requireDoubleRight: true},
                          {id: 5531112512, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112513, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112514, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112515, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112516, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112517, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112518, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111252,
                        name: 'Reset Total 1',
                        children: [
                          {id: 5531112521, name: 'None', requireDoubleRight: true},
                          {id: 5531112522, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112523, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112524, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112525, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112526, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112527, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112528, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111253,
                        name: 'Reset Total 2',
                        children: [
                          {id: 5531112531, name: 'None', requireDoubleRight: true},
                          {id: 5531112532, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112533, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112534, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112535, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112536, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112537, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112538, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111254,
                        name: 'Reset Total 3',
                        children: [
                          {id: 5531112541, name: 'None', requireDoubleRight: true},
                          {id: 5531112542, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112543, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112544, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112545, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112546, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112547, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112548, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111255,
                        name: 'Reset Total 4',
                        children: [
                          {id: 5531112551, name: 'None', requireDoubleRight: true},
                          {id: 5531112552, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112553, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112554, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112555, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112556, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112557, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112558, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111256,
                        name: 'Reset Total 5',
                        children: [
                          {id: 5531112561, name: 'None', requireDoubleRight: true},
                          {id: 5531112562, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112563, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112564, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112565, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112566, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112567, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112568, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111257,
                        name: 'Reset Total 6',
                        children: [
                          {id: 5531112571, name: 'None', requireDoubleRight: true},
                          {id: 5531112572, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112573, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112574, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112575, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112576, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112577, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112578, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111258,
                        name: 'Reset Total 7',
                        children: [
                          {id: 5531112581, name: 'None', requireDoubleRight: true},
                          {id: 5531112582, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112583, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112584, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112585, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112586, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112587, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112588, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111259,
                        name: 'Increment Matrix',
                        children: [
                          {id: 5531112591, name: 'None', requireDoubleRight: true},
                          {id: 5531112592, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112593, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112594, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112595, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112596, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112597, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112598, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111260,
                        name: 'Reset All Totals',
                        children: [
                          {id: 5531112601, name: 'None', requireDoubleRight: true},
                          {id: 5531112602, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112603, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112604, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112605, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112606, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112607, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112608, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111261,
                        name: 'Start/stop all totalizers',
                        children: [
                          {id: 5531112611, name: 'None', requireDoubleRight: true},
                          {id: 5531112612, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112613, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112614, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112615, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112616, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112617, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112618, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111262,
                        name: 'Start/stop totalizer 1',
                        children: [
                          {id: 5531112621, name: 'None', requireDoubleRight: true},
                          {id: 5531112622, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112623, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112624, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112625, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112626, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112627, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112628, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111263,
                        name: 'Start/stop totalizer 2',
                        children: [
                          {id: 5531112631, name: 'None', requireDoubleRight: true},
                          {id: 5531112632, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112633, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112634, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112635, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112636, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112637, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112638, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111264,
                        name: 'Start/stop totalizer 3',
                        children: [
                          {id: 5531112641, name: 'None', requireDoubleRight: true},
                          {id: 5531112642, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112643, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112644, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112645, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112646, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112647, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112648, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111265,
                        name: 'Start/stop totalizer 4',
                        children: [
                          {id: 5531112651, name: 'None', requireDoubleRight: true},
                          {id: 5531112652, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112653, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112654, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112655, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112656, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112657, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112658, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111266,
                        name: 'Start/stop totalizer 5',
                        children: [
                          {id: 5531112661, name: 'None', requireDoubleRight: true},
                          {id: 5531112662, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112663, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112664, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112665, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112666, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112667, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112668, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111267,
                        name: 'Start/stop totalizer 6',
                        children: [
                          {id: 5531112671, name: 'None', requireDoubleRight: true},
                          {id: 5531112672, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112673, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112674, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112675, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112676, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112677, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112678, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111268,
                        name: 'Start/stop totalizer 7',
                        children: [
                          {id: 5531112681, name: 'None', requireDoubleRight: true},
                          {id: 5531112682, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112683, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112684, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112685, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112686, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112687, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112688, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111269,
                        name: 'Start/stop inv 1',
                        children: [
                          {id: 5531112691, name: 'None', requireDoubleRight: true},
                          {id: 5531112692, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112693, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112694, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112695, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112696, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112697, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112698, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111270,
                        name: 'Start/stop inv 2',
                        children: [
                          {id: 5531112701, name: 'None', requireDoubleRight: true},
                          {id: 5531112702, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112703, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112704, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112705, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112706, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112707, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112708, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111271,
                        name: 'Start/stop inv 3',
                        children: [
                          {id: 5531112711, name: 'None', requireDoubleRight: true},
                          {id: 5531112712, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112713, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112714, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112715, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112716, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112717, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112718, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111272,
                        name: 'Start/stop inv 4',
                        children: [
                          {id: 5531112721, name: 'None', requireDoubleRight: true},
                          {id: 5531112722, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112723, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112724, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112725, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112726, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112727, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112728, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111273,
                        name: 'Start/stop inv 5',
                        children: [
                          {id: 5531112731, name: 'None', requireDoubleRight: true},
                          {id: 5531112732, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112733, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112734, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112735, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112736, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112737, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112738, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111274,
                        name: 'Start/stop inv 6',
                        children: [
                          {id: 5531112741, name: 'None', requireDoubleRight: true},
                          {id: 5531112742, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112743, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112744, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112745, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112746, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112747, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112748, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111275,
                        name: 'Start/stop inv 7',
                        children: [
                          {id: 5531112751, name: 'None', requireDoubleRight: true},
                          {id: 5531112752, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112753, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112754, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112755, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112756, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112757, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112758, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111276,
                        name: 'Start SMV',
                        children: [
                          {id: 5531112761, name: 'None', requireDoubleRight: true},
                          {id: 5531112762, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112763, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112764, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112765, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112766, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112767, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112768, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111277,
                        name: 'Resume Batch',
                        children: [
                          {id: 5531112771, name: 'None', requireDoubleRight: true},
                          {id: 5531112772, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112773, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112774, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112775, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112776, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112777, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112778, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111278,
                        name: 'Pause Batch',
                        children: [
                          {id: 5531112781, name: 'None', requireDoubleRight: true},
                          {id: 5531112782, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112783, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112784, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112785, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112786, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112787, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112788, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111279,
                        name: 'Begin Batch',
                        children: [
                          {id: 5531112791, name: 'None', requireDoubleRight: true},
                          {id: 5531112792, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112793, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112794, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112795, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112796, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112797, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112798, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111280,
                        name: 'End Batch',
                        children: [
                          {id: 5531112801, name: 'None', requireDoubleRight: true},
                          {id: 5531112802, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112803, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112804, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112805, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112806, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112807, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112808, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111281,
                        name: 'Reset Batch Total',
                        children: [
                          {id: 5531112811, name: 'None', requireDoubleRight: true},
                          {id: 5531112812, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112813, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112814, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112815, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112816, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112817, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112818, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111282,
                        name: 'Inhibit Batch',
                        children: [
                          {id: 5531112821, name: 'None', requireDoubleRight: true},
                          {id: 5531112822, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112823, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112824, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112825, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112826, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112827, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112828, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111283,
                        name: 'Inhibit Totalizer',
                        children: [
                          {id: 5531112831, name: 'None', requireDoubleRight: true},
                          {id: 5531112832, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112833, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112834, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112835, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112836, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112837, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112838, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111284,
                        name: 'Inhibit Flow',
                        children: [
                          {id: 5531112841, name: 'None', requireDoubleRight: true},
                          {id: 5531112842, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112843, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112844, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112845, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112846, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112847, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112848, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111285,
                        name: 'Increment Preset',
                        children: [
                          {id: 5531112851, name: 'None', requireDoubleRight: true},
                          {id: 5531112852, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112853, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112854, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112855, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112856, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112857, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112858, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111286,
                        name: 'Print Ticket',
                        children: [
                          {id: 5531112861, name: 'None', requireDoubleRight: true},
                          {id: 5531112862, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112863, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112864, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112865, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112866, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112867, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112868, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111287,
                        name: 'Print Transfer Ticket',
                        children: [
                          {id: 5531112871, name: 'None', requireDoubleRight: true},
                          {id: 5531112872, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112873, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112874, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112875, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112876, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112877, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112878, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311126,
                    name: 'Print Ticket Actions',
                    children: [
                      {
                        id: 55311126111,
                        name: 'Print Process Screen',
                        children: [
                          {id: 553111261111, name: 'On', requireDoubleRight: true},
                          {id: 553111261122, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126211,
                        name: 'Print Batch Ticket',
                        children: [
                          {id: 553111262111, name: 'On', requireDoubleRight: true},
                          {id: 553111262112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126311,
                        name: 'Print Config Data',
                        children: [
                          {id: 553111263111, name: 'On', requireDoubleRight: true},
                          {id: 553111263112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126411,
                        name: 'Print Alert History',
                        children: [
                          {id: 553111264111, name: 'On', requireDoubleRight: true},
                          {id: 553111264112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126511,
                        name: 'Print Active Alerts',
                        children: [
                          {id: 553111265111, name: 'On', requireDoubleRight: true},
                          {id: 553111265112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126611,
                        name: 'Print Audit Trail',
                        children: [
                          {id: 553111266111, name: 'On', requireDoubleRight: true},
                          {id: 553111266112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126711,
                        name: 'Print Test Page',
                        children: [
                          {id: 553111267111, name: 'On', requireDoubleRight: true},
                          {id: 553111267112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126811,
                        name: 'Print Transfer Totals',
                        children: [
                          {id: 553111268111, name: 'On', requireDoubleRight: true},
                          {id: 553111268112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126911,
                        name: 'Print Transfer Inventories',
                        children: [
                          {id: 553111269111, name: 'On', requireDoubleRight: true},
                          {id: 553111269112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311127,
                    name: 'Transfer Ticket Action',
                    children: [
                      {
                        id: 55311127111,
                        name: 'PRINT_PrintMassandVolumeTransferTotals',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127222,
                        name: 'PRINT_PrintMassandVolumeInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127333,
                        name: 'PRINT_PrintMassandVolumeTransferTotalsandInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127444,
                        name: 'PRINT_PrintAPITransferTotalandInventory',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127555,
                        name: 'PRINT_PrintEDNetMasstotalandinventory',
                        requireDoubleRight: true,
                      },
                    ],
                  },
                ],
              },
              {
                id: 5531115,
                name: 'Enhanced Event 4',
                children: [
                  {
                    id: 55311121,
                    name: 'Variable',
                    children: [
                      {id: 553111211, name: 'Variable', requireDoubleRight: true},
                      {id: 553111212, name: 'Event Type', requireDoubleRight: true},
                      {id: 553111213, name: 'Setpoint A', requireDoubleRight: true},
                      {id: 553111214, name: 'Setpoint B', requireDoubleRight: true},
                      {id: 553111215, name: 'Assign Actions', requireDoubleRight: true},
                      {id: 553111216, name: 'Print Ticket Actions', requireDoubleRight: true},
                      {id: 553111217, name: 'Transfer Ticket Action', requireDoubleRight: true},
                      {id: 553111218, name: 'Reset Total 7', requireDoubleRight: true},
                      {id: 553111219, name: 'Increment Matrix', requireDoubleRight: true},
                      {id: 553111220, name: 'Reset All Totals', requireDoubleRight: true},
                      {id: 553111221, name: 'Start/stop all totalizers', requireDoubleRight: true},
                      {id: 553111222, name: 'Start/stop totalizer 1', requireDoubleRight: true},
                      {id: 553111223, name: 'Start/stop totalizer 2', requireDoubleRight: true},
                      {id: 553111224, name: 'Start/stop totalizer 3', requireDoubleRight: true},
                      {id: 553111225, name: 'Start/stop totalizer 4', requireDoubleRight: true},
                      {id: 553111226, name: 'Start/stop totalizer 5', requireDoubleRight: true},
                      {id: 553111227, name: 'Start/stop totalizer 6', requireDoubleRight: true},
                      {id: 553111228, name: 'Start/stop totalizer 7', requireDoubleRight: true},
                      {id: 553111229, name: 'Start/stop inv 1', requireDoubleRight: true},
                      {id: 553111230, name: 'Start/stop inv 2', requireDoubleRight: true},
                      {id: 553111231, name: 'Start/stop inv 3', requireDoubleRight: true},
                      {id: 553111232, name: 'Start/stop inv 4', requireDoubleRight: true},
                      {id: 553111233, name: 'Start/stop inv 5', requireDoubleRight: true},
                      {id: 553111234, name: 'Start/stop inv 6', requireDoubleRight: true},
                      {id: 553111235, name: 'Start/stop inv 7', requireDoubleRight: true},
                      {id: 553111236, name: 'Start SMV', requireDoubleRight: true},
                      {id: 553111237, name: 'Resume Batch', requireDoubleRight: true},
                      {id: 553111238, name: 'Pause Batch', requireDoubleRight: true},
                      {id: 553111239, name: 'Begin Batch', requireDoubleRight: true},
                      {id: 553111240, name: 'End Batch', requireDoubleRight: true},
                      {id: 553111241, name: 'Reset Batch Total', requireDoubleRight: true},
                      {id: 553111242, name: 'Inhibit Batch', requireDoubleRight: true},
                      {id: 553111243, name: 'Inhibit Totalizer', requireDoubleRight: true},
                      {id: 553111244, name: 'Inhibit Flow', requireDoubleRight: true},
                      {id: 553111245, name: 'Increment Preset', requireDoubleRight: true},
                      {id: 553111246, name: 'Print Ticket', requireDoubleRight: true},
                      {id: 553111247, name: 'Print Transfer Ticket', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 55311122,
                    name: 'Event Type',
                    children: [
                      {id: 5531112211, name: 'PC_LO', requireDoubleRight: true},
                      {id: 5531112222, name: 'PC_HI', requireDoubleRight: true},
                      {id: 5531112233, name: 'PC_IN_HI_LO', requireDoubleRight: true},
                      {id: 5531112244, name: 'PC_OUT_HI_LO', requireDoubleRight: true},
                    ],
                  },
                  {id: 55311123, name: 'Setpoint A', component: <SetpointATN />},
                  {id: 55311124, name: 'Setpoint B', component: <SetpointBTN />},
                  {
                    id: 55311125,
                    name: 'Assign Actions',
                    children: [
                      {
                        id: 553111251,
                        name: 'Start Zero Calibration',
                        children: [
                          {id: 5531112511, name: 'None', requireDoubleRight: true},
                          {id: 5531112512, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112513, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112514, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112515, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112516, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112517, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112518, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111252,
                        name: 'Reset Total 1',
                        children: [
                          {id: 5531112521, name: 'None', requireDoubleRight: true},
                          {id: 5531112522, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112523, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112524, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112525, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112526, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112527, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112528, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111253,
                        name: 'Reset Total 2',
                        children: [
                          {id: 5531112531, name: 'None', requireDoubleRight: true},
                          {id: 5531112532, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112533, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112534, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112535, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112536, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112537, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112538, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111254,
                        name: 'Reset Total 3',
                        children: [
                          {id: 5531112541, name: 'None', requireDoubleRight: true},
                          {id: 5531112542, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112543, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112544, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112545, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112546, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112547, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112548, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111255,
                        name: 'Reset Total 4',
                        children: [
                          {id: 5531112551, name: 'None', requireDoubleRight: true},
                          {id: 5531112552, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112553, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112554, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112555, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112556, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112557, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112558, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111256,
                        name: 'Reset Total 5',
                        children: [
                          {id: 5531112561, name: 'None', requireDoubleRight: true},
                          {id: 5531112562, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112563, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112564, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112565, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112566, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112567, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112568, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111257,
                        name: 'Reset Total 6',
                        children: [
                          {id: 5531112571, name: 'None', requireDoubleRight: true},
                          {id: 5531112572, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112573, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112574, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112575, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112576, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112577, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112578, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111258,
                        name: 'Reset Total 7',
                        children: [
                          {id: 5531112581, name: 'None', requireDoubleRight: true},
                          {id: 5531112582, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112583, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112584, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112585, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112586, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112587, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112588, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111259,
                        name: 'Increment Matrix',
                        children: [
                          {id: 5531112591, name: 'None', requireDoubleRight: true},
                          {id: 5531112592, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112593, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112594, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112595, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112596, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112597, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112598, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111260,
                        name: 'Reset All Totals',
                        children: [
                          {id: 5531112601, name: 'None', requireDoubleRight: true},
                          {id: 5531112602, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112603, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112604, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112605, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112606, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112607, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112608, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111261,
                        name: 'Start/stop all totalizers',
                        children: [
                          {id: 5531112611, name: 'None', requireDoubleRight: true},
                          {id: 5531112612, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112613, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112614, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112615, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112616, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112617, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112618, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111262,
                        name: 'Start/stop totalizer 1',
                        children: [
                          {id: 5531112621, name: 'None', requireDoubleRight: true},
                          {id: 5531112622, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112623, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112624, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112625, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112626, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112627, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112628, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111263,
                        name: 'Start/stop totalizer 2',
                        children: [
                          {id: 5531112631, name: 'None', requireDoubleRight: true},
                          {id: 5531112632, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112633, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112634, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112635, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112636, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112637, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112638, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111264,
                        name: 'Start/stop totalizer 3',
                        children: [
                          {id: 5531112641, name: 'None', requireDoubleRight: true},
                          {id: 5531112642, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112643, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112644, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112645, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112646, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112647, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112648, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111265,
                        name: 'Start/stop totalizer 4',
                        children: [
                          {id: 5531112651, name: 'None', requireDoubleRight: true},
                          {id: 5531112652, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112653, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112654, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112655, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112656, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112657, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112658, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111266,
                        name: 'Start/stop totalizer 5',
                        children: [
                          {id: 5531112661, name: 'None', requireDoubleRight: true},
                          {id: 5531112662, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112663, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112664, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112665, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112666, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112667, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112668, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111267,
                        name: 'Start/stop totalizer 6',
                        children: [
                          {id: 5531112671, name: 'None', requireDoubleRight: true},
                          {id: 5531112672, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112673, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112674, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112675, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112676, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112677, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112678, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111268,
                        name: 'Start/stop totalizer 7',
                        children: [
                          {id: 5531112681, name: 'None', requireDoubleRight: true},
                          {id: 5531112682, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112683, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112684, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112685, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112686, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112687, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112688, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111269,
                        name: 'Start/stop inv 1',
                        children: [
                          {id: 5531112691, name: 'None', requireDoubleRight: true},
                          {id: 5531112692, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112693, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112694, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112695, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112696, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112697, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112698, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111270,
                        name: 'Start/stop inv 2',
                        children: [
                          {id: 5531112701, name: 'None', requireDoubleRight: true},
                          {id: 5531112702, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112703, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112704, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112705, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112706, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112707, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112708, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111271,
                        name: 'Start/stop inv 3',
                        children: [
                          {id: 5531112711, name: 'None', requireDoubleRight: true},
                          {id: 5531112712, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112713, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112714, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112715, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112716, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112717, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112718, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111272,
                        name: 'Start/stop inv 4',
                        children: [
                          {id: 5531112721, name: 'None', requireDoubleRight: true},
                          {id: 5531112722, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112723, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112724, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112725, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112726, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112727, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112728, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111273,
                        name: 'Start/stop inv 5',
                        children: [
                          {id: 5531112731, name: 'None', requireDoubleRight: true},
                          {id: 5531112732, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112733, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112734, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112735, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112736, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112737, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112738, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111274,
                        name: 'Start/stop inv 6',
                        children: [
                          {id: 5531112741, name: 'None', requireDoubleRight: true},
                          {id: 5531112742, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112743, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112744, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112745, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112746, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112747, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112748, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111275,
                        name: 'Start/stop inv 7',
                        children: [
                          {id: 5531112751, name: 'None', requireDoubleRight: true},
                          {id: 5531112752, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112753, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112754, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112755, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112756, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112757, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112758, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111276,
                        name: 'Start SMV',
                        children: [
                          {id: 5531112761, name: 'None', requireDoubleRight: true},
                          {id: 5531112762, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112763, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112764, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112765, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112766, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112767, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112768, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111277,
                        name: 'Resume Batch',
                        children: [
                          {id: 5531112771, name: 'None', requireDoubleRight: true},
                          {id: 5531112772, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112773, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112774, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112775, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112776, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112777, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112778, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111278,
                        name: 'Pause Batch',
                        children: [
                          {id: 5531112781, name: 'None', requireDoubleRight: true},
                          {id: 5531112782, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112783, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112784, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112785, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112786, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112787, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112788, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111279,
                        name: 'Begin Batch',
                        children: [
                          {id: 5531112791, name: 'None', requireDoubleRight: true},
                          {id: 5531112792, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112793, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112794, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112795, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112796, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112797, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112798, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111280,
                        name: 'End Batch',
                        children: [
                          {id: 5531112801, name: 'None', requireDoubleRight: true},
                          {id: 5531112802, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112803, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112804, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112805, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112806, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112807, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112808, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111281,
                        name: 'Reset Batch Total',
                        children: [
                          {id: 5531112811, name: 'None', requireDoubleRight: true},
                          {id: 5531112812, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112813, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112814, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112815, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112816, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112817, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112818, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111282,
                        name: 'Inhibit Batch',
                        children: [
                          {id: 5531112821, name: 'None', requireDoubleRight: true},
                          {id: 5531112822, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112823, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112824, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112825, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112826, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112827, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112828, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111283,
                        name: 'Inhibit Totalizer',
                        children: [
                          {id: 5531112831, name: 'None', requireDoubleRight: true},
                          {id: 5531112832, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112833, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112834, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112835, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112836, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112837, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112838, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111284,
                        name: 'Inhibit Flow',
                        children: [
                          {id: 5531112841, name: 'None', requireDoubleRight: true},
                          {id: 5531112842, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112843, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112844, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112845, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112846, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112847, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112848, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111285,
                        name: 'Increment Preset',
                        children: [
                          {id: 5531112851, name: 'None', requireDoubleRight: true},
                          {id: 5531112852, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112853, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112854, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112855, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112856, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112857, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112858, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111286,
                        name: 'Print Ticket',
                        children: [
                          {id: 5531112861, name: 'None', requireDoubleRight: true},
                          {id: 5531112862, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112863, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112864, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112865, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112866, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112867, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112868, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111287,
                        name: 'Print Transfer Ticket',
                        children: [
                          {id: 5531112871, name: 'None', requireDoubleRight: true},
                          {id: 5531112872, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112873, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112874, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112875, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112876, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112877, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112878, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311126,
                    name: 'Print Ticket Actions',
                    children: [
                      {
                        id: 55311126111,
                        name: 'Print Process Screen',
                        children: [
                          {id: 553111261111, name: 'On', requireDoubleRight: true},
                          {id: 553111261122, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126211,
                        name: 'Print Batch Ticket',
                        children: [
                          {id: 553111262111, name: 'On', requireDoubleRight: true},
                          {id: 553111262112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126311,
                        name: 'Print Config Data',
                        children: [
                          {id: 553111263111, name: 'On', requireDoubleRight: true},
                          {id: 553111263112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126411,
                        name: 'Print Alert History',
                        children: [
                          {id: 553111264111, name: 'On', requireDoubleRight: true},
                          {id: 553111264112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126511,
                        name: 'Print Active Alerts',
                        children: [
                          {id: 553111265111, name: 'On', requireDoubleRight: true},
                          {id: 553111265112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126611,
                        name: 'Print Audit Trail',
                        children: [
                          {id: 553111266111, name: 'On', requireDoubleRight: true},
                          {id: 553111266112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126711,
                        name: 'Print Test Page',
                        children: [
                          {id: 553111267111, name: 'On', requireDoubleRight: true},
                          {id: 553111267112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126811,
                        name: 'Print Transfer Totals',
                        children: [
                          {id: 553111268111, name: 'On', requireDoubleRight: true},
                          {id: 553111268112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126911,
                        name: 'Print Transfer Inventories',
                        children: [
                          {id: 553111269111, name: 'On', requireDoubleRight: true},
                          {id: 553111269112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311127,
                    name: 'Transfer Ticket Action',
                    children: [
                      {
                        id: 55311127111,
                        name: 'PRINT_PrintMassandVolumeTransferTotals',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127222,
                        name: 'PRINT_PrintMassandVolumeInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127333,
                        name: 'PRINT_PrintMassandVolumeTransferTotalsandInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127444,
                        name: 'PRINT_PrintAPITransferTotalandInventory',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127555,
                        name: 'PRINT_PrintEDNetMasstotalandinventory',
                        requireDoubleRight: true,
                      },
                    ],
                  },
                ],
              },
              {
                id: 5531116,
                name: 'Enhanced Event 5',
                children: [
                  {
                    id: 55311121,
                    name: 'Variable',
                    children: [
                      {id: 553111211, name: 'Variable', requireDoubleRight: true},
                      {id: 553111212, name: 'Event Type', requireDoubleRight: true},
                      {id: 553111213, name: 'Setpoint A', requireDoubleRight: true},
                      {id: 553111214, name: 'Setpoint B', requireDoubleRight: true},
                      {id: 553111215, name: 'Assign Actions', requireDoubleRight: true},
                      {id: 553111216, name: 'Print Ticket Actions', requireDoubleRight: true},
                      {id: 553111217, name: 'Transfer Ticket Action', requireDoubleRight: true},
                      {id: 553111218, name: 'Reset Total 7', requireDoubleRight: true},
                      {id: 553111219, name: 'Increment Matrix', requireDoubleRight: true},
                      {id: 553111220, name: 'Reset All Totals', requireDoubleRight: true},
                      {id: 553111221, name: 'Start/stop all totalizers', requireDoubleRight: true},
                      {id: 553111222, name: 'Start/stop totalizer 1', requireDoubleRight: true},
                      {id: 553111223, name: 'Start/stop totalizer 2', requireDoubleRight: true},
                      {id: 553111224, name: 'Start/stop totalizer 3', requireDoubleRight: true},
                      {id: 553111225, name: 'Start/stop totalizer 4', requireDoubleRight: true},
                      {id: 553111226, name: 'Start/stop totalizer 5', requireDoubleRight: true},
                      {id: 553111227, name: 'Start/stop totalizer 6', requireDoubleRight: true},
                      {id: 553111228, name: 'Start/stop totalizer 7', requireDoubleRight: true},
                      {id: 553111229, name: 'Start/stop inv 1', requireDoubleRight: true},
                      {id: 553111230, name: 'Start/stop inv 2', requireDoubleRight: true},
                      {id: 553111231, name: 'Start/stop inv 3', requireDoubleRight: true},
                      {id: 553111232, name: 'Start/stop inv 4', requireDoubleRight: true},
                      {id: 553111233, name: 'Start/stop inv 5', requireDoubleRight: true},
                      {id: 553111234, name: 'Start/stop inv 6', requireDoubleRight: true},
                      {id: 553111235, name: 'Start/stop inv 7', requireDoubleRight: true},
                      {id: 553111236, name: 'Start SMV', requireDoubleRight: true},
                      {id: 553111237, name: 'Resume Batch', requireDoubleRight: true},
                      {id: 553111238, name: 'Pause Batch', requireDoubleRight: true},
                      {id: 553111239, name: 'Begin Batch', requireDoubleRight: true},
                      {id: 553111240, name: 'End Batch', requireDoubleRight: true},
                      {id: 553111241, name: 'Reset Batch Total', requireDoubleRight: true},
                      {id: 553111242, name: 'Inhibit Batch', requireDoubleRight: true},
                      {id: 553111243, name: 'Inhibit Totalizer', requireDoubleRight: true},
                      {id: 553111244, name: 'Inhibit Flow', requireDoubleRight: true},
                      {id: 553111245, name: 'Increment Preset', requireDoubleRight: true},
                      {id: 553111246, name: 'Print Ticket', requireDoubleRight: true},
                      {id: 553111247, name: 'Print Transfer Ticket', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 55311122,
                    name: 'Event Type',
                    children: [
                      {id: 5531112211, name: 'PC_LO', requireDoubleRight: true},
                      {id: 5531112222, name: 'PC_HI', requireDoubleRight: true},
                      {id: 5531112233, name: 'PC_IN_HI_LO', requireDoubleRight: true},
                      {id: 5531112244, name: 'PC_OUT_HI_LO', requireDoubleRight: true},
                    ],
                  },
                  {id: 55311123, name: 'Setpoint A', component: <SetpointATN />},
                  {id: 55311124, name: 'Setpoint B', component: <SetpointBTN />},
                  {
                    id: 55311125,
                    name: 'Assign Actions',
                    children: [
                      {
                        id: 553111251,
                        name: 'Start Zero Calibration',
                        children: [
                          {id: 5531112511, name: 'None', requireDoubleRight: true},
                          {id: 5531112512, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112513, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112514, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112515, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112516, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112517, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112518, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111252,
                        name: 'Reset Total 1',
                        children: [
                          {id: 5531112521, name: 'None', requireDoubleRight: true},
                          {id: 5531112522, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112523, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112524, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112525, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112526, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112527, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112528, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111253,
                        name: 'Reset Total 2',
                        children: [
                          {id: 5531112531, name: 'None', requireDoubleRight: true},
                          {id: 5531112532, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112533, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112534, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112535, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112536, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112537, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112538, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111254,
                        name: 'Reset Total 3',
                        children: [
                          {id: 5531112541, name: 'None', requireDoubleRight: true},
                          {id: 5531112542, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112543, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112544, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112545, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112546, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112547, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112548, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111255,
                        name: 'Reset Total 4',
                        children: [
                          {id: 5531112551, name: 'None', requireDoubleRight: true},
                          {id: 5531112552, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112553, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112554, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112555, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112556, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112557, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112558, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111256,
                        name: 'Reset Total 5',
                        children: [
                          {id: 5531112561, name: 'None', requireDoubleRight: true},
                          {id: 5531112562, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112563, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112564, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112565, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112566, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112567, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112568, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111257,
                        name: 'Reset Total 6',
                        children: [
                          {id: 5531112571, name: 'None', requireDoubleRight: true},
                          {id: 5531112572, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112573, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112574, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112575, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112576, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112577, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112578, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111258,
                        name: 'Reset Total 7',
                        children: [
                          {id: 5531112581, name: 'None', requireDoubleRight: true},
                          {id: 5531112582, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112583, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112584, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112585, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112586, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112587, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112588, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111259,
                        name: 'Increment Matrix',
                        children: [
                          {id: 5531112591, name: 'None', requireDoubleRight: true},
                          {id: 5531112592, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112593, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112594, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112595, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112596, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112597, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112598, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111260,
                        name: 'Reset All Totals',
                        children: [
                          {id: 5531112601, name: 'None', requireDoubleRight: true},
                          {id: 5531112602, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112603, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112604, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112605, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112606, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112607, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112608, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111261,
                        name: 'Start/stop all totalizers',
                        children: [
                          {id: 5531112611, name: 'None', requireDoubleRight: true},
                          {id: 5531112612, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112613, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112614, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112615, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112616, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112617, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112618, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111262,
                        name: 'Start/stop totalizer 1',
                        children: [
                          {id: 5531112621, name: 'None', requireDoubleRight: true},
                          {id: 5531112622, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112623, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112624, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112625, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112626, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112627, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112628, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111263,
                        name: 'Start/stop totalizer 2',
                        children: [
                          {id: 5531112631, name: 'None', requireDoubleRight: true},
                          {id: 5531112632, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112633, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112634, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112635, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112636, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112637, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112638, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111264,
                        name: 'Start/stop totalizer 3',
                        children: [
                          {id: 5531112641, name: 'None', requireDoubleRight: true},
                          {id: 5531112642, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112643, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112644, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112645, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112646, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112647, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112648, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111265,
                        name: 'Start/stop totalizer 4',
                        children: [
                          {id: 5531112651, name: 'None', requireDoubleRight: true},
                          {id: 5531112652, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112653, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112654, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112655, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112656, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112657, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112658, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111266,
                        name: 'Start/stop totalizer 5',
                        children: [
                          {id: 5531112661, name: 'None', requireDoubleRight: true},
                          {id: 5531112662, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112663, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112664, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112665, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112666, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112667, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112668, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111267,
                        name: 'Start/stop totalizer 6',
                        children: [
                          {id: 5531112671, name: 'None', requireDoubleRight: true},
                          {id: 5531112672, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112673, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112674, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112675, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112676, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112677, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112678, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111268,
                        name: 'Start/stop totalizer 7',
                        children: [
                          {id: 5531112681, name: 'None', requireDoubleRight: true},
                          {id: 5531112682, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112683, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112684, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112685, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112686, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112687, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112688, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111269,
                        name: 'Start/stop inv 1',
                        children: [
                          {id: 5531112691, name: 'None', requireDoubleRight: true},
                          {id: 5531112692, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112693, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112694, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112695, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112696, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112697, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112698, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111270,
                        name: 'Start/stop inv 2',
                        children: [
                          {id: 5531112701, name: 'None', requireDoubleRight: true},
                          {id: 5531112702, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112703, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112704, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112705, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112706, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112707, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112708, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111271,
                        name: 'Start/stop inv 3',
                        children: [
                          {id: 5531112711, name: 'None', requireDoubleRight: true},
                          {id: 5531112712, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112713, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112714, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112715, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112716, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112717, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112718, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111272,
                        name: 'Start/stop inv 4',
                        children: [
                          {id: 5531112721, name: 'None', requireDoubleRight: true},
                          {id: 5531112722, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112723, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112724, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112725, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112726, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112727, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112728, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111273,
                        name: 'Start/stop inv 5',
                        children: [
                          {id: 5531112731, name: 'None', requireDoubleRight: true},
                          {id: 5531112732, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112733, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112734, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112735, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112736, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112737, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112738, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111274,
                        name: 'Start/stop inv 6',
                        children: [
                          {id: 5531112741, name: 'None', requireDoubleRight: true},
                          {id: 5531112742, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112743, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112744, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112745, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112746, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112747, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112748, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111275,
                        name: 'Start/stop inv 7',
                        children: [
                          {id: 5531112751, name: 'None', requireDoubleRight: true},
                          {id: 5531112752, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112753, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112754, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112755, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112756, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112757, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112758, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111276,
                        name: 'Start SMV',
                        children: [
                          {id: 5531112761, name: 'None', requireDoubleRight: true},
                          {id: 5531112762, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112763, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112764, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112765, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112766, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112767, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112768, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111277,
                        name: 'Resume Batch',
                        children: [
                          {id: 5531112771, name: 'None', requireDoubleRight: true},
                          {id: 5531112772, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112773, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112774, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112775, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112776, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112777, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112778, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111278,
                        name: 'Pause Batch',
                        children: [
                          {id: 5531112781, name: 'None', requireDoubleRight: true},
                          {id: 5531112782, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112783, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112784, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112785, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112786, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112787, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112788, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111279,
                        name: 'Begin Batch',
                        children: [
                          {id: 5531112791, name: 'None', requireDoubleRight: true},
                          {id: 5531112792, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112793, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112794, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112795, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112796, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112797, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112798, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111280,
                        name: 'End Batch',
                        children: [
                          {id: 5531112801, name: 'None', requireDoubleRight: true},
                          {id: 5531112802, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112803, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112804, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112805, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112806, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112807, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112808, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111281,
                        name: 'Reset Batch Total',
                        children: [
                          {id: 5531112811, name: 'None', requireDoubleRight: true},
                          {id: 5531112812, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112813, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112814, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112815, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112816, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112817, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112818, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111282,
                        name: 'Inhibit Batch',
                        children: [
                          {id: 5531112821, name: 'None', requireDoubleRight: true},
                          {id: 5531112822, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112823, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112824, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112825, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112826, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112827, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112828, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111283,
                        name: 'Inhibit Totalizer',
                        children: [
                          {id: 5531112831, name: 'None', requireDoubleRight: true},
                          {id: 5531112832, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112833, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112834, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112835, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112836, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112837, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112838, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111284,
                        name: 'Inhibit Flow',
                        children: [
                          {id: 5531112841, name: 'None', requireDoubleRight: true},
                          {id: 5531112842, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112843, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112844, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112845, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112846, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112847, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112848, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111285,
                        name: 'Increment Preset',
                        children: [
                          {id: 5531112851, name: 'None', requireDoubleRight: true},
                          {id: 5531112852, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112853, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112854, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112855, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112856, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112857, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112858, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111286,
                        name: 'Print Ticket',
                        children: [
                          {id: 5531112861, name: 'None', requireDoubleRight: true},
                          {id: 5531112862, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112863, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112864, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112865, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112866, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112867, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112868, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 553111287,
                        name: 'Print Transfer Ticket',
                        children: [
                          {id: 5531112871, name: 'None', requireDoubleRight: true},
                          {id: 5531112872, name: 'PV_DI_1', requireDoubleRight: true},
                          {id: 5531112873, name: 'PV_DI_2', requireDoubleRight: true},
                          {id: 5531112874, name: 'Enhanced Event 1', requireDoubleRight: true},
                          {id: 5531112875, name: 'Enhanced Event 2', requireDoubleRight: true},
                          {id: 5531112876, name: 'Enhanced Event 3', requireDoubleRight: true},
                          {id: 5531112877, name: 'Enhanced Event 4', requireDoubleRight: true},
                          {id: 5531112878, name: 'Enhanced Event 5', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311126,
                    name: 'Print Ticket Actions',
                    children: [
                      {
                        id: 55311126111,
                        name: 'Print Process Screen',
                        children: [
                          {id: 553111261111, name: 'On', requireDoubleRight: true},
                          {id: 553111261122, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126211,
                        name: 'Print Batch Ticket',
                        children: [
                          {id: 553111262111, name: 'On', requireDoubleRight: true},
                          {id: 553111262112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126311,
                        name: 'Print Config Data',
                        children: [
                          {id: 553111263111, name: 'On', requireDoubleRight: true},
                          {id: 553111263112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126411,
                        name: 'Print Alert History',
                        children: [
                          {id: 553111264111, name: 'On', requireDoubleRight: true},
                          {id: 553111264112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126511,
                        name: 'Print Active Alerts',
                        children: [
                          {id: 553111265111, name: 'On', requireDoubleRight: true},
                          {id: 553111265112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126611,
                        name: 'Print Audit Trail',
                        children: [
                          {id: 553111266111, name: 'On', requireDoubleRight: true},
                          {id: 553111266112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126711,
                        name: 'Print Test Page',
                        children: [
                          {id: 553111267111, name: 'On', requireDoubleRight: true},
                          {id: 553111267112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126811,
                        name: 'Print Transfer Totals',
                        children: [
                          {id: 553111268111, name: 'On', requireDoubleRight: true},
                          {id: 553111268112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                      {
                        id: 55311126911,
                        name: 'Print Transfer Inventories',
                        children: [
                          {id: 553111269111, name: 'On', requireDoubleRight: true},
                          {id: 553111269112, name: 'Off', requireDoubleRight: true},
                        ],
                      },
                    ],
                  },
                  {
                    id: 55311127,
                    name: 'Transfer Ticket Action',
                    children: [
                      {
                        id: 55311127111,
                        name: 'PRINT_PrintMassandVolumeTransferTotals',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127222,
                        name: 'PRINT_PrintMassandVolumeInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127333,
                        name: 'PRINT_PrintMassandVolumeTransferTotalsandInventories',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127444,
                        name: 'PRINT_PrintAPITransferTotalandInventory',
                        requireDoubleRight: true,
                      },
                      {
                        id: 55311127555,
                        name: 'PRINT_PrintEDNetMasstotalandinventory',
                        requireDoubleRight: true,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 56,
        name: 'Sensor Parameters',
        children: [
          {
            id: 561,
            name: 'Sensor Type',
            children: [
              {id: 5611, name: 'Curved Tube', requireDoubleRight: true},
              {id: 5612, name: 'Straight Tube', requireDoubleRight: true},
            ],
          },
          {id: 562, name: 'FCF', component: <FCFTN />},
          {id: 563, name: 'D1', component: <D1TN />},
          {id: 564, name: 'D2', component: <D2TN />},
          {id: 565, name: 'K1', component: <K1TN />},
          {id: 566, name: 'K2', component: <K2TN />},
          {id: 567, name: 'DT', component: <DTTN />},
          {id: 568, name: 'FD', component: <FDTN />},
          {id: 569, name: 'FTG', component: <FTGTN />},
          {id: 570, name: 'FFQ', component: <FFQTN />},
          {id: 571, name: 'DTG', component: <DTGTN />},
          {id: 572, name: 'DFQ1', component: <DFQ1TN />},
          {id: 573, name: 'DFQ2', component: <DFQ2TN />},
          {id: 574, name: 'Temperature Slope', component: <SlopeTN />},
          {id: 575, name: 'Temperature Offset', component: <OffsetTN />},
        ],
      },
      {
        id: 57,
        name: 'Totalizer Log',
        children: [
          {id: 5711, name: 'Start Logging Date', component: <LoggingDateTN />},
          {id: 5712, name: 'Start Logging Time', component: <LoggingTimeTN />},
          {id: 5713, name: 'Log Interval (hours)', component: <LogInterval />},
          {
            id: 5714,
            name: 'Log Total 1',
            children: [
              {id: 57141, name: 'Totalizer 1', requireDoubleRight: true},
              {id: 57142, name: 'Totalizer 2', requireDoubleRight: true},
              {id: 57143, name: 'Totalizer 3', requireDoubleRight: true},
              {id: 57144, name: 'Totalizer 4', requireDoubleRight: true},
              {id: 57145, name: 'Totalizer 5', requireDoubleRight: true},
              {id: 57146, name: 'Totalizer 6', requireDoubleRight: true},
              {id: 57147, name: 'Totalizer 7', requireDoubleRight: true},
              {id: 57148, name: 'Inventory 1', requireDoubleRight: true},
              {id: 57149, name: 'Inventory 2', requireDoubleRight: true},
              {id: 57150, name: 'Inventory 3', requireDoubleRight: true},
              {id: 57151, name: 'Inventory 4', requireDoubleRight: true},
              {id: 57152, name: 'Inventory 5', requireDoubleRight: true},
              {id: 57153, name: 'Inventory 6', requireDoubleRight: true},
              {id: 57154, name: 'Inventory 7', requireDoubleRight: true},
              {id: 57155, name: 'None', requireDoubleRight: true},
            ],
          },
          {
            id: 5715,
            name: 'Log Total 2',
            children: [
              {id: 57156, name: 'Totalizer 1', requireDoubleRight: true},
              {id: 57157, name: 'Totalizer 2', requireDoubleRight: true},
              {id: 57158, name: 'Totalizer 3', requireDoubleRight: true},
              {id: 57159, name: 'Totalizer 4', requireDoubleRight: true},
              {id: 57160, name: 'Totalizer 5', requireDoubleRight: true},
              {id: 57161, name: 'Totalizer 6', requireDoubleRight: true},
              {id: 57162, name: 'Totalizer 7', requireDoubleRight: true},
              {id: 57163, name: 'Inventory 1', requireDoubleRight: true},
              {id: 57164, name: 'Inventory 2', requireDoubleRight: true},
              {id: 57165, name: 'Inventory 3', requireDoubleRight: true},
              {id: 57166, name: 'Inventory 4', requireDoubleRight: true},
              {id: 57167, name: 'Inventory 5', requireDoubleRight: true},
              {id: 57168, name: 'Inventory 6', requireDoubleRight: true},
              {id: 57169, name: 'Inventory 7', requireDoubleRight: true},
              {id: 57170, name: 'None', requireDoubleRight: true},
            ],
          },
          {
            id: 5716,
            name: 'Log Total 3',
            children: [
              {id: 57171, name: 'Totalizer 1', requireDoubleRight: true},
              {id: 57172, name: 'Totalizer 2', requireDoubleRight: true},
              {id: 57173, name: 'Totalizer 3', requireDoubleRight: true},
              {id: 57174, name: 'Totalizer 4', requireDoubleRight: true},
              {id: 57175, name: 'Totalizer 5', requireDoubleRight: true},
              {id: 57176, name: 'Totalizer 6', requireDoubleRight: true},
              {id: 57177, name: 'Totalizer 7', requireDoubleRight: true},
              {id: 57178, name: 'Inventory 1', requireDoubleRight: true},
              {id: 57179, name: 'Inventory 2', requireDoubleRight: true},
              {id: 57180, name: 'Inventory 3', requireDoubleRight: true},
              {id: 57181, name: 'Inventory 4', requireDoubleRight: true},
              {id: 57182, name: 'Inventory 5', requireDoubleRight: true},
              {id: 57183, name: 'Inventory 6', requireDoubleRight: true},
              {id: 57184, name: 'Inventory 7', requireDoubleRight: true},
              {id: 57185, name: 'None', requireDoubleRight: true},
            ],
          },
          {
            id: 5717,
            name: 'Log Total 4',
            children: [
              {id: 57186, name: 'Totalizer 1', requireDoubleRight: true},
              {id: 57187, name: 'Totalizer 2', requireDoubleRight: true},
              {id: 57188, name: 'Totalizer 3', requireDoubleRight: true},
              {id: 57189, name: 'Totalizer 4', requireDoubleRight: true},
              {id: 57190, name: 'Totalizer 5', requireDoubleRight: true},
              {id: 57191, name: 'Totalizer 6', requireDoubleRight: true},
              {id: 57192, name: 'Totalizer 7', requireDoubleRight: true},
              {id: 57193, name: 'Inventory 1', requireDoubleRight: true},
              {id: 57194, name: 'Inventory 2', requireDoubleRight: true},
              {id: 57195, name: 'Inventory 3', requireDoubleRight: true},
              {id: 57196, name: 'Inventory 4', requireDoubleRight: true},
              {id: 57197, name: 'Inventory 5', requireDoubleRight: true},
              {id: 57198, name: 'Inventory 6', requireDoubleRight: true},
              {id: 57199, name: 'Inventory 7', requireDoubleRight: true},
              {id: 57200, name: 'None', requireDoubleRight: true},
            ],
          },
        ],
      },
      {
        id: 58,
        name: 'Weights & Measures',
        children: [
          {
            id: 581,
            name: 'World Area',
            children: [
              {id: 5811, name: 'WA_OIML', requireDoubleRight: true},
              {id: 5812, name: 'WA_NTEP', requireDoubleRight: true},
            ],
          },
          {
            id: 582,
            name: 'Approve Variables',
            children: [
              {
                id: 58111,
                name: 'Mass Flow Rate',
                children: [
                  {id: 581111, name: '0', requireDoubleRight: true},
                  {id: 581112, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58112,
                name: 'Volume Flow Rate',
                children: [
                  {id: 581121, name: '0', requireDoubleRight: true},
                  {id: 581122, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58113,
                name: 'GSV Flow Rate',
                children: [
                  {id: 581131, name: '0', requireDoubleRight: true},
                  {id: 581132, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58114,
                name: 'Temperature',
                children: [
                  {id: 581141, name: '0', requireDoubleRight: true},
                  {id: 581142, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58115,
                name: 'Density',
                children: [
                  {id: 581151, name: '0', requireDoubleRight: true},
                  {id: 581152, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58116,
                name: 'Referred Density',
                children: [
                  {id: 581161, name: '0', requireDoubleRight: true},
                  {id: 581162, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58117,
                name: 'Referred Volume Flow',
                children: [
                  {id: 581171, name: '0', requireDoubleRight: true},
                  {id: 581172, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58118,
                name: 'Average Line Density',
                children: [
                  {id: 581181, name: '0', requireDoubleRight: true},
                  {id: 581182, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58119,
                name: 'Average Temperature',
                children: [
                  {id: 581191, name: '0', requireDoubleRight: true},
                  {id: 581192, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58120,
                name: 'CTPL',
                children: [
                  {id: 581201, name: '0', requireDoubleRight: true},
                  {id: 581202, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58121,
                name: 'Specific Gravity',
                children: [
                  {id: 581211, name: '0', requireDoubleRight: true},
                  {id: 581212, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58122,
                name: 'Standard Vol Flow',
                children: [
                  {id: 581221, name: '0', requireDoubleRight: true},
                  {id: 581222, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58123,
                name: 'Net Mass Flow',
                children: [
                  {id: 581231, name: '0', requireDoubleRight: true},
                  {id: 581232, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58124,
                name: 'Net Volume Flow Rate',
                children: [
                  {id: 581241, name: '0', requireDoubleRight: true},
                  {id: 581242, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58125,
                name: 'Concentration',
                children: [
                  {id: 581251, name: '0', requireDoubleRight: true},
                  {id: 581252, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58126,
                name: 'Totalizer 1',
                children: [
                  {id: 581261, name: '0', requireDoubleRight: true},
                  {id: 581262, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58127,
                name: 'Totalizer 2',
                children: [
                  {id: 581271, name: '0', requireDoubleRight: true},
                  {id: 581272, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58128,
                name: 'Totalizer 3',
                children: [
                  {id: 581281, name: '0', requireDoubleRight: true},
                  {id: 581282, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58129,
                name: 'Totalizer 4',
                children: [
                  {id: 581291, name: '0', requireDoubleRight: true},
                  {id: 581292, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58130,
                name: 'Totalizer 5',
                children: [
                  {id: 581301, name: '0', requireDoubleRight: true},
                  {id: 581302, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58131,
                name: 'Totalizer 6',
                children: [
                  {id: 581311, name: '0', requireDoubleRight: true},
                  {id: 581312, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58132,
                name: 'Totalizer 7',
                children: [
                  {id: 581321, name: '0', requireDoubleRight: true},
                  {id: 581322, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58133,
                name: 'Inventory 1',
                children: [
                  {id: 581331, name: '0', requireDoubleRight: true},
                  {id: 581332, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58134,
                name: 'Inventory 2',
                children: [
                  {id: 581341, name: '0', requireDoubleRight: true},
                  {id: 581342, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58135,
                name: 'Inventory 3',
                children: [
                  {id: 581351, name: '0', requireDoubleRight: true},
                  {id: 581352, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58136,
                name: 'Inventory 4',
                children: [
                  {id: 581361, name: '0', requireDoubleRight: true},
                  {id: 581362, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58137,
                name: 'Inventory 5',
                children: [
                  {id: 581371, name: '0', requireDoubleRight: true},
                  {id: 581372, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58138,
                name: 'Inventory 6',
                children: [
                  {id: 581381, name: '0', requireDoubleRight: true},
                  {id: 581382, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58139,
                name: 'Inventory 7',
                children: [
                  {id: 581391, name: '0', requireDoubleRight: true},
                  {id: 581392, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58140,
                name: 'Velocity',
                children: [
                  {id: 581401, name: '0', requireDoubleRight: true},
                  {id: 581402, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58141,
                name: 'Tube Frequency',
                children: [
                  {id: 581411, name: '0', requireDoubleRight: true},
                  {id: 581412, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58142,
                name: 'Drive Gain',
                children: [
                  {id: 581421, name: '0', requireDoubleRight: true},
                  {id: 581422, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58143,
                name: 'Case Temperature',
                children: [
                  {id: 581431, name: '0', requireDoubleRight: true},
                  {id: 581432, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58144,
                name: 'LPO Amplitude',
                children: [
                  {id: 581441, name: '0', requireDoubleRight: true},
                  {id: 581442, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58145,
                name: 'RPO Amplitude',
                children: [
                  {id: 581451, name: '0', requireDoubleRight: true},
                  {id: 581452, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58146,
                name: 'Board Temperature',
                children: [
                  {id: 581461, name: '0', requireDoubleRight: true},
                  {id: 581462, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58147,
                name: 'Input Voltage',
                children: [
                  {id: 581471, name: '0', requireDoubleRight: true},
                  {id: 581472, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58148,
                name: 'External Pressure',
                children: [
                  {id: 581481, name: '0', requireDoubleRight: true},
                  {id: 581482, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58149,
                name: 'External Temperature',
                children: [
                  {id: 581491, name: '0', requireDoubleRight: true},
                  {id: 581492, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58150,
                name: 'Field Verification Zero',
                children: [
                  {id: 581501, name: '0', requireDoubleRight: true},
                  {id: 581502, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58151,
                name: 'Live Zero',
                children: [
                  {id: 581511, name: '0', requireDoubleRight: true},
                  {id: 581512, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58152,
                name: 'Flow Rate Switch',
                children: [
                  {id: 581521, name: '0', requireDoubleRight: true},
                  {id: 581522, name: '1', requireDoubleRight: true},
                ],
              },
              {
                id: 58153,
                name: 'Phase',
                children: [
                  {id: 581531, name: '0', requireDoubleRight: true},
                  {id: 581532, name: '1', requireDoubleRight: true},
                ],
              },
            ],
          },
          {id: 583, name: 'Transmitter Checksum'},
          {id: 584, name: 'Core Checksum'},
          {id: 585, name: 'PIC Checksum'},
          {id: 586, name: 'LCD PIC Checksum'},
          {id: 587, name: 'Switch Status'},
        ],
      },
      {
        id: 59,
        name: 'Security',
        children: [
          {
            id: 591,
            name: 'Display Security',
            children: [
              {
                id: 5911,
                name: 'Password Required',
                children: [
                  {id: 59111, name: 'Never', requireDoubleRight: true},
                  {id: 59112, name: 'At Write', requireDoubleRight: true},
                  {id: 59113, name: 'Enter Menu', requireDoubleRight: true},
                ],
              },
              {
                id: 5912,
                name: 'Alert Security',
                children: [
                  {id: 59121, name: 'On', requireDoubleRight: true},
                  {id: 59122, name: 'Off', requireDoubleRight: true},
                ],
              },
              {
                id: 5913,
                name: 'Main Menu Available',
                component: <MenuAvailable />,
                children: [
                  {id: 59131, name: 'Enabled', requireDoubleRight: true},
                  {id: 59132, name: 'Disabled', requireDoubleRight: true},
                ],
              },
              {
                id: 5914,
                name: 'Totalizers & Inventories',
                children: [
                  {
                    id: 59141,
                    name: 'Totalizer Reset',
                    children: [
                      {id: 591411, name: 'On', requireDoubleRight: true},
                      {id: 591412, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 59142,
                    name: 'Totalizer Start/Stop',
                    children: [
                      {id: 591421, name: 'On', requireDoubleRight: true},
                      {id: 591422, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 59143,
                    name: 'Inventory Reset',
                    children: [
                      {id: 591431, name: 'On', requireDoubleRight: true},
                      {id: 591432, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 59144,
                    name: 'Inventory Start/Stop',
                    children: [
                      {id: 591441, name: 'On', requireDoubleRight: true},
                      {id: 591442, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                  {
                    id: 59145,
                    name: 'Tot/Inv Options Menu',
                    children: [
                      {id: 591451, name: 'On', requireDoubleRight: true},
                      {id: 591452, name: 'Off', requireDoubleRight: true},
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 592,
            name: 'Service Port',
            children: [
              {id: 5921, name: 'On', requireDoubleRight: true},
              {id: 5922, name: 'Off', requireDoubleRight: true},
            ],
          },
        ],
      },
      {
        id: 60,
        name: 'Device Information',
        children: [
          {id: 601, name: 'Sensor Serial Number', component: <SensorSerialTN />},
          {id: 602, name: 'Transmitter Serial No.', component: <TransmitterSerialTN />},
          {id: 603, name: 'Model Code Base', component: <CodeBaseTN />},
          {id: 604, name: 'Model Code Options', component: <CodeOptionsTN />},
        ],
      },
      {
        id: 61,
        name: 'Save/Restore Config',
        children: [
          {id: 611, name: 'Save Config to Memory', component: <SaveConfigTN />},
          {id: 612, name: 'Restore Config from Memory'},
        ],
      },
      {id: 62, name: 'Guided Setup', component: <GuidedConfiguration />},
    ],
  },
  {
    id: 6,
    name: 'Service Tools',
    children: [
      getAlerts(6111, 6121, 6131),
      {
        id: 63,
        name: 'Verification & Calibration',
        children: [
          {id: 631, name: 'Density Determination'},
          getInstallationVerification(6311, 6312, 6313),
          getSMV(
            6323,
            6324,
            6325,
            6326,
            63261,
            63262,
            63263,
            63264,
            63265,
            63266,
            63267,
            63268,
            63269,
          ),
          getMeterZero(6327, 6328, 6329, 6330, 63301, 63302, 63303),
          {
            id: 633,
            name: 'Density Calibration',
            children: [
              {
                id: 6331,
                name: 'D1 (Air)',
                children: [
                  {id: 63311, name: 'Density of Fluid', component: <D1FluidTN />},
                  {id: 63312, name: 'K1'},
                  {id: 63313, name: 'Start Calibration', component: <D1CalibrationCompleted />},
                ],
              },
              {
                id: 6332,
                name: 'D2 (Water)',
                children: [
                  {id: 63321, name: 'Density of Fluid', component: <D2FluidTN />},
                  {id: 63322, name: 'K2'},
                  {id: 63323, name: 'Start Calibration', component: <D2CalibrationCompleted />},
                ],
              },
            ],
          },
        ],
      },
      {
        id: 64,
        name: 'Service Data',
        children: [
          {id: 641, name: 'View Process Variables', component: <ProcessVariable />},
          {id: 642, name: 'View Diagnostiic Variables', component: <DiagnostiicVariable />},
          {id: 643, name: 'View I/O Levels', component: <IOLevels />},
          {id: 644, name: 'View Lifetime Statistics', component: <LifetimeStats />},
          {id: 645, name: 'View Configuration Summary', component: <ConfigSummary />},
        ],
      },
      getSensorSimulation(
        65,
        651,
        652,
        653,
        6531,
        6532,
        6533,
        6534,
        6535,
        6536,
        6537,
        6538,
        6539,
        6540,
        6541,
        6542,
        6543,
        6544,
        6545,
        6546,
        6547,
        6548,
        6549,
        6550,
        6551,
        6552,
        6553,
        6554,
        6555,
        6556,
        6557,
      ),
      getOutputSimulation(66, 661, 662, 663, 664),
      getMaOutTrim(67, 671, 672, 673, 674),
      {id: 68, name: 'mA Input Trim', component: <MAInputTrim4 />},
      {
        id: 69,
        name: 'License Manager',
        children: [
          {id: 691, name: 'Unique ID'},
          {id: 692, name: 'Enter Permanent License', component: <LicenseTN />},
          {id: 693, name: 'Enter Trial License', component: <TrialTN />},
        ],
      },
      {id: 70, name: 'Reboot Transmitter', component: <RebootTransmitter />},
    ],
  },
  {
    id: 7,
    name: 'USB Options',
    children: [
      {
        id: 71,
        name: 'Transmitter--&gt USB Drive',
        children: [
          {
            id: 711,
            name: 'Download Service Files',
            children: [
              {id: 7111, name: 'DLOAD_allServiceFiles', requireDoubleRight: true},
              {id: 7112, name: 'DLOAD_auditTrail', requireDoubleRight: true},
              {id: 7113, name: 'DLOAD_alertLog', requireDoubleRight: true},
              {id: 7114, name: 'DLOAD_last30Days', requireDoubleRight: true},
              {id: 7115, name: 'DLOAD_lastDay', requireDoubleRight: true},
              {id: 7116, name: 'DLOAD_mvLast20Runs', requireDoubleRight: true},
              {id: 7117, name: 'DLOAD_serviceImage', requireDoubleRight: true},
              {id: 7118, name: 'DLOAD_factoryConfig', requireDoubleRight: true},
              {id: 7119, name: 'DLOAD_assertLog', requireDoubleRight: true},
              {id: 7120, name: 'DLOAD_supportContact', requireDoubleRight: true},
              {id: 7121, name: 'DLOAD_securityLog', requireDoubleRight: true},
            ],
          },
          {
            id: 712,
            name: 'Download Historical Files',
            children: [
              {id: 7122, name: 'Historian Data', requireDoubleRight: true},
              {id: 7123, name: 'SMV: Lifetime', requireDoubleRight: true},
              {id: 7124, name: 'SMV: 20 Runs', requireDoubleRight: true},
              {id: 7125, name: 'Totalizer Log', requireDoubleRight: true},
              {id: 7126, name: 'Totalizer History', requireDoubleRight: true},
            ],
          },
          {
            id: 713,
            name: 'Save Configuration File',
            children: [
              {
                id: 7131,
                name: 'Save Active Config to USB Drive',
                children: [
                  {id: 71311, name: 'Database::CFGFILE_TYPE_SPARE_USB', requireDoubleRight: true},
                  {id: 71312, name: 'Database::CFGFILE_TYPE_XFER_USB', requireDoubleRight: true},
                  {id: 71313, name: 'Database::CFGFILE_TYPE_DUMP_USB', requireDoubleRight: true},
                  {id: 71314, name: 'Database::CFGFILE_TYPE_EDF_USB', requireDoubleRight: true},
                ],
              },
              {
                id: 7132,
                name: 'Transfer Config File to USB Drive',
                children: [
                  {id: 71321, name: 'Database::CFGFILE_TYPE_SPARE_SD', requireDoubleRight: true},
                  {id: 71322, name: 'Database::CFGFILE_TYPE_XFER_SD', requireDoubleRight: true},
                  {id: 71323, name: 'Database::CFGFILE_TYPE_EDF_SD', requireDoubleRight: true},
                ],
              },
            ],
          },
          {
            id: 714,
            name: 'Download Support Files',
            children: [
              {id: 7141, name: 'EDS file', requireDoubleRight: true},
              {id: 7142, name: 'GSD file', requireDoubleRight: true},
            ],
          },
        ],
      },
      {
        id: 72,
        name: 'USB Drive --&gt Transmitter',
        children: [
          {
            id: 721,
            name: 'Upload Configuration File',
            children: [
              {id: 7211, name: 'Database::CFGFILE_TYPE_SPARE_USB', requireDoubleRight: true},
              {id: 7212, name: 'Database::CFGFILE_TYPE_XFER_USB', requireDoubleRight: true},
              {id: 7213, name: 'Database::CFGFILE_TYPE_EDF_USB', requireDoubleRight: true},
            ],
          },
          {id: 722, name: 'Update Device Software'},
          {id: 723, name: 'Load License File', component: <LoadLicense />},
        ],
      },
    ],
  },
  {
    id: 8,
    name: 'Startup Tasks',
    children: [
      {id: 81, name: 'Guided Setup', component: <GuidedConfiguration />},
      {
        id: 82,
        name: 'Commissioning Tools',
        children: [
          getInstallationVerification(821, 822, 823),
          getSMV(831, 832, 833, 834, 8341, 8342, 8343, 8344, 8345, 8346, 8347, 8348, 8349),
          getMaOutTrim(841, 842, 843, 844, 845),
          {id: 86, name: 'mA Input Trim', component: <MAInputTrim4 />},
          getOutputSimulation(851, 852, 853, 854, 855),
          getSensorSimulation(
            861,
            862,
            863,
            864,
            865,
            8651,
            8652,
            8653,
            8654,
            8655,
            8656,
            8657,
            8658,
            8659,
            8660,
            8661,
            8662,
            8663,
            8664,
            8665,
            8666,
            8667,
            8668,
            8669,
            8670,
            8671,
            8672,
            8673,
            8674,
            8675,
            8676,
          ),
          {id: 89, name: 'Zero Verification', component: <ZeroVerification />},
        ],
      },
    ],
  },
  {
    id: 9,
    name: 'About',
    children: [
      {id: 91, name: 'Device Information', component: <DeviceInfo />},
      {id: 92, name: 'Versions', component: <Versions />},
      {id: 93, name: 'Licenses', component: <Licenses />},
      {id: 94, name: 'Sensor Information', component: <SensorInfo />},
    ],
  },
];

export const sensorFailedItem = [
  {id: 1, name: '[003] Sensor Error', component: <SensorError />},
  {id: 2, name: '[016] Sensor Temp Failure', component: <SensorTemp />},
  {id: 3, name: '[017] Sensor Case Temp Fail', component: <SensorCase />},
];

export const yesNoItem = [
  {id: 1, name: 'Yes'},
  {id: 2, name: 'No'},
];

export const languages = [
  {id: 1, name: 'English', requireDoubleRight: true, code: 'en'},
  {id: 2, name: '中文', requireDoubleRight: true, code: 'ch'},
  {id: 3, name: 'Español', requireDoubleRight: true, code: 'sp'},
  {id: 4, name: 'Deutsch', requireDoubleRight: true, code: 'ge'},
  {id: 5, name: 'Français', requireDoubleRight: true, code: 'fr'},
  {id: 6, name: '日本語', requireDoubleRight: true, code: 'ja'},
  {id: 7, name: 'Русский', requireDoubleRight: true, code: 'ru'},
  {id: 8, name: 'Português', requireDoubleRight: true, code: 'po'},
];

export const timeZoneItem = [
  {id: 1, name: 'TZ_dateLine', requireDoubleRight: true},
  {id: 2, name: 'TZ_samoa', requireDoubleRight: true},
  {id: 3, name: 'TZ_hawaii', requireDoubleRight: true},
  {id: 4, name: 'TZ_alaska', requireDoubleRight: true},
  {id: 5, name: 'TZ_pacific', requireDoubleRight: true},
  {id: 6, name: 'TZ_mountain', requireDoubleRight: true},
  {id: 7, name: 'TZ_central', requireDoubleRight: true},
  {id: 8, name: 'TZ_eastern', requireDoubleRight: true},
  {id: 9, name: 'TZ_atlantic', requireDoubleRight: true},
  {id: 10, name: 'TZ_newfoundLand', requireDoubleRight: true},
  {id: 11, name: 'TZ_saEastern', requireDoubleRight: true},
  {id: 12, name: 'TZ_midAtlantic', requireDoubleRight: true},
  {id: 13, name: 'TZ_azores', requireDoubleRight: true},
  {id: 14, name: 'TZ_greenwich', requireDoubleRight: true},
  {id: 15, name: 'TZ_centralEU', requireDoubleRight: true},
  {id: 16, name: 'TZ_europe', requireDoubleRight: true},
  {id: 17, name: 'TZ_russian', requireDoubleRight: true},
  {id: 18, name: 'TZ_iran', requireDoubleRight: true},
  {id: 19, name: 'TZ_arabian', requireDoubleRight: true},
  {id: 20, name: 'TZ_afghan', requireDoubleRight: true},
  {id: 21, name: 'TZ_westAsia', requireDoubleRight: true},
  {id: 22, name: 'TZ_india', requireDoubleRight: true},
  {id: 23, name: 'TZ_nepal', requireDoubleRight: true},
  {id: 24, name: 'TZ_centralAsia', requireDoubleRight: true},
  {id: 25, name: 'TZ_myanmar', requireDoubleRight: true},
  {id: 26, name: 'TZ_seAsia', requireDoubleRight: true},
  {id: 27, name: 'TZ_china', requireDoubleRight: true},
  {id: 28, name: 'TZ_korea', requireDoubleRight: true},
  {id: 29, name: 'TZ_centralAustralia', requireDoubleRight: true},
  {id: 30, name: 'TZ_eastAustralia', requireDoubleRight: true},
  {id: 31, name: 'TZ_centralPacific', requireDoubleRight: true},
  {id: 32, name: 'TZ_fiji', requireDoubleRight: true},
  {id: 33, name: 'TZ_tonga', requireDoubleRight: true},
];

export const massUnitItem = [
  {id: 1, name: 'gram/s', requireDoubleRight: true},
  {id: 2, name: 'gram/min', requireDoubleRight: true},
  {id: 3, name: 'gram/h', requireDoubleRight: true},
  {id: 4, name: 'kg/s', requireDoubleRight: true},
  {id: 5, name: 'kg/min', requireDoubleRight: true},
  {id: 6, name: 'kg/h', requireDoubleRight: true},
  {id: 7, name: 'kg/d', requireDoubleRight: true},
  {id: 8, name: 'MetTon/min', requireDoubleRight: true},
  {id: 9, name: 'MetTon/h', requireDoubleRight: true},
  {id: 10, name: 'MetTon/d', requireDoubleRight: true},
  {id: 11, name: 'lb/s', requireDoubleRight: true},
  {id: 12, name: 'lb/min', requireDoubleRight: true},
  {id: 13, name: 'lb/h', requireDoubleRight: true},
  {id: 14, name: 'lb/d', requireDoubleRight: true},
  {id: 15, name: 'STon/min', requireDoubleRight: true},
  {id: 16, name: 'STon/h', requireDoubleRight: true},
  {id: 17, name: 'STon/d', requireDoubleRight: true},
  {id: 18, name: 'LTon/h', requireDoubleRight: true},
  {id: 19, name: 'LTon/d', requireDoubleRight: true},
  {id: 20, name: 'SPECIAL', requireDoubleRight: true},
];

export const volumeUnitItem = [
  {id: 1, name: 'L/s', requireDoubleRight: true},
  {id: 2, name: 'L/min', requireDoubleRight: true},
  {id: 3, name: 'L/h', requireDoubleRight: true},
  {id: 4, name: 'MML/d', requireDoubleRight: true},
  {id: 5, name: 'm3/s', requireDoubleRight: true},
  {id: 6, name: 'm3/min', requireDoubleRight: true},
  {id: 7, name: 'm3/h', requireDoubleRight: true},
  {id: 8, name: 'm3/d', requireDoubleRight: true},
  {id: 9, name: 'ft3/s', requireDoubleRight: true},
  {id: 10, name: 'ft3/min', requireDoubleRight: true},
  {id: 11, name: 'ft3/h', requireDoubleRight: true},
  {id: 12, name: 'ft3/d', requireDoubleRight: true},
  {id: 13, name: 'gal/s', requireDoubleRight: true},
  {id: 14, name: 'gal/min', requireDoubleRight: true},
  {id: 15, name: 'gal/h', requireDoubleRight: true},
  {id: 16, name: 'gal/d', requireDoubleRight: true},
  {id: 17, name: 'MMgal/d', requireDoubleRight: true},
  {id: 18, name: 'Impgal/s', requireDoubleRight: true},
  {id: 19, name: 'Impgal/min', requireDoubleRight: true},
  {id: 20, name: 'Impgal/h', requireDoubleRight: true},
  {id: 21, name: 'Impgal/d', requireDoubleRight: true},
  {id: 22, name: 'bbl/s', requireDoubleRight: true},
  {id: 23, name: 'bbl/min', requireDoubleRight: true},
  {id: 24, name: 'bbl/h', requireDoubleRight: true},
  {id: 25, name: 'bbl/d', requireDoubleRight: true},
  {id: 26, name: 'Beer bbl/s', requireDoubleRight: true},
  {id: 27, name: 'Beer bbl/min', requireDoubleRight: true},
  {id: 28, name: 'Beer bbl/d', requireDoubleRight: true},
  {id: 29, name: 'SPECIAL', requireDoubleRight: true},
];

export const densityUnitItem = [
  {id: 1, name: 'SGU', requireDoubleRight: true},
  {id: 2, name: 'g/cm3', requireDoubleRight: true},
  {id: 3, name: 'g/mL', requireDoubleRight: true},
  {id: 4, name: 'g/L', requireDoubleRight: true},
  {id: 5, name: 'kg/L', requireDoubleRight: true},
  {id: 6, name: 'kg/m3', requireDoubleRight: true},
  {id: 7, name: 'lb/gal', requireDoubleRight: true},
  {id: 8, name: 'lb/in3', requireDoubleRight: true},
  {id: 9, name: 'lb/ft3', requireDoubleRight: true},
  {id: 10, name: 'STon/yd3', requireDoubleRight: true},
  {id: 11, name: '°API', requireDoubleRight: true},
];

export const temperatureUnitItem = [
  {id: 1, name: '°C', requireDoubleRight: true},
  {id: 2, name: '°F', requireDoubleRight: true},
  {id: 3, name: '°R', requireDoubleRight: true},
  {id: 4, name: 'K', requireDoubleRight: true},
];

export const channelItem = [
  {
    id: 1,
    name: 'Channel A',
    children: [
      {
        id: 11,
        name: 'Milliamp Output 1',
        children: [
          {
            id: 111,
            name: 'Active',
            children: [
              {id: 1111, name: 'Mass Flow Rate'},
              {id: 1112, name: 'Volume Flow Rate'},
              {id: 1113, name: 'Drive Gain'},
              {id: 1114, name: 'GSV Flow Rate'},
              {id: 1115, name: 'Velocity'},
              {id: 1116, name: 'Temperature'},
              {id: 1117, name: 'Density'},
              {id: 1118, name: 'External Pressure'},
              {id: 1119, name: 'External Temperature'},
              {id: 1120, name: 'External Density'},
              {id: 1121, name: 'FI Flow Rate'},
              {id: 1122, name: 'PV_PG_FLOW_SEVERITY'},
              {id: 1123, name: 'Referred Density'},
              {id: 1124, name: 'Referred Volume Flow'},
              {id: 1125, name: 'Avg. Line Density'},
              {id: 1126, name: 'Avg. Temperature'},
              {id: 1127, name: 'Referred Density'},
              {id: 1128, name: 'Specific Gravity'},
              {id: 1129, name: 'Standard Vol Flow'},
              {id: 1130, name: 'Net Mass Flow'},
              {id: 1131, name: 'Net Volume Flow Rate'},
              {id: 1132, name: 'Concentration'},
              {id: 1133, name: '% of Fill'},
              {id: 1134, name: 'PV_FUEL_DIFF_MASS_FLOW'},
              {id: 1135, name: 'PV_NET_FLOW_OIL_AT_LINE'},
              {id: 1136, name: 'PV_WATERCUT_AT_LINE'},
              {id: 1137, name: 'PV_EXT_WATERCUT'},
              {id: 1138, name: 'PV_NET_FLOW_WATER_AT_LINE'},
              {id: 1139, name: 'PV_NET_FLOW_OIL_AT_REF'},
              {id: 1140, name: 'PV_WATERCUT_AT_REF'},
              {id: 1141, name: 'PV_NET_FLOW_WATER_AT_REF'},
              {id: 1142, name: 'PV_GAS_VOID_FRACTION'},
              {id: 1143, name: 'PV_UNREM_MASS_FLOW'},
              {id: 1144, name: 'PV_UNREM_VOL_FLOW'},
              {id: 1145, name: 'PV_UNREM_DENSITY'},
              {id: 1146, name: 'PV_DEN_CALORIFIC_VALUE'},
              {id: 1147, name: 'PV_DEN_ENERGY_FLOW'},
              {id: 1148, name: 'PV_NOC_UNC_GROSS_FLOW'},
              {id: 1149, name: 'PV_NOC_UNC_GROSS_FLOW'},
              {id: 1150, name: 'PV_NOC_AVE_UNC_OIL_FLOW'},
              {id: 1151, name: 'PV_NOC_AVE_UNC_WATER_CUT'},
              {id: 1152, name: 'PV_NOC_AVE_UNC_GROSS_FLOW'},
              {id: 1153, name: 'PV_NOC_AVE_UNC_WATER_FLOW'},
              {id: 1154, name: 'PV_NOC_AVE_UNC_BACK_FLOW'},
              {id: 1155, name: 'PV_NOC_AVE_NET_OIL_FLOW'},
              {id: 1156, name: 'PV_NOC_AVE_NET_WATER_CUT'},
              {id: 1157, name: 'PV_NOC_AVE_NET_GROSS_FLOW'},
              {id: 1158, name: 'PV_NOC_AVE_NET_WATER_FLOW'},
              {id: 1159, name: 'PV_NOC_AVE_DENSITY'},
              {id: 1160, name: 'PV_NOC_AVE_TEMPERATURE'},
              {id: 1161, name: 'PV_NOC_AVE_MASS_FLOW'},
              {id: 1162, name: 'PV_TMR_LIQUID_FLOW'},
            ],
          },
          {id: 112, name: 'Passive'},
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Channel B',
    children: [
      {id: 21, name: 'Milliamp Output 2'},
      {id: 22, name: 'Frequency Output 2'},
      {id: 23, name: 'Discrete Output 1'},
      {id: 24, name: 'None'},
    ],
  },
  {
    id: 3,
    name: 'Channel C',
    children: [
      {id: 31, name: 'Milliamp Output 3'},
      {id: 32, name: 'Milliamp Output 3'},
      {id: 33, name: 'Frequency Output 1'},
      {id: 34, name: 'Discrete Output 1'},
      {id: 35, name: 'Discrete Output 2'},
      {id: 36, name: 'Discrete Input 1'},
      {id: 37, name: 'None'},
    ],
  },
  {
    id: 4,
    name: 'Channel D',
    children: [
      {id: 41, name: 'Frequency Output 2'},
      {id: 42, name: 'Discrete Output 2'},
      {id: 43, name: 'Discrete Output 3'},
      {id: 44, name: 'Discrete Input 2'},
      {id: 45, name: 'Milliamp Input 1'},
      {id: 46, name: 'Frequency Input'},
      {id: 47, name: 'None'},
    ],
  },
  {id: 5, name: 'Channel E', component: <SetModbus />},
  {id: 6, name: 'Finished'},
];

function App() {
  const [showMenu, setShowMenu] = useState(false);
  const rightPress = useKeyPress('ArrowRight');
  const leftPress = useKeyPress('ArrowLeft');
  const [alert, setAlert] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [items, setItems] = useState(() => [...masterList]);
  const [sensorFailed, setSensorFailed] = useState(sensorFailedItem);
  const [showSplashScreen, setShowSplashScreen] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showAck, setShowAck] = useState(false);
  const [info, setInfo] = useState(false);
  const [sensorError, setsensorError] = useState(false);
  const [component, setComponent] = useState();
  const [disableMenu, setDisableMenu] = useState(false);
  const [selected, setSelected] = useState();
  const [list, setList] = useState([]);

  useEffect(() => {
    if (!leftPress) {
      return;
    }
    if (!alert) {
      if (showAck === false && showInfo === true) {
        setShowInfo(false);
        setShowAck(false);
      }
    }
  }, [leftPress]);

  useEffect(() => {
    const [newItems] = generateAlertsChildren(items);
    setItems(newItems);
  }, [alert]);

  const handleResetDevice = () => {
    setShowSplashScreen(true);
    setDisableMenu(true);
    setShowMenu(false);
    setTimeout(() => {
      setComponent(<SelfTest />);
      setShowSplashScreen(false);
    }, 3000);
  };

  const handleAlert = () => {
    if (alert === true) {
      setAlert(false);
      setsensorError(false);
      setShowAck(false);
      setInfo(false);
    }
    if (alert === false) {
      setAlert(true);
      setsensorError(true);
    }
  };

  const handleShowHelp = () => {
    if (showHelp === true) {
      setShowHelp(false);
    }
    if (showHelp === false) {
      setShowHelp(true);
    }
  };

  useEffect(() => {
    setItems(showInfo ? sensorFailedItem : masterList);
    setList(showInfo ? sensorFailed : []);
    setSelected(showInfo ? sensorFailed[0] : null);
  }, [showInfo]);

  useEffect(() => {
    setList(showMenu ? items : []);
    setSelected(showMenu ? items[0] : null);
  }, [showMenu]);

  useEffect(() => {
    if (!selected) {
      return;
    }

    const newList = findList(items, selected);

    if (list === newList) {
      return;
    }

    setList(newList);
  }, [selected]);

  const renderDisplay = () => {
    if (showSplashScreen) {
      return <img src={SplashScreen} className="splashScreen" />;
    }

    if (component) {
      const children = React.cloneElement(component, {
        ...component.props,
        onExit: component.props.onExit || (() => setComponent(null)),
      });
      return children;
    }

    if (showMenu) return <Menu onHome={() => setShowMenu(false)} />;
    if (showAck) return <Acknowledge />;
    if (showInfo) return <Info />;

    return <Home alert={alert} info={info} sensorError={sensorError} />;
  };

  const {t, i18n} = useTranslation();

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  const tabs = [
    {id: 1, name: 'Smart Meter Verification'},
    {id: 2, name: 'Configure Mass Flow Units'},
    {id: 3, name: 'Configure Channel C Output'},
    {id: 4, name: 'Configure Channel C Span'},
  ];

  const [tabName, setTabName] = useState('Smart Meter Verification');
  const [activeTab, setActiveTab] = useState({id: 1, name: 'Smart Meter Verification'});

  const handleTabClick = item => {
    setTabName(item.name);

    const active = tabs.find(x => x.id === item.id);
    setActiveTab(active);
  };

  return (
    <>
      <ValuesContextProvider>
        <CommandsContextProvider>
          <ConfigContextProvider>
            <MenuContext.Provider
              value={{
                selected,
                setSelected,
                setItems,
                setList,
                items,
                list,
                masterList,
                alert,
                showInfo,
                component,
                disableMenu,
                setDisableMenu,
                onComponent: cmp => setComponent(cmp),
                onShowMenu: setShowMenu,
                setShowAck,
                setShowInfo,
                setsensorError,
                showAck,
                showInfo,
                sensorError,
                info,
                setInfo,
              }}>
              <div className="container">
                <div className="topContent">
                  <div className="topHeader">
                    <span className="topTitle">
                      {t('menuTab.title')}
                    </span>
                    <div className="topLanguage">
                      <select
                        className="languageSelector"
                        onChange={e => i18n.changeLanguage(e.target.value)}
                        value={i18n.language}>
                        {languages.map((item, i) => (
                          <option value={item.code} key={i}>
                            {item.name.toUpperCase()}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="tabNav">
                    {tabs.map((item, i) => (
                      <div
                        key={item.id}
                        className={classNames('tabs', activeTab.name === item.name && 'activeTab')}
                        onClick={() => handleTabClick(item)}>
                        {item.name === 'Smart Meter Verification' ? t('menuTab.t1') : 
                          item.name === 'Configure Mass Flow Units' ? t('menuTab.t2') :
                          item.name === 'Configure Channel C Output' ? t('menuTab.t3') :
                          item.name === 'Configure Channel C Span' ? t('menuTab.t4') : item.name}
                        <div
                          className={classNames(
                            '',
                            activeTab.name === item.name && 'activeLine',
                          )}></div>
                      </div>
                    ))}
                  </div>
                  <div className="line"></div>
                </div>
                <div className="content">
                  <div className="tool-container">
                    <img className="tool-img" src={ToolImg5700} alt="5700 Tool" />
                    {showHelp && <ShowHelp />}
                    <Alert alert={alert} />
                    <div className="tool-screen">
                      <IdleTimerContainer />
                      {!showMenu && sensorError && <SensorFailed />}
                      {renderDisplay()}
                    </div>
                    <ArrowButton
                      onHome={() => setShowMenu(false)}
                      onHomeRight={() => setShowMenu(true)}
                      onExit={() => setComponent(null)}></ArrowButton>

                    {/* -----Translation Buttons----- */}

                    {/* <div className="button-left">
                      <button
                        className="btnleft"
                        title={'English'}
                        style={{fontWeight: i18n.language === 'en' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('en')}>
                        {t('home.eng_btn')}
                      </button>
                      <button
                        className="btnleft"
                        title={'Chinese'}
                        style={{fontWeight: i18n.language === 'ch' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('ch')}>
                        {t('home.chi_btn')}
                      </button>
                      <button
                        className="btnleft"
                        title={'Spanish'}
                        style={{fontWeight: i18n.language === 'sp' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('sp')}>
                        {t('home.spa_btn')}
                      </button>
                      <button
                        className="btnleft"
                        title={'German'}
                        style={{fontWeight: i18n.language === 'ge' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('ge')}>
                        {t('home.ger_btn')}
                      </button>
                      <button
                        className="btnleft"
                        title={'French'}
                        style={{fontWeight: i18n.language === 'fr' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('fr')}>
                        {t('home.fre_btn')}
                      </button>
                      <button
                        className="btnleft"
                        title={'Japanese'}
                        style={{fontWeight: i18n.language === 'ja' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('ja')}>
                        {t('home.jap_btn')}
                      </button>
                      <button
                        className="btnleft"
                        title={'Russian'}
                        style={{fontWeight: i18n.language === 'ru' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('ru')}>
                        {t('home.rus_btn')}
                      </button>
                      <button
                        className="btnleft"
                        title={'Portuguese'}
                        style={{fontWeight: i18n.language === 'po' ? 'bold' : 'normal'}}
                        onClick={() => i18n.changeLanguage('po')}>
                        {t('home.por_btn')}
                      </button>
                    </div> */}
                    {/* <div className="button-bottom">
                  <button onClick={handleResetDevice} className="btnbottom" title={'Reset Device'}>
                    {t('home.reset_btn')}
                  </button>
                  <button className="btnbottom" onClick={handleAlert}>
                    {alert ? 'Clear Alert' : t('home.alert_btn')}
                  </button>
                  <button onClick={handleShowHelp} className="btnbottom" title={'Show help'}>
                    {t('home.help_btn')}
                  </button>
                </div> */}
                  </div>
                  <div className="instuction-container">
                    <div className="filler"></div>
                    <div className="contents">
                      <div className="title-container">
                        {tabName === 'Smart Meter Verification' ? (
                          <h4 className="title">{t('menuTab.t1')}</h4>
                        ) : tabName === 'Configure Mass Flow Units' ? (
                          <h4 className="title">{t('menuTab.t2')}</h4>
                        ) : tabName === 'Configure Channel C Output' ? (
                          <h4 className="title">{t('menuTab.t3')}</h4>
                        ) : tabName === 'Configure Channel C Span' ? (
                          <h4 className="title">{t('menuTab.t4')}</h4>
                        ) : (
                          ''
                        )}
                      </div>
                      {tabName === 'Smart Meter Verification' ? (
                        <div className="bodyContent">
                          <span className="bodyCaption">{t('menuTab.d1.smvo1')}</span>
                          <span className="bodyCaption">{t('menuTab.d1.smvo2')}</span>
                          <span className="bodyCaption">{t('menuTab.d1.smvo3')}</span>
                          <span className="bodyCaption">{t('menuTab.d1.smvo4')}</span>
                          <span className="bodyCaption">{t('menuTab.d1.smvo5')}</span>
                          <span className="bodyCaption">{t('menuTab.d1.smvo6')}</span>
                        </div>
                      ) : tabName === 'Configure Mass Flow Units' ? (
                        <div className="bodyContent">
                          <span className="bodyCaption">{t('menuTab.d2.smvo1')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo2')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo3')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo4')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo5')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo6')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo7')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo8')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo9')}</span>
                          <span className="bodyCaption">{t('menuTab.d2.smvo10')}</span>
                        </div>
                      ) : tabName === 'Configure Channel C Output' ? (
                        <div className="bodyContent">
                          <span className="bodyCaption">{t('menuTab.d3.smvo1')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo2')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo3')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo4')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo5')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo6')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo7')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo8')}</span>
                          <span className="bodyCaption">{t('menuTab.d3.smvo9')}</span>
                        </div>
                      ) : tabName === 'Configure Channel C Span' ? (
                        <div className="bodyContent">
                          <span className="bodyCaption">{t('menuTab.d4.smvo1')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo2')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo3')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo4')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo5')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo6')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo7')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo8')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo9')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo10')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo11')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo12')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo13')}</span>
                          <span className="bodyCaption">{t('menuTab.d4.smvo14')}</span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </MenuContext.Provider>
          </ConfigContextProvider>
        </CommandsContextProvider>
      </ValuesContextProvider>
    </>
  );
}

export default App;
